/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";

import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";
import Table4 from "../../../region/pages/oqjar/Table4";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";
import {
  formatDisplayDate,
  getDateColumnsInRange,
  getDefaultRange,
  getMonthRange,
  getMonthsInRange,
  isValidRange,
  normalizeRangeRows,
} from "../../../region/pages/ravotxoji/rangeHelpers";

const createEmptyOqjarRow = (column) => ({
  sana: column.date,
});

const normalizeOqjarMonthRows = (month, rows) => {
  const monthRange = getMonthRange(month);

  if (!monthRange) {
    return rows || [];
  }

  const columns = getDateColumnsInRange(monthRange.from, monthRange.to);

  return normalizeRangeRows(
    { [month]: rows || [] },
    columns,
    createEmptyOqjarRow
  );
};

const Oqjar = () => {
  const defaultRange = getDefaultRange();
  const [toggle, setToggle] = useState(1);

  const tabs = [
    { title: "Oraliq", id: 1, type: "text" },
    { title: "Oylik", id: 2, type: "text" },
    { title: "Sxema", id: 3, type: "text" },
  ];

  const [data, setData] = useState([]);
  const [rangeData, setRangeData] = useState([]);
  const [schema, setSchema] = useState([]);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [range, setRange] = useState(defaultRange);
  const [localRange, setLocalRange] = useState(defaultRange);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [indexRes, schemaRes] = await Promise.all([
          axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/republik/oqjar/index?month=${month}`,
            header()
          ),
          axios.get(
            `${
              getEnv('REACT_APP_BASE_URL')
            }/v1/republik/oqjar/schema?date=${date.split("-").join("")}`,
            header()
          ),
        ]);

        if (!indexRes.data) {
          console.warn("Index ma'lumot topilmadi");
          setData([]);
        } else {
          setData(normalizeOqjarMonthRows(month, indexRes.data));
        }

        console.log(schemaRes);
        

        if (!schemaRes.data) {
          console.warn("Schema ma'lumot topilmadi");
          setSchema([]);
        } else {
          setSchema(schemaRes.data);
        }
      } catch (e) {
        console.error("Xato", e);
        alert("Server bilan bog'lanishda xato!");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [month, date]);

  useEffect(() => {
    if (toggle !== 1) {
      return;
    }

    if (!isValidRange(range)) {
      setRangeData([]);
      return;
    }

    const fetchRangeData = async () => {
      setLoading(true);
      const columns = getDateColumnsInRange(range.from, range.to);
      const months = getMonthsInRange(range.from, range.to);

      try {
        const responses = await Promise.all(
          months.map((rangeMonth) =>
            axios.get(
              getEnv('REACT_APP_BASE_URL') +
                "/v1/republik/oqjar/index?month=" +
                rangeMonth,
              header()
            )
          )
        );
        const monthlyData = {};
        months.forEach((rangeMonth, index) => {
          monthlyData[rangeMonth] = responses[index]?.data || [];
        });
        setRangeData(
          normalizeRangeRows(monthlyData, columns, createEmptyOqjarRow)
        );
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
        setRangeData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRangeData();
  }, [range, toggle]);

  const applyRange = () => {
    if (!isValidRange(localRange)) {
      alert("Sana oralig'ini to'g'ri kiriting!");
      return;
    }

    setRange(localRange);
  };

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left suv-omborlari' style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {/* TUZATILDI: Rejimga qarab (oylik/kunlik) dinamik o'zgaruvchi sarlavha */}
          <li style={{ fontWeight: "600", fontSize: "16px", whiteSpace: "nowrap" }}>
            Oqjar va Qizilqishloq G/P ko'rsatkichlari (m<sup>3</sup>/s)
            <span style={{ color: "#7e8299", fontSize: "13px", marginLeft: "8px", fontWeight: "400" }}>
        {toggle === 1 ? (
          <>({formatDisplayDate(range.from)} - {formatDisplayDate(range.to)})</>
        ) : toggle === 2 ? (
          <>({month ? month.split("-").reverse().join(".") : ""} oyi uchun)</>
        ) : (
            <>({date ? date.split("-").reverse().join(".") : ""} kun holatiga)</>
        )}
      </span>
          </li>
          <div>
            <Tabs
                toggle={toggle}
                setToggle={setToggle}
                tabs={tabs}
                date={date}
            />
          </div>
        </ul>

        <ul className='content-top-right'>
          {toggle === 1 ? (
            <>
              <span className='text-muted small mr-2'>Dan</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.from}
                onChange={(e) =>
                  setLocalRange({ ...localRange, from: e.target.value })
                }
              />
              &nbsp;&nbsp;
              <span className='text-muted small mr-2'>Gacha</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.to}
                onChange={(e) =>
                  setLocalRange({ ...localRange, to: e.target.value })
                }
              />
              &nbsp;&nbsp;&nbsp;
              <button
                className='btn btn-outline-primary btn-sm'
                onClick={applyRange}>
                Ok
              </button>
            </>
          ) : toggle === 2 ? (
            <input
              type='month'
              className='form-control form-control-sm'
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            />
          ) : (
            <input
              type='date'
              className='form-control form-control-sm'
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          )}
        </ul>
      </ContentTop>

      <div className="tabs-content table-box">
        <div className="tabs-content-item active">
          {toggle !== 3 ? (
            loading ? (
              <LoadingCard loading={loading} heightSize='80vh' />
            ) : (
              <Table4
                    isRange={toggle === 1}
                month={toggle === 2 ? month : range.from.slice(0, 7)}
                data={toggle === 2 ? data : rangeData}
              />
            )
          ) : (
            <div className="card statistic-card w-100">
              <div className="container-fluid oqjar-sxema">
                <div className="oqjar-svg">
                  <svg
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="100%"
                    height="402"
                    viewBox="0 0 1920 1080"
                    xmlSpace="preserve"
                    enableBackground="new 0 0 1920 1080"
                  >
                    <style>
                      {
                        ".st0{fill:#7ea641;stroke:#0c0;stroke-miterlimit:10}.st1{fill:#4457a6}.st2{fill:none;stroke:#000;stroke-miterlimit:10}.st3{font-family:&apos;Poppins-SemiBold&apos;}.st5{fill:#2e3192}.st6{font-family:&apos;Poppins-Regular&apos;}.st9{font-size:15.8962px}.st10{font-size:9.2675px}.st11{fill:#fff}.st15{font-family:&apos;Poppins-Medium&apos;}.st18{fill:none;stroke:#000;stroke-width:.25;stroke-miterlimit:10}.st19{font-size:21.1992px}.st20,.st21,.st24{fill:#ef4136}.st21,.st24{opacity:.39;enable-background:new}.st24{opacity:.29;fill:#fff200;stroke:#000;stroke-miterlimit:10}.st25{fill:#262262}.st26{font-size:46.9003px}.st29{font-size:18.3151px}.st35{opacity:.4;fill:#537898;enable-background:new}.st37{fill:#40536c}.st38{fill:#475d76}.st41{opacity:.5}.st42{fill:#eaf4fc}.st44{fill:#cbe5f7}.st57{opacity:.25}.st64{fill:#f2f7f7}.st184,.st93{opacity:.25;fill:#a7c1d5;enable-background:new}.st184{opacity:.4;fill:#c1dadd}.st185{fill:#e4eaea}.st186{fill:#c1dadd}.st217{fill:#eff4f4}.st222{fill:#576e82}.st224{fill:#dee8f0}.st225{fill:#a7c1d5}.st230{opacity:.5;enable-background:new}.st230,.st231,.st232{fill:#a5b8bf}.st232{opacity:.25;enable-background:new}.st235{fill:#4d6380}.st250{fill:#979e38}.st251{opacity:.25;enable-background:new}.st251,.st252{fill:#717832}.st253{fill:#a6a938}.st255,.st257{opacity:.5;fill:#814262;enable-background:new}.st257{fill:#bbddf5}.st260{font-family:&apos;Poppins-MediumItalic&apos;}.st263{font-size:22.4204px}.st264{font-family:&apos;Poppins-SemiBoldItalic&apos;}.st269{fill:#fff;stroke:#000;stroke-miterlimit:10}.st276{font-size:20.7241px}.st281{font-size:20.419px}.st285{fill:none;stroke:#4457a6;stroke-width:10;stroke-miterlimit:10}.st287{font-size:19.6687px}.st292{font-size:20.474px}"
                      }
                    </style>
                    <path
                      className="st0"
                      d="M898.5 996.3h-.8v-2.7h.8v2.7zm0-14.7h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm22-12.5h-.3c-3.8 0-7.7-.1-11.7-.2v-.7c4 .2 7.9.2 11.6.2h.3v.7h.1zm12-.3v-.7c4.1-.2 8.1-.5 11.9-.9l.1.7c-3.9.4-7.9.7-12 .9zm23.8-2.6l-.1-.7c4-.7 8-1.6 11.7-2.6l.2.7c-3.8 1-7.7 1.9-11.8 2.6zm23.2-6.3l-.3-.7c3.8-1.5 7.5-3.1 10.9-4.9l.4.7c-3.5 1.8-7.2 3.4-11 4.9zm21.1-11.4l-.4-.6c3.2-2.4 6.2-5.1 8.9-7.9l.5.5c-2.7 2.9-5.7 5.6-9 8zm16.3-17.6l-.6-.4c2.1-3.4 3.8-7 5.1-10.8l.7.2c-1.4 3.9-3.1 7.5-5.2 11zm7.7-22.7l-.7-.1c.1-1.1.1-1.8.1-2.1V392.2h.8v9.9c-.1.3-.1 1-.2 2.1zm.1-24.1h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12zm0-24h-.8v-12h.8v12z"
                    />
                    <path
                      className="st0"
                      d="M898.7 996.3h-1v-2.7h1v2.7zm0-14.7h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm21.8-12.4h-.3c-3.8 0-7.7-.1-11.7-.2v-1c4 .2 7.9.2 11.6.2h.3v1h.1zm12-.3v-1c4.1-.2 8.1-.5 11.9-.9l.1 1c-3.9.4-7.9.7-12 .9zm23.8-2.6l-.2-1c4-.7 8-1.6 11.7-2.6l.3 1c-3.7 1-7.7 1.9-11.8 2.6zm23.2-6.3l-.4-.9c3.8-1.5 7.5-3.1 10.9-4.9l.5.9c-3.4 1.8-7.1 3.5-11 4.9zm21.2-11.4l-.6-.8c3.2-2.4 6.2-5.1 8.8-7.9l.7.7c-2.6 2.9-5.6 5.6-8.9 8zM1017 427l-.9-.5c2.1-3.4 3.8-7 5.1-10.7l.9.3c-1.3 3.7-3 7.4-5.1 10.9zm7.7-22.8l-1-.1c.1-1.1.1-1.8.1-2.1V392.2h1v9.9c0 .3 0 1-.1 2.1zm.1-24.1h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12zm0-24h-1v-12h1v12z"
                    />
                    <path className="st1" d="M25.5 470.3H1888V490.8H25.5z" />
                    <path
                      className="st1"
                      d="M1467.6 553.6h-128.5c-26.5 0-48.2-21.5-48.2-48.2V450c0-26.5 21.5-48.2 48.2-48.2h128.3c26.5 0 48.2 21.5 48.2 48.2v55.4c.1 26.5-21.5 48.2-48 48.2z"
                    />
                    <path
                      className="st2"
                      d="M692.8 877H525.5c-2.5 0-4.5-2-4.5-4.5v-67.7c0-2.5 2-4.5 4.5-4.5h167.3c2.5 0 4.5 2 4.5 4.5v67.7c0 2.5-1.9 4.5-4.5 4.5z"
                    />
                    <text
                      transform="translate(528.661 829.106)"
                      className="st3"
                      fontSize="23.8442px"
                    >
                      {"Bekobod"}
                    </text>
                    <text
                      transform="translate(600.145 865.043)"
                      className="st5 st6"
                      fontSize="19.0754px"
                    >
                      {`${schema?.bekobod1 ? schema?.bekobod1 : "0"} m\u00B3/s`}
                    </text>

                    <text
                      transform="translate(1317.204 517.148)"
                      className="st11 st3"
                      fontSize="14.9295px"
                    >
                      {"Bahri Tojik Suv Ombori"}
                    </text>
                    <path
                      d="M912.6 517.1c-20.7 20.7-54.1 20.7-74.7 0-20.7-20.7-20.7-54.1 0-74.7 20.7-20.7 54.1-20.7 74.7 0 20.7 20.6 20.7 54.1 0 74.7z"
                      fill="#ddd3c5"
                    />
                    <path
                      d="M1387.3 853.2c-8 8-20.9 8-28.9 0s-8-20.9 0-28.9 20.9-8 28.9 0c8.1 7.9 8.1 20.9 0 28.9z"
                      fill="#c6baab"
                    />
                    <text
                      transform="translate(854.33 450.647)"
                      className="st15"
                      fontSize="12.8575px"
                    >
                      {"Farxod"}
                    </text>
                    <text
                      transform="translate(865.069 467.087)"
                      className="st15"
                      fontSize="11.5846px"
                    >
                      {"G/u"}
                    </text>
                    {/* <path d='M1183.3 459.7H1252V461.8H1183.3z' />
                    <path d='M1177.1 460.7L1184 464.6 1184 456.7z' /> */}
                    <path
                      transform="rotate(-8.332 433.24 549.662)"
                      d="M431.8 525.2H434.7V574.1H431.8z"
                    />
                    <path d="M428.7 518L435.2 525.6 424.4 527.1z" />
                    <path
                      transform="rotate(-31.306 539.677 527.206)"
                      d="M510.7 525.7H568.7V528.7H510.7z"
                    />
                    <path d="M507.3 546.9L512.9 537 518.8 546.7z" />
                    {/* <text
                      transform='translate(1554.546 452.629)'
                      className='st5 st6 st9'>
                      {`${
                        data[Number(date.slice(8, 10)) - 1]?.kz1
                          ? data[Number(date.slice(8, 10)) - 1].kz1
                          : "0"
                      } m\u00B3/s`}
                    </text> */}
                    {/* <path d='M1542.9 459.8H1611.6000000000001V461.90000000000003H1542.9z' />
                    <path d='M1536.7 460.9L1543.6 464.8 1543.6 456.9z' />
                    <path d='M1244.4 530.5c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z' /> */}
                    <circle className="st18" cx={1235.9} cy={530.5} r={8.4} />
                    <path d="M1234.8 503.6H1237V522H1234.8z" />
                    <path d="M1224.7 530.5c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1216.3} cy={530.5} r={8.4} />
                    <path d="M1215.1 503.6H1217.3V522H1215.1z" />
                    <path d="M1205.2 530.5c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1196.7} cy={530.5} r={8.4} />
                    <path d="M1195.6 503.6H1197.8V522H1195.6z" />
                    <ellipse cx={1217.4} cy={500.8} rx={32.7} ry={5.5} />
                    <path d="M1099.1 528.5c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1090.7} cy={528.5} r={8.4} />
                    <path d="M1089.5 501.7H1091.7V520.1H1089.5z" />
                    <ellipse cx={1090.6} cy={498.7} rx={19.9} ry={3.3} />
                    <path d="M811.3 637.3c0 6-4.8 10.8-10.8 10.8s-10.8-4.8-10.8-10.8h21.6z" />
                    <circle className="st18" cx={800.5} cy={637.3} r={10.8} />
                    <path d="M799 602.7H801.9V626.3000000000001H799z" />
                    <ellipse cx={800.4} cy={598.8} rx={25.5} ry={4.3} />
                    <path d="M1048.1 431.7c0-4.7-3.7-8.4-8.4-8.4s-8.4 3.7-8.4 8.4h16.8z" />
                    <circle className="st18" cx={1039.7} cy={431.7} r={8.4} />
                    <path d="M1038.5 440.2H1040.7V458.59999999999997H1038.5z" />
                    <ellipse cx={1039.6} cy={461.6} rx={19.9} ry={3.3} />
                    <path d="M1700.8 530.6c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1692.4} cy={530.6} r={8.4} />
                    <path d="M1691.2 503.8H1693.4V522.2H1691.2z" />
                    <path d="M1457.4 580.4c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1449} cy={580.4} r={8.4} />
                    <path d="M1447.9 553.6H1450.1000000000001V572H1447.9z" />
                    <path d="M1435 580.4c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1426.6} cy={580.4} r={8.4} />
                    <path d="M1425.4 553.6H1427.6000000000001V572H1425.4z" />
                    <path d="M1412.2 580.4c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1403.8} cy={580.4} r={8.4} />
                    <path d="M1402.6 553.6H1404.8V572H1402.6z" />
                    <path d="M1389.4 580.4c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1380.9} cy={580.4} r={8.4} />
                    <path d="M1379.8 553.6H1382V572H1379.8z" />
                    <path d="M1366.6 580.4c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1358.1} cy={580.4} r={8.4} />
                    <path d="M1357 553.6H1359.2V572H1357z" />
                    <path d="M1681.3 530.6c0 4.7-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4h16.8z" />
                    <circle className="st18" cx={1672.8} cy={530.6} r={8.4} />
                    <path d="M1671.7 503.8H1673.9V522.2H1671.7z" />
                    <ellipse cx={1682.6} cy={501} rx={21.9} ry={5.5} />
                    <text
                      transform="translate(722.298 709.355)"
                      className="st3 st19"
                    >
                      {"Zafarobod"}
                    </text>
                    <text
                      transform="translate(722.298 742.27)"
                      className="st15 st19"
                    >
                      {"N/S"}
                    </text>
                    <path
                      className="st2"
                      d="M882.2 759.6h-162c-3.3 0-6.1-2.8-6.1-6.1v-63.8c0-3.3 2.8-6.1 6.1-6.1h162c3.3 0 6.1 2.8 6.1 6.1v63.6c0 3.5-2.6 6.3-6.1 6.3z"
                    />
                    <path
                      className="st20"
                      d="M1143.8 427.6L1143.8 443.7 1124.8 443.7 1124.8 460.7 1122.9 460.7 1122.9 427.6z"
                    />
                    <ellipse
                      className="st21"
                      cx={1123.6}
                      cy={460.3}
                      rx={26.1}
                      ry={5.5}
                    />
                    <path
                      className="st20"
                      d="M1079.2 383.4H1081.6000000000001V460.79999999999995H1079.2z"
                    />
                    <path
                      className="st21"
                      d="M1098 459.8v.4c0 .4-.1.5-.4.5h-18.2v-1.5h18.2c.3.1.4.3.4.6z"
                    />
                    <text
                      transform="translate(805.446 753.307)"
                      className="st5 st6"
                      fontSize="20.7897px"
                    >
                      {`${schema?.ns ? schema?.ns : "0"} m\u00B3/s`}
                    </text>
                    <path
                      className="st20"
                      d="M755.2 320.3H758.3000000000001V458.3H755.2z"
                    />
                    <path
                      className="st20"
                      d="M956.2 321.2H959.3000000000001V459.2H956.2z"
                    />
                    <path
                      className="st21"
                      d="M756 457v.5c0 .5.4.8 1.3.8h69.6l1.1-2.3-70.7.2c-.9 0-1.3.2-1.3.8zM957.7 457.9v.5c0 .5-.2.8-.7.8l-33.2-.1-1-2.1h34.1c.6 0 .8.3.8.9z"
                    />
                    <path
                      className="st20"
                      d="M599.2 609.3H602.3000000000001V682.6999999999999H599.2z"
                    />
                    <path
                      className="st21"
                      d="M602.3 680.8v.8c0 .8-.2 1.2-.7 1.2h-36.4v-3.1h36.4c.5 0 .7.4.7 1.1z"
                    />
                    <path d="M448.1 663.5v.9c0 .9-.6 1.4-1.9 1.4h-99V662h99c1.3.1 1.9.6 1.9 1.5z" />
                    <path
                      className="st20"
                      d="M1027.6 527.9L1013.6 536 1011.7 536 1011.7 502.8 1013.6 502.8 1013.6 519.8 1013.6 519.8z"
                    />
                    <ellipse
                      className="st21"
                      cx={1012.4}
                      cy={503.2}
                      rx={26.1}
                      ry={5.5}
                    />
                    <path
                      className="st20"
                      d="M555.4 656.7L541.4 648.6 539.5 648.6 539.5 681.8 541.4 681.8 541.4 664.8 541.4 664.8z"
                    />
                    <ellipse
                      className="st21"
                      cx={540.2}
                      cy={681.4}
                      rx={26.1}
                      ry={5.5}
                    />
                    <path
                      className="st20"
                      d="M1110 954.4L1093.9 945.1 1091.7 945.1 1091.7 983.3 1093.9 983.3 1093.9 963.6 1093.9 963.6z"
                    />
                    <ellipse
                      className="st21"
                      cx={1092.5}
                      cy={982.7}
                      rx={30}
                      ry={6.3}
                    />
                    <path className="st20" d="M968 502.3H971.2V580.7H968z" />
                    <path
                      className="st21"
                      d="M986.8 503.5v-.5c0-.5-.1-.7-.4-.7h-18.2v2h18.2c.3-.1.4-.3.4-.8z"
                    />
                    <path d="M863.5 597.4H865.7V683.1H863.5z" />
                    <path d="M810.2 599v-.7c0-.7.3-1 1-1h54.5v2.6h-54.5c-.7.1-1-.2-1-.9zM1710.7 431.1c0-4.7-3.7-8.4-8.4-8.4s-8.4 3.7-8.4 8.4h16.8z" />
                    <circle className="st18" cx={1702.2} cy={431.1} r={8.4} />
                    <path d="M1701.2 439.5H1703.4V457.9H1701.2z" />
                    <path d="M1691.1 431.1c0-4.7-3.7-8.4-8.4-8.4s-8.4 3.7-8.4 8.4h16.8z" />
                    <circle className="st18" cx={1682.7} cy={431.1} r={8.4} />
                    <path d="M1681.5 439.5H1683.7V457.9H1681.5z" />
                    <path d="M1671.5 431.1c0-4.7-3.7-8.4-8.4-8.4s-8.4 3.7-8.4 8.4h16.8z" />
                    <circle className="st18" cx={1663} cy={431.1} r={8.4} />
                    <path d="M1662 439.5H1664.2V457.9H1662z" />
                    <ellipse cx={1683.6} cy={460.6} rx={32.7} ry={5.5} />
                    <path
                      className="st20"
                      d="M1113.9 817L1113.9 833.3 1094.7 833.3 1094.7 850.3 1092.9 850.3 1092.9 817z"
                    />
                    <ellipse
                      className="st21"
                      cx={1093.6}
                      cy={848.3}
                      rx={26.2}
                      ry={5.4}
                    />
                    <path
                      className="st20"
                      d="M1841.2 429.1L1841.2 445.2 1822.1 445.2 1822.1 462.3 1820.4 462.3 1820.4 429.1z"
                    />
                    <ellipse
                      className="st21"
                      cx={1821}
                      cy={460.2}
                      rx={26.1}
                      ry={5.5}
                    />
                    <path
                      className="st20"
                      d="M1776.5 383H1779.4V461.2H1776.5z"
                    />
                    <path
                      className="st21"
                      d="M1795.9 459.9v.5c0 .5-.1.8-.4.8h-18.2V459h18.2c.2.1.4.4.4.9z"
                    />
                    <path className="st24" d="M119 50H467.5V122.8H119z" />
                    <text
                      transform="translate(142.685 102.981)"
                      className="st25 st3 st26"
                    >
                      {"O\u2018zbekiston"}
                    </text>
                    <path
                      className="st24"
                      d="M1545.3 45.8H1828.5V120.39999999999999H1545.3z"
                    />
                    <text
                      transform="translate(1573.587 95.263)"
                      className="st25 st3 st26"
                    >
                      {"Tojikiston"}
                    </text>
                    <text
                      transform="translate(1061.648 787.775)"
                      className="st15"
                      fontSize="23.5512px"
                      opacity={0.6}
                      enableBackground="new"
                    >
                      {"Shartli belgilar"}
                    </text>
                    <text
                      transform="translate(1139.598 844.714)"
                      className="st6 st29"
                    >
                      {"Suv o\u2019lchash posti"}
                    </text>
                    <text
                      transform="translate(1139.232 913.433)"
                      className="st6 st29"
                    >
                      {"Nasos stansiya"}
                    </text>
                    <text
                      transform="translate(1140.64 983.27)"
                      className="st6 st29"
                    >
                      {"Reyka"}
                    </text>
                    <text
                      transform="translate(1426.178 843.58)"
                      className="st6 st29"
                    >
                      {"Gidrouzel"}
                    </text>
                    <text
                      transform="translate(1426.178 908.011)"
                      className="st6 st29"
                    >
                      {"Daryo"}
                    </text>
                    <text
                      transform="translate(1668.88 843.324)"
                      className="st6 st29"
                    >
                      {"Kanal"}
                    </text>
                    <text
                      transform="translate(1668.88 908.011)"
                      className="st6 st29"
                    >
                      {"Davlat chegarasi"}
                    </text>
                    <text
                      transform="translate(1426.178 975.472)"
                      className="st6 st29"
                    >
                      {"Gidroelektrostansiya"}
                    </text>
                    <path
                      className="st2"
                      d="M1040.2 755.4H1855.5V1008.9H1040.2z"
                    />
                    <path d="M1103.4 894c0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5h17z" />
                    <circle className="st2" cx={1094.9} cy={894} r={8.5} />
                    <path d="M1093.8 902.5H1096.1V920.9H1093.8z" />
                    <path
                      className="st1"
                      d="M1581.9 832.5H1652.1000000000001V844.8H1581.9z"
                    />
                    <path
                      className="st1"
                      d="M1337.8 889.4H1408V914.9H1337.8z"
                    />
                    <path
                      d="M1651.6 904.9h-11.1v-2.8h11.1v2.8zm-22 0h-11.2v-2.8h11.2v2.8zm-22.1 0h-11.2v-2.8h11.2v2.8zm-22.1 0h-11.2v-2.8h11.2v2.8zm-22.2 0H1552v-2.8h11.2v2.8z"
                      fill="#7ea641"
                    />
                    <linearGradient
                      id="SVGID_1_"
                      gradientUnits="userSpaceOnUse"
                      x1={1333.5}
                      y1={444.6}
                      x2={1333.5}
                      y2={433.5361}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#d7e7e6" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_1_)"
                      d="M1325.9 433.5H1341.1000000000001V444.6H1325.9z"
                    />
                    <linearGradient
                      id="SVGID_00000088103434126775270080000011852829062291734966_"
                      gradientUnits="userSpaceOnUse"
                      x1={1320.3143}
                      y1={483.2147}
                      x2={1330.6003}
                      y2={453.7169}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#d7e7e6" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_00000088103434126775270080000011852829062291734966_)"
                      d="M1325.2 491.8L1310 491.8 1325.9 444.6 1341.3 444.6z"
                    />
                    <linearGradient
                      id="SVGID_00000168818118456898708720000010357225533888716174_"
                      gradientUnits="userSpaceOnUse"
                      x1={1325.2705}
                      y1={468.2}
                      x2={1347.7126}
                      y2={468.2}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#b6c5c7" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_00000168818118456898708720000010357225533888716174_)"
                      d="M1347.7 444.6L1347.7 491.8 1325.2 491.8 1326.2 489.3 1341.3 444.6z"
                    />
                    <linearGradient
                      id="SVGID_00000137133920268234751890000017749240297550470575_"
                      gradientUnits="userSpaceOnUse"
                      x1={1341.2584}
                      y1={439.05}
                      x2={1347.7332}
                      y2={439.05}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#b6c5c7" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_00000137133920268234751890000017749240297550470575_)"
                      d="M1341.3 433.5H1347.7V444.6H1341.3z"
                    />
                    <path
                      className="st11"
                      d="M1327.8 461.9c-.8 1.8-1.9 2.7-3 2.8l-.5 1.1c1.8-.1 3.6-1.5 4.7-3.9h-1.2zm-.1-4.8l-.5 1.1c1.2.1 1.5 1.2.8 3.2h1.2c1.1-2.6.4-4.2-1.5-4.3zm-5.4 4.2h1.2c.8-2 2-3 3.3-3.2l.5-1.1c-2.1.2-3.9 1.8-5 4.3zm1.1.6h-1.2c-.7 2.3 0 3.7 1.8 3.9l.5-1.1c-1.2-.1-1.7-1-1.1-2.8zM1331.7 461.9l-1.5 3.9h1.2l1.5-3.9h-1.2zm-.1-4.8l-.5 1.1h2l-1.2 3.2h1.2l1.6-4.2h-3.1v-.1z"
                    />
                    <path
                      className="st35"
                      d="M1344.9 468.3c0-.1-.1-.1 0 0 .7-3.4 1.3-6.1 1.8-7.9h.1v.1c-.5 1.8-1.2 4.5-1.9 7.8 0-.1 0 0 0 0z"
                    />
                    <linearGradient
                      id="SVGID_00000161611704209806620720000016050739746798841221_"
                      gradientUnits="userSpaceOnUse"
                      x1={1361.15}
                      y1={451.9313}
                      x2={1361.15}
                      y2={444.6046}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#d7e7e6" />
                    </linearGradient>
                    <path
                      d="M1374.5 444.6l-.4 1.1H1355c-1.6 0-3 1.4-3 3v1.5c-1.5.4-2.9.9-4.2 1.6v-7.4h26.7v.2z"
                      fill="url(#SVGID_00000161611704209806620720000016050739746798841221_)"
                    />
                    <path
                      className="st37"
                      d="M1374.1 445.7l-2.8 8.1H1352v-5c0-1.6 1.4-3 3-3h19.1v-.1z"
                    />
                    <path
                      className="st37"
                      d="M1373.8 445.7l-.1.5-2.6 7.5h-14.8v-5c0-1.6 1.4-3 3-3h14.5z"
                    />
                    <path
                      className="st38"
                      d="M1373.5 446.3l-2.7 8.1h-11.1v-5c0-1.6 1.4-3 3-3h10.8v-.1z"
                    />
                    <linearGradient
                      id="SVGID_00000067222623068864543700000014935179247098815421_"
                      gradientUnits="userSpaceOnUse"
                      x1={1352.6499}
                      y1={491.8412}
                      x2={1352.6499}
                      y2={449.8412}
                    >
                      <stop offset={0} stopColor="#79aace" />
                      <stop offset={0.5838} stopColor="#95c9ed" />
                      <stop offset={0.7626} stopColor="#c9e5f8" />
                      <stop offset={0.8631} stopColor="#aedaf5" />
                      <stop offset={1} stopColor="#9cd0f1" />
                    </linearGradient>
                    <path
                      d="M1372.6 449.9l-11.9 34.8-.9 2.7-.6 1.9-.8 2.6h-25.7c0-.8 0-1.6.1-2.6.1-.9.2-1.9.4-2.9.5-2.5 1.1-5.1 1.9-7.7 1.9-6.4 4.4-12.9 6.1-18.1 1.2-3.7 3.6-6.8 6.9-8.6 1.3-.8 2.7-1.3 4.2-1.6 1.2-.2 2.3-.4 3.5-.4l16.8-.1z"
                      fill="url(#SVGID_00000067222623068864543700000014935179247098815421_)"
                    />
                    <linearGradient
                      id="SVGID_00000106847769915920619700000016174149894419434377_"
                      gradientUnits="userSpaceOnUse"
                      x1={1332.4102}
                      y1={470.9}
                      x2={1372.5593}
                      y2={470.9}
                    >
                      <stop offset={0} stopColor="#fff" />
                      <stop offset={0.1981} stopColor="#fafbfd" />
                      <stop offset={0.3376} stopColor="#eff1f8" />
                      <stop offset={0.4591} stopColor="#dfe4f1" />
                      <stop offset={0.5703} stopColor="#c9d2e7" />
                      <stop offset={0.6746} stopColor="#aebedc" />
                      <stop offset={0.7737} stopColor="#8fa6d0" />
                      <stop offset={0.8686} stopColor="#6b8fc2" />
                      <stop offset={0.958} stopColor="#3d78b4" />
                      <stop offset={1} stopColor="#166eae" />
                    </linearGradient>
                    <path
                      d="M1372.6 449.9l-11.9 34.8-.9 2.7-.6 1.9-.8 2.6h-25.7c0-.8 0-1.6.1-2.6.1-.9.2-1.9.4-2.9.5-2.5 1.1-5.1 1.9-7.7 1.9-6.4 4.4-12.9 6.1-18.1 1.2-3.7 3.6-6.8 6.9-8.6 1.3-.8 2.7-1.3 4.2-1.6 1.2-.2 2.3-.4 3.5-.4l16.8-.1z"
                      opacity={0.4}
                      fill="url(#SVGID_00000106847769915920619700000016174149894419434377_)"
                      enableBackground="new"
                    />
                    <g className="st41">
                      <path
                        className="st42"
                        d="M1334.7 488.5c.4-3 .9-6 1.5-8.9h.1v.1c-.5 2.8-1.1 5.7-1.6 8.8.1 0 0 0 0 0zM1356.6 488.5c-.1 0-.1 0 0 0 .4-3 .9-6 1.5-8.9h.1v.1c-.7 2.8-1.2 5.7-1.6 8.8zM1337.8 473.7c-.2 0-.2 0 0 0 .7-3 1.6-6 2.7-9.4h.1v.1c-1.2 3.4-2 6.4-2.8 9.3zM1360 473.7s-.2 0 0 0c.7-3 1.6-6 2.7-9.4h.1v.1c-1.1 3.4-2 6.4-2.8 9.3zM1342 460c0-.1 0-.1 0 0l.2-.8c.8-2.5 2.5-4.4 4.8-6 1.1-.7 2.3-1.2 3.6-1.5 1.3-.4 2.6-.6 4-.6 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.7 0-10.6 3.2-12.3 7.9l-.3.8c.1-.1.1 0 0 0zM1363.6 460c-.1-.1-.1-.1 0 0l.2-.8c1.1-3 3.4-5.4 6.5-6.8h.1v.1c-3.2 1.4-5.5 3.7-6.5 6.8l-.3.7c0-.1 0 0 0 0zM1345.8 488.5s-.1 0 0 0c0-.1.5-2.7 1.2-6.3h.1v.1c-.7 3.5-1.3 6-1.3 6.2zM1348.5 474.2c1.2-6.2 2.1-10.6 2.7-13.4h.1v.1c-.6 2.7-1.5 7.2-2.8 13.3.1 0 .1 0 0 0zM1354.9 454.3c0-.1 0-.1 0 0 1.5-1.3 3.2-1.9 4.3-2.2 1.3-.4 2.1-.5 2.1-.5h.1v.1s-.9.1-2.1.5c-1.1.3-2.8 1-4.4 2.1z"
                      />
                      <path
                        className="st35"
                        d="M1350.1 490c-.1 0-.1 0 0 0 .1-1.4 1.1-5.5 2.7-12.4h.1v.1c-1.6 6.8-2.5 11-2.8 12.3zM1354.7 469.6s0-.1 0 0c.4-1.8.7-3.5 1.2-5.4h.1v.1c-.4 1.8-.8 3.6-1.3 5.3.1 0 0 0 0 0zM1357.2 459.2c.5-1.6 1.2-3 2.1-4.1.8-.9 1.6-1.6 2.7-2.2 1.8-.9 3.2-1.1 3.3-1.1h.1v.1s-1.5.1-3.2 1.1c-1.7.9-3.8 2.7-5 6.2.1 0 .1 0 0 0zM1340.4 490c0-.7.4-2 .6-3.7h.1v.1c-.2 1.6-.4 2.9-.7 3.6.2 0 0 0 0 0zM1342.4 480.3c-.1 0-.1 0 0 0 .4-1.9.7-3.6 1.1-5.4h.1v.1c-.5 1.6-.8 3.5-1.2 5.3z"
                      />
                    </g>
                    <linearGradient
                      id="SVGID_00000110469050448546575110000002523826992775102885_"
                      gradientUnits="userSpaceOnUse"
                      x1={1346.65}
                      y1={491.8637}
                      x2={1346.65}
                      y2={482.6936}
                    >
                      <stop offset={0} stopColor="#b8ddf5" />
                      <stop offset={0.6005} stopColor="#d8edfa" />
                      <stop offset={1} stopColor="#e7f6fd" />
                    </linearGradient>
                    <path
                      d="M1362.4 491.5v.4h-30.6c-.6-.6-.9-1.4-.9-2.5v-.1c0-1.4.9-2.7 2.1-2.9h.5c.5 0 .9.1 1.3.4.1-.1.1-.4.2-.5.6-.8 1.4-1.6 2.6-2.1 1.8-.8 3.6-.8 4.7 0 .4-.6.9-1.2 1.6-1.3 1.2-.4 2.5.2 3.3 1.3.1-.2.4-.5.6-.6.4-.2.9-.2 1.5-.2 1.2 0 2.2.8 2.6 2 .5.1.9.2 1.3.5.2-.7 1.1-1.3 1.9-1.3 1.1 0 2 .8 2 2 0 .2 0 .5-.1.7.4-.1.7-.1 1.1-.1.6 0 1.2.1 1.6.5h.2c.8.5 1.5 1.1 2 1.9.2.4.5 1.2.5 1.9z"
                      fill="url(#SVGID_00000110469050448546575110000002523826992775102885_)"
                    />
                    <path
                      className="st44"
                      d="M1333.9 491.8h-.6c-.1-.4-.2-.7-.2-1.1 0-.5 0-1.1.2-1.5.1-.4.4-.6.6-.8-.1.2-.2.6-.4.8-.1.4-.1.7-.1 1.1s.1.7.4 1.1c0 .2 0 .3.1.4zM1351.8 485.3c-.4-.1-.6-.1-.9-.1-1.1 0-2.1.4-2.9 1.1 0-.1 0-.2-.1-.4.7-.5 1.6-.8 2.6-.8.5 0 .9.1 1.3.2zM1355.4 487.9l-.2.2c-.2-.5-.5-.9-.8-1.4-.2-.2-.6-.6-.9-.7-.1-.1-.2-.1-.4-.2.2.1.5.2.7.4.4.2.6.5.9.7.2.3.5.6.7 1zM1354.2 489.3c-.2.5-.4.9-.4 1.5 0 .2 0 .6.1.8 0 .1 0 .1.1.2h-6.5c0-.1.1-.1.1-.2.1-.2.2-.5.2-.8 0-.2-.1-.6-.2-.8-.1-.2-.4-.5-.6-.7.1 0 .1.1.2.1l.4.4c.4.4.6.8.6 1.3 0 .4.2.6.6.6h4.9v-.4c.1-.7.2-1.4.5-2 0-.1.1-.2.1-.2 0 .1 0 .2-.1.2zM1345.1 490v.2c0 .6-.2 1.2-.5 1.6h-6.4c-.2-.5-.4-1.1-.4-1.8 0-.4 0-.6.1-.8.1-.4.2-.7.4-1.1.1-.1.1-.2.2-.4.1-.1.1-.2.2-.4-.1.1-.1.2-.2.4-.2.5-.4.9-.5 1.4v.6c0 .8.7 1.5 1.6 1.5h4.6c.2-.5.4-.9.4-1.5v-.2-.5-.2c-.1-.9-.7-1.6-1.3-2.2-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.4-.1c.2 0 .4.1.6.2.1-.5 0-1.1-.1-1.4-.2-.4-.5-.7-.8-.9.5.2.9.6 1.2 1.2.2.5.2.9.1 1.5.8.5 1.4 1.3 1.6 2.2v1zM1335.9 487.9c-.5-.9-1.3-1.2-1.3-1.2.1-.1.1-.4.2-.5.6.4 1.1 1.1 1.1 1.7z"
                    />
                    <defs>
                      <path
                        id="SVGID_00000012474730831890753210000012764144829010013103_"
                        d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                      />
                    </defs>
                    <clipPath id="SVGID_00000172441421806009063770000000961470428943163782_">
                      <use
                        xlinkHref="#SVGID_00000012474730831890753210000012764144829010013103_"
                        overflow="visible"
                      />
                    </clipPath>
                    <defs>
                      <path
                        id="SVGID_00000026843924044644769510000002003894207028861312_"
                        d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                      />
                    </defs>
                    <defs>
                      <path
                        id="SVGID_00000000908416684028064460000017754491469761995964_"
                        d="M288.6 45L287.4 45 288.6 43.8z"
                      />
                    </defs>
                    <clipPath id="SVGID_00000162333975354200481630000012958594749645917607_">
                      <use
                        xlinkHref="#SVGID_00000026843924044644769510000002003894207028861312_"
                        overflow="visible"
                      />
                    </clipPath>
                    <clipPath
                      id="SVGID_00000109742985607760160050000013011949328845548478_"
                      clipPath="url(#SVGID_00000162333975354200481630000012958594749645917607_)"
                    >
                      <use
                        xlinkHref="#SVGID_00000000908416684028064460000017754491469761995964_"
                        overflow="visible"
                      />
                    </clipPath>
                    <defs>
                      <filter
                        id="Adobe_OpacityMaskFilter"
                        filterUnits="userSpaceOnUse"
                        x={1328}
                        y={477.4}
                        width={37.6}
                        height={14.5}
                      >
                        <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                      </filter>
                    </defs>
                    <mask
                      maskUnits="userSpaceOnUse"
                      x={1328}
                      y={477.4}
                      width={37.6}
                      height={14.5}
                      id="SVGID_00000085246750517292422900000010224360415866327458_"
                    >
                      <g filter="url(#Adobe_OpacityMaskFilter)">
                        <defs>
                          <path
                            id="SVGID_00000171689499530178611440000012419356038609104801_"
                            d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                          />
                        </defs>
                        <defs>
                          <path
                            id="SVGID_00000004546588584391231310000008984168710865772932_"
                            d="M288.6 45L287.4 45 288.6 43.8z"
                          />
                        </defs>
                        <clipPath
                          id="SVGID_00000116224251611459499600000015843387152994278289_"
                          clipPath="url(#SVGID_00000109742985607760160050000013011949328845548478_)"
                        >
                          <use
                            xlinkHref="#SVGID_00000171689499530178611440000012419356038609104801_"
                            overflow="visible"
                          />
                        </clipPath>
                        <clipPath
                          id="SVGID_00000135681055672544528680000008811848806246082740_"
                          clipPath="url(#SVGID_00000116224251611459499600000015843387152994278289_)"
                        >
                          <use
                            xlinkHref="#SVGID_00000004546588584391231310000008984168710865772932_"
                            overflow="visible"
                          />
                        </clipPath>
                        <g>
                          <defs>
                            <path
                              id="SVGID_00000047777836693099748570000001635487482841900709_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000150824668902768743760000006025478386849317293_"
                              d="M288.6 45L287.4 45 288.6 43.8z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000163062268958329568200000014818652272426166713_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <clipPath
                            id="SVGID_00000178905695144518109390000000545346102359084708_"
                            clipPath="url(#SVGID_00000109742985607760160050000013011949328845548478_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000047777836693099748570000001635487482841900709_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000182489393250538245550000008924788764120638132_"
                            clipPath="url(#SVGID_00000178905695144518109390000000545346102359084708_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000150824668902768743760000006025478386849317293_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000082338983337493751650000015370732905329285277_"
                            clipPath="url(#SVGID_00000182489393250538245550000008924788764120638132_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000163062268958329568200000014818652272426166713_"
                              overflow="visible"
                            />
                          </clipPath>
                        </g>
                        <g>
                          <defs>
                            <path
                              id="SVGID_00000158714289633507649510000012732529617164193462_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000163781218433659163930000010084771281999858313_"
                              d="M288.6 45L287.4 45 288.6 43.8z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000109017159846276568610000007623832925402145689_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000183966286941532818270000004792516298480817850_"
                              d="M288.6 45L287.4 45 288.6 43.8z"
                            />
                          </defs>
                          <clipPath
                            id="SVGID_00000169517898372301192100000011637084453754610829_"
                            clipPath="url(#SVGID_00000109742985607760160050000013011949328845548478_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000158714289633507649510000012732529617164193462_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000106847210389832572300000017898694312758233505_"
                            clipPath="url(#SVGID_00000169517898372301192100000011637084453754610829_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000163781218433659163930000010084771281999858313_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000031184640131182627580000012404461000269779113_"
                            clipPath="url(#SVGID_00000106847210389832572300000017898694312758233505_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000109017159846276568610000007623832925402145689_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000039126948444328145910000016023709417205964478_"
                            clipPath="url(#SVGID_00000031184640131182627580000012404461000269779113_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000183966286941532818270000004792516298480817850_"
                              overflow="visible"
                            />
                          </clipPath>
                          <linearGradient
                            id="SVGID_00000064347602114535879070000006038512149683921542_"
                            gradientUnits="userSpaceOnUse"
                            x1={1346.8}
                            y1={491.8637}
                            x2={1346.8}
                            y2={477.5794}
                          >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={1} />
                          </linearGradient>
                          <path
                            d="M1365.6 488.5c0 .2 0 .6-.1.8-.2 1.1-.9 2-1.9 2.6H1330c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-2.6 1.8-4.8 4.1-5.5.5-.1 1.1-.2 1.6-.2 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3h.2c.4-.1.7-.1 1.2-.1 2 .1 3.7 1.8 3.7 4z"
                            clipPath="url(#SVGID_00000039126948444328145910000016023709417205964478_)"
                            fill="url(#SVGID_00000064347602114535879070000006038512149683921542_)"
                          />
                        </g>
                      </g>
                    </mask>
                    <linearGradient
                      id="SVGID_00000157309328716192320680000004841018223384607370_"
                      gradientUnits="userSpaceOnUse"
                      x1={1346.8}
                      y1={491.8637}
                      x2={1346.8}
                      y2={477.5794}
                    >
                      <stop offset={0} stopColor="#fff" />
                      <stop offset={1} />
                    </linearGradient>
                    <path
                      d="M1365.6 488.5c0 .2 0 .6-.1.8-.2 1.1-.9 2-1.9 2.6H1330c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-2.6 1.8-4.8 4.1-5.5.5-.1 1.1-.2 1.6-.2 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3h.2c.4-.1.7-.1 1.2-.1 2 .1 3.7 1.8 3.7 4z"
                      clipPath="url(#SVGID_00000109742985607760160050000013011949328845548478_)"
                      mask="url(#SVGID_00000085246750517292422900000010224360415866327458_)"
                      fill="url(#SVGID_00000157309328716192320680000004841018223384607370_)"
                    />
                    <linearGradient
                      id="SVGID_00000041275568793591566640000006690106825897357724_"
                      gradientUnits="userSpaceOnUse"
                      x1={1346.8}
                      y1={491.8637}
                      x2={1346.8}
                      y2={477.5794}
                    >
                      <stop offset={0} stopColor="#fff" />
                      <stop offset={1} stopColor="#9cd0f1" />
                    </linearGradient>
                    <path
                      d="M1365.6 488.5c0 .2 0 .6-.1.8-.2 1.1-.9 2-1.9 2.6H1330c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-2.6 1.8-4.8 4.1-5.5.5-.1 1.1-.2 1.6-.2 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3h.2c.4-.1.7-.1 1.2-.1 2 .1 3.7 1.8 3.7 4z"
                      opacity={0.5}
                      fill="url(#SVGID_00000041275568793591566640000006690106825897357724_)"
                      enableBackground="new"
                    />
                    <g className="st57">
                      <path
                        className="st11"
                        d="M1334.8 483.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.2.2 0 .2.2zM1331.2 489.5c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2zM1342.4 479.8c0 .1-.1.1-.1.1l-.1-.1c0-.1.1-.1.1-.1l.1.1zM1338.3 480.5c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1349.9 482.4c-.1.1-.1 0 0 0-.1 0-.1-.1 0 0 0-.1 0 0 0 0zM1352.9 483.7c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1347.3 480.5s0 .1 0 0c-.1.1-.2 0-.2 0 0-.1.1-.1.2 0 0-.1 0-.1 0 0zM1340.2 482c-.1.1-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zM1329 487.9c-.1.1-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zM1334.5 480.9s-.1 0 0 0c-.1.1-.1 0 0 0-.3-.2-.1-.2 0 0-.1-.2 0-.2 0 0zM1333.7 485.5c0 .1 0 .1 0 0-.1.1-.1 0 0 0zM1353.6 481.7c-.1.1-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zM1356.9 483.9s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0zM1358.2 482.4s0 .1 0 0c-.1.1-.2 0-.2 0 0-.1.1-.1.2 0 0-.1 0-.1 0 0zM1358.6 485.4s0 .1 0 0c-.2.1-.2 0 0 0-.2 0-.2 0 0 0zM1361.6 485.3s-.1 0 0 0c-.1.1-.1 0 0 0-.2-.1-.1-.1 0 0-.1-.1 0-.1 0 0zM1361.8 488.2c-.1.1-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zM1363.8 490.3c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1363.1 491.3c0 .1-.1.1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0-.1 0 0 0 0 0z"
                      />
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000091723754336509313600000002767871248962125997_"
                        gradientUnits="userSpaceOnUse"
                        x1={1381.7}
                        y1={444.6}
                        x2={1381.7}
                        y2={433.5361}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000091723754336509313600000002767871248962125997_)"
                        d="M1374.1 433.5H1389.3V444.6H1374.1z"
                      />
                      <linearGradient
                        id="SVGID_00000098206171771125000550000004139262615093486989_"
                        gradientUnits="userSpaceOnUse"
                        x1={1364.3345}
                        y1={494.0691}
                        x2={1383.1539}
                        y2={442.363}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000098206171771125000550000004139262615093486989_)"
                        d="M1389.3 444.6L1374.2 489.3 1373.4 491.8 1358.1 491.8 1358.9 489.3 1359.6 487.4 1360.5 484.8 1370.8 454.2 1370.9 453.7 1373.5 446.3 1373.8 445.7 1374.1 444.6z"
                      />
                      <linearGradient
                        id="SVGID_00000065771332795974063560000009414917137915469247_"
                        gradientUnits="userSpaceOnUse"
                        x1={1373.3538}
                        y1={468.2}
                        x2={1395.796}
                        y2={468.2}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#b6c5c7" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000065771332795974063560000009414917137915469247_)"
                        d="M1395.8 444.6L1395.8 491.8 1373.4 491.8 1374.2 489.3 1389.3 444.6z"
                      />
                      <linearGradient
                        id="SVGID_00000106830402795411543570000013594096042520250295_"
                        gradientUnits="userSpaceOnUse"
                        x1={1389.3406}
                        y1={439.05}
                        x2={1395.8154}
                        y2={439.05}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#b6c5c7" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000106830402795411543570000013594096042520250295_)"
                        d="M1389.3 433.5H1395.7V444.6H1389.3z"
                      />
                    </g>
                    <linearGradient
                      id="SVGID_00000001662865832666747110000004106812612714784404_"
                      gradientUnits="userSpaceOnUse"
                      x1={1437.1282}
                      y1={439.05}
                      x2={1443.6029}
                      y2={439.05}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#b6c5c7" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_00000001662865832666747110000004106812612714784404_)"
                      d="M1437.1 433.5H1443.5V444.6H1437.1z"
                    />
                    <g>
                      <path
                        className="st11"
                        d="M1374.6 457.1l-.5 1.1c1.2.1 1.5 1.2.8 3.2h1.2c1-2.6.2-4.2-1.5-4.3zm-5.5 4.2h1.2c.8-2 2-3 3.3-3.2l.5-1.1c-2 .2-4 1.8-5 4.3zm5.6.6c-.8 1.8-1.9 2.7-3 2.8l-.5 1.1c1.8-.1 3.6-1.5 4.7-3.9h-1.2zm-4.6 0h-1.2c-.7 2.3 0 3.7 1.8 3.9l.5-1.1c-1.2-.1-1.5-1-1.1-2.8zM1381.6 457c-1.3 0-2.7.5-3.6 1.3l.6.7c.8-.6 1.6-.9 2.6-.9 1.2 0 1.6.6 1.3 1.4-.2.5-.6 1.1-1.6 1.8h1.4c.8-.7 1.2-1.3 1.4-1.9.5-1.5-.2-2.4-2.1-2.4zm-4 7.6l3.6-2.6c.1-.1.2-.1.4-.2h-1.5l-4.2 2.9-.4.8h6.2l.5-1.1h-4.6v.2z"
                      />
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000153682968701333183920000004269442777187831196_"
                        gradientUnits="userSpaceOnUse"
                        x1={1358.4501}
                        y1={444.6}
                        x2={1358.4501}
                        y2={435.3371}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000153682968701333183920000004269442777187831196_)"
                        d="M1342.8 435.4H1374.1V444.59999999999997H1342.8z"
                      />
                      <path
                        className="st64"
                        d="M1373.8 442.5h-30.4c-.1 0-.4-.1-.4-.4V436c0-.1.1-.4.4-.4h30.4c.1 0 .4.1.4.4v6.1c-.1.3-.2.4-.4.4z"
                      />
                      <linearGradient
                        id="SVGID_00000021098976863431908310000012427393593217836985_"
                        gradientUnits="userSpaceOnUse"
                        x1={1345.9501}
                        y1={442.3409}
                        x2={1345.9501}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1348.4 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000021098976863431908310000012427393593217836985_)"
                      />
                      <linearGradient
                        id="SVGID_00000047782673083805571830000016368156481198760629_"
                        gradientUnits="userSpaceOnUse"
                        x1={1351.05}
                        y1={442.3409}
                        x2={1351.05}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1353.5 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000047782673083805571830000016368156481198760629_)"
                      />
                      <linearGradient
                        id="SVGID_00000104706353747733278510000008918951874387799468_"
                        gradientUnits="userSpaceOnUse"
                        x1={1356.25}
                        y1={442.3409}
                        x2={1356.25}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1358.7 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000104706353747733278510000008918951874387799468_)"
                      />
                      <linearGradient
                        id="SVGID_00000099640536733319206480000006457929697695489943_"
                        gradientUnits="userSpaceOnUse"
                        x1={1361.3501}
                        y1={442.3409}
                        x2={1361.3501}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1363.8 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000099640536733319206480000006457929697695489943_)"
                      />
                      <linearGradient
                        id="SVGID_00000177444098373526761120000016899633189664339887_"
                        gradientUnits="userSpaceOnUse"
                        x1={1366.55}
                        y1={442.3409}
                        x2={1366.55}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1369 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.2-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000177444098373526761120000016899633189664339887_)"
                      />
                      <linearGradient
                        id="SVGID_00000005979878328588324140000013864447939079695760_"
                        gradientUnits="userSpaceOnUse"
                        x1={1371.6499}
                        y1={442.3409}
                        x2={1371.6499}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1374.1 436.1v6.3h-4.8c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h4.8z"
                        fill="url(#SVGID_00000005979878328588324140000013864447939079695760_)"
                      />
                      <linearGradient
                        id="SVGID_00000024713646918663163450000013204565902268860313_"
                        gradientUnits="userSpaceOnUse"
                        x1={1343.65}
                        y1={442.3409}
                        x2={1343.65}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1343.9 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000024713646918663163450000013204565902268860313_)"
                      />
                      <linearGradient
                        id="SVGID_00000088106669902557178720000013895697466654088881_"
                        gradientUnits="userSpaceOnUse"
                        x1={1353.95}
                        y1={442.3409}
                        x2={1353.95}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1354.2 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000088106669902557178720000013895697466654088881_)"
                      />
                      <linearGradient
                        id="SVGID_00000106863640176951031710000008252351975589501062_"
                        gradientUnits="userSpaceOnUse"
                        x1={1358.8}
                        y1={442.3409}
                        x2={1358.8}
                        y2={439.5656}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1343.5 439.6l4.9.7v2c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-2.7zm5.1.7v2c0 .1 0 .1.1.1h4.7c.1 0 .1 0 .1-.1v-1.8l-2.8.1-2.1-.3zm5.2 2s0 .1 0 0l4.8.1c.1 0 .1 0 .1-.1v-2l-4.9.2v1.8zm5.1 0s0 .1 0 0l4.8.1c.1 0 .1 0 .1-.1v-2.2l-4.9.2v2zm5.2-2.2v2.2c0 .1 0 .1.1.1h4.7c.1 0 .1 0 .1-.1v-2.2h-4.9zm5.1 0v2.2c0 .1 0 .1.1.1h4.8v-2.3h-4.9z"
                        opacity={0.25}
                        fill="url(#SVGID_00000106863640176951031710000008252351975589501062_)"
                        enableBackground="new"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1353.2 436.1L1350.3 442.4 1348.9 442.4 1351.9 436.1z"
                        />
                        <path
                          className="st64"
                          d="M1357.7 442.4l.9-2v1.9c0 .1 0 .1-.1.1h-.8zM1363.8 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-2.5l1.8-3.7 3.1.1c-.1-.1 0-.1 0 0zM1369 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.2-.1 0-.1 0 0zM1372.4 436.1l-2.9 6.3h-.1c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h3z"
                        />
                      </g>
                      <linearGradient
                        id="SVGID_00000064320995257104839110000018050899840891100571_"
                        gradientUnits="userSpaceOnUse"
                        x1={1364.25}
                        y1={442.3409}
                        x2={1364.25}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1364.5 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000064320995257104839110000018050899840891100571_)"
                      />
                      <linearGradient
                        id="SVGID_00000135673335273575914720000013758866063072518586_"
                        gradientUnits="userSpaceOnUse"
                        x1={1369.45}
                        y1={442.3409}
                        x2={1369.45}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1369.7 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.2-.1 0 0 0 0z"
                        fill="url(#SVGID_00000135673335273575914720000013758866063072518586_)"
                      />
                      <linearGradient
                        id="SVGID_00000090989363812146975640000005713337086799576474_"
                        gradientUnits="userSpaceOnUse"
                        x1={1348.8999}
                        y1={442.3409}
                        x2={1348.8999}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1349.2 442.4h-.5c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.2 6.2c-.1-.1-.1 0 0 0z"
                        fill="url(#SVGID_00000090989363812146975640000005713337086799576474_)"
                      />
                      <linearGradient
                        id="SVGID_00000122683961495600023690000004075951406072231358_"
                        gradientUnits="userSpaceOnUse"
                        x1={1359.15}
                        y1={442.3409}
                        x2={1359.15}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1359.4 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000122683961495600023690000004075951406072231358_)"
                      />
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000165931425621195118310000013458550604428335789_"
                        gradientUnits="userSpaceOnUse"
                        x1={1406.4501}
                        y1={444.6}
                        x2={1406.4501}
                        y2={435.3371}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000165931425621195118310000013458550604428335789_)"
                        d="M1390.8 435.4H1422.1V444.59999999999997H1390.8z"
                      />
                      <path
                        className="st64"
                        d="M1421.9 442.5h-30.4c-.1 0-.4-.1-.4-.4V436c0-.1.1-.4.4-.4h30.4c.1 0 .4.1.4.4v6.1c-.2.3-.3.4-.4.4z"
                      />
                      <linearGradient
                        id="SVGID_00000098908942323369621490000013329414212264982172_"
                        gradientUnits="userSpaceOnUse"
                        x1={1393.9501}
                        y1={442.3409}
                        x2={1393.9501}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1396.4 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c0-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000098908942323369621490000013329414212264982172_)"
                      />
                      <linearGradient
                        id="SVGID_00000054959705311972994470000002983483055942415010_"
                        gradientUnits="userSpaceOnUse"
                        x1={1399.15}
                        y1={442.3409}
                        x2={1399.15}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1401.6 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c0-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000054959705311972994470000002983483055942415010_)"
                      />
                      <linearGradient
                        id="SVGID_00000047050937788331557540000009625840049084369293_"
                        gradientUnits="userSpaceOnUse"
                        x1={1404.25}
                        y1={442.3409}
                        x2={1404.25}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1406.7 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c0-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000047050937788331557540000009625840049084369293_)"
                      />
                      <linearGradient
                        id="SVGID_00000165220642905575067590000011435262304005815701_"
                        gradientUnits="userSpaceOnUse"
                        x1={1409.4501}
                        y1={442.3409}
                        x2={1409.4501}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1411.9 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c0-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000165220642905575067590000011435262304005815701_)"
                      />
                      <linearGradient
                        id="SVGID_00000103244977838745125520000010432056651868433825_"
                        gradientUnits="userSpaceOnUse"
                        x1={1414.55}
                        y1={442.3409}
                        x2={1414.55}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1417 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c0-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000103244977838745125520000010432056651868433825_)"
                      />
                      <linearGradient
                        id="SVGID_00000034061469261512941620000011182427640277980078_"
                        gradientUnits="userSpaceOnUse"
                        x1={1419.6499}
                        y1={442.3409}
                        x2={1419.6499}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1422.1 436.1v6.3h-4.8c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h4.8z"
                        fill="url(#SVGID_00000034061469261512941620000011182427640277980078_)"
                      />
                      <linearGradient
                        id="SVGID_00000160883545391964399430000012501100933212619393_"
                        gradientUnits="userSpaceOnUse"
                        x1={1391.85}
                        y1={442.3409}
                        x2={1391.85}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1392.1 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1-.1 0 0 0z"
                        fill="url(#SVGID_00000160883545391964399430000012501100933212619393_)"
                      />
                      <linearGradient
                        id="SVGID_00000093859871211734303460000013723428688124966278_"
                        gradientUnits="userSpaceOnUse"
                        x1={1402.15}
                        y1={442.3409}
                        x2={1402.15}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1402.4 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1-.1 0 0 0z"
                        fill="url(#SVGID_00000093859871211734303460000013723428688124966278_)"
                      />
                      <linearGradient
                        id="SVGID_00000071518066065949042560000005318917747606886019_"
                        gradientUnits="userSpaceOnUse"
                        x1={1406.8}
                        y1={442.3409}
                        x2={1406.8}
                        y2={439.5656}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1391.5 439.6l4.9.7v2c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-2.7zm5.2.7v2c0 .1 0 .1.1.1h4.7c.1 0 .1 0 .1-.1v-1.8l-2.8.1-2.1-.3zm5.1 2s.1.1 0 0l4.8.1c.1 0 .1 0 .1-.1v-2l-4.9.2v1.8zm5.1 0s.2.1 0 0l4.8.1c.1 0 .1 0 .1-.1v-2.2l-4.9.2v2zm5.2-2.2v2.2c0 .1 0 .1.1.1h4.7c.1 0 .1 0 .1-.1v-2.2h-4.9zm5.1 0v2.2c0 .1 0 .1.1.1h4.8v-2.3h-4.9z"
                        opacity={0.25}
                        fill="url(#SVGID_00000071518066065949042560000005318917747606886019_)"
                        enableBackground="new"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1401.3 436.1L1398.4 442.4 1397 442.4 1399.9 436.1z"
                        />
                        <path
                          className="st64"
                          d="M1405.8 442.4l.9-2v1.9c0 .1 0 .1-.1.1h-.8zM1411.9 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-2.5l1.8-3.7 3.1.1c0-.1 0-.1 0 0zM1417 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c0-.1 0-.1 0 0zM1420.4 436.1l-2.9 6.3h-.1c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h3z"
                        />
                      </g>
                      <linearGradient
                        id="SVGID_00000010272337850607128940000008114979628622775714_"
                        gradientUnits="userSpaceOnUse"
                        x1={1412.45}
                        y1={442.3409}
                        x2={1412.45}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1412.7 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1-.1 0 0 0z"
                        fill="url(#SVGID_00000010272337850607128940000008114979628622775714_)"
                      />
                      <linearGradient
                        id="SVGID_00000161595511210851299470000016581902098687261101_"
                        gradientUnits="userSpaceOnUse"
                        x1={1417.55}
                        y1={442.3409}
                        x2={1417.55}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1417.8 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1-.1 0 0 0z"
                        fill="url(#SVGID_00000161595511210851299470000016581902098687261101_)"
                      />
                      <linearGradient
                        id="SVGID_00000070797059290659269620000005726451204198160279_"
                        gradientUnits="userSpaceOnUse"
                        x1={1396.95}
                        y1={442.3409}
                        x2={1396.95}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1397.2 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1-.1 0 0 0z"
                        fill="url(#SVGID_00000070797059290659269620000005726451204198160279_)"
                      />
                      <linearGradient
                        id="SVGID_00000039837793309008026420000018388614926295839646_"
                        gradientUnits="userSpaceOnUse"
                        x1={1407.25}
                        y1={442.3409}
                        x2={1407.25}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1407.5 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1-.1 0 0 0z"
                        fill="url(#SVGID_00000039837793309008026420000018388614926295839646_)"
                      />
                    </g>
                    <g>
                      <path
                        className="st64"
                        d="M1339.7 441.6h-12.3c-.4 0-.6-.2-.6-.6v-4.3c0-.4.2-.6.6-.6h12.3c.4 0 .6.2.6.6v4.3c0 .3-.2.6-.6.6z"
                      />
                      <linearGradient
                        id="SVGID_00000119824776104060123080000014164951425238622340_"
                        gradientUnits="userSpaceOnUse"
                        x1={1327.1251}
                        y1={438.85}
                        x2={1340.1371}
                        y2={438.85}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1340.1 436.4v4.9s0 .1-.1.1h-12.9s-.1 0-.1-.1v-4.9s0-.1.1-.1l13 .1c0-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000119824776104060123080000014164951425238622340_)"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1331.3 436.3L1329.7 441.3 1328.3 441.3 1329.9 436.3z"
                        />
                        <path
                          className="st64"
                          d="M1339.3 436.3L1337.6 441.3 1334.1 441.3 1335.8 436.3z"
                        />
                      </g>
                      <path
                        className="st93"
                        d="M1340.1 438.8v2.6s0 .1-.1.1h-12.9s-.1 0-.1-.1v-1.6h7.9l5.2-1z"
                      />
                      <linearGradient
                        id="SVGID_00000009567412778182932860000002357224730332615334_"
                        gradientUnits="userSpaceOnUse"
                        x1={1327.35}
                        y1={441.3922}
                        x2={1327.35}
                        y2={436.3094}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1327.6 441.3h-.4c-.1 0-.1 0-.1-.1v-4.9c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 5z"
                        fill="url(#SVGID_00000009567412778182932860000002357224730332615334_)"
                      />
                    </g>
                    <g>
                      <path
                        className="st64"
                        d="M1387.9 441.6h-12.3c-.4 0-.6-.2-.6-.6v-4.3c0-.4.2-.6.6-.6h12.3c.4 0 .6.2.6.6v4.3c0 .3-.4.6-.6.6z"
                      />
                      <linearGradient
                        id="SVGID_00000028294281846375843760000000757468049066902189_"
                        gradientUnits="userSpaceOnUse"
                        x1={1375.2083}
                        y1={438.85}
                        x2={1388.2202}
                        y2={438.85}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1388.2 436.4v4.9s0 .1-.1.1h-12.9s-.1 0-.1-.1v-4.9s0-.1.1-.1l13 .1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000028294281846375843760000000757468049066902189_)"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1379.4 436.3L1377.7 441.3 1376.4 441.3 1378.1 436.3z"
                        />
                        <path
                          className="st64"
                          d="M1387.3 436.3L1385.7 441.3 1382.3 441.3 1383.9 436.3z"
                        />
                      </g>
                      <path
                        className="st93"
                        d="M1388.2 438.8v2.6s0 .1-.1.1h-12.9s-.1 0-.1-.1v-1.6h7.9l5.2-1z"
                      />
                      <linearGradient
                        id="SVGID_00000086675828593631798670000009793036422523870851_"
                        gradientUnits="userSpaceOnUse"
                        x1={1375.45}
                        y1={441.3922}
                        x2={1375.45}
                        y2={436.3094}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1375.7 441.3h-.4c-.1 0-.1 0-.1-.1v-4.9c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 5c-.1 0-.1 0 0 0z"
                        fill="url(#SVGID_00000086675828593631798670000009793036422523870851_)"
                      />
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000119828386525825146330000014896256302007107234_"
                        gradientUnits="userSpaceOnUse"
                        x1={1409.15}
                        y1={451.9313}
                        x2={1409.15}
                        y2={444.6046}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        d="M1422.5 444.6l-.4 1.1H1403c-1.6 0-3 1.4-3 3v1.5c-1.5.4-2.9.9-4.2 1.6v-7.4h26.7v.2z"
                        fill="url(#SVGID_00000119828386525825146330000014896256302007107234_)"
                      />
                      <path
                        className="st37"
                        d="M1422.1 445.7l-2.8 8.1H1400v-5c0-1.6 1.4-3 3-3h19.1v-.1z"
                      />
                      <path
                        className="st37"
                        d="M1421.8 445.7l-.1.5-2.6 7.5h-14.8v-5c0-1.6 1.4-3 3-3h14.5z"
                      />
                      <path
                        className="st38"
                        d="M1421.7 446.3l-2.7 8.1h-11.1v-5c0-1.6 1.4-3 3-3h10.8v-.1z"
                      />
                      <linearGradient
                        id="SVGID_00000029020270534265283580000002821094379188659340_"
                        gradientUnits="userSpaceOnUse"
                        x1={1400.55}
                        y1={491.8412}
                        x2={1400.55}
                        y2={449.8412}
                      >
                        <stop offset={0} stopColor="#79aace" />
                        <stop offset={0.5838} stopColor="#95c9ed" />
                        <stop offset={0.7626} stopColor="#c9e5f8" />
                        <stop offset={0.8631} stopColor="#aedaf5" />
                        <stop offset={1} stopColor="#9cd0f1" />
                      </linearGradient>
                      <path
                        d="M1420.6 449.9l-14.4 42h-25.7c0-9.5 5.6-22.3 8.4-31.3 1.2-3.7 3.6-6.8 6.9-8.6 1.3-.8 2.7-1.3 4.2-1.6 1.2-.2 2.3-.4 3.5-.4l17.1-.1z"
                        fill="url(#SVGID_00000029020270534265283580000002821094379188659340_)"
                      />
                      <linearGradient
                        id="SVGID_00000170995300323947358220000015242501279966682518_"
                        gradientUnits="userSpaceOnUse"
                        x1={1380.5}
                        y1={470.9}
                        x2={1420.649}
                        y2={470.9}
                      >
                        <stop offset={0} stopColor="#fff" />
                        <stop offset={0.1981} stopColor="#fafbfd" />
                        <stop offset={0.3376} stopColor="#eff1f8" />
                        <stop offset={0.4591} stopColor="#dfe4f1" />
                        <stop offset={0.5703} stopColor="#c9d2e7" />
                        <stop offset={0.6746} stopColor="#aebedc" />
                        <stop offset={0.7737} stopColor="#8fa6d0" />
                        <stop offset={0.8686} stopColor="#6b8fc2" />
                        <stop offset={0.958} stopColor="#3d78b4" />
                        <stop offset={1} stopColor="#166eae" />
                      </linearGradient>
                      <path
                        d="M1420.6 449.9l-14.4 42h-25.7c0-9.5 5.6-22.3 8.4-31.3 1.2-3.7 3.6-6.8 6.9-8.6 1.3-.8 2.7-1.3 4.2-1.6 1.2-.2 2.3-.4 3.5-.4l17.1-.1z"
                        opacity={0.4}
                        fill="url(#SVGID_00000170995300323947358220000015242501279966682518_)"
                        enableBackground="new"
                      />
                      <g className="st41">
                        <path
                          className="st42"
                          d="M1382.8 488.5c.4-3 .9-6 1.5-8.9h.1v.1c-.6 2.8-1.1 5.7-1.6 8.8.1 0 .1 0 0 0zM1404.6 488.5s-.1 0 0 0c.4-3 .9-6 1.5-8.9h.1v.1c-.5 2.8-1.1 5.7-1.6 8.8zM1385.8 473.7s-.1 0 0 0c.7-3 1.6-6 2.7-9.4h.1v.1c-1.1 3.4-2 6.4-2.8 9.3zM1408 473.7c.7-3 1.6-6 2.7-9.4h.1v.1c-1 3.4-1.9 6.4-2.8 9.3.1 0 .1 0 0 0zM1390.1 460c-.1-.1-.1-.1 0 0l.2-.8c.8-2.5 2.5-4.4 4.8-6 1.1-.7 2.3-1.2 3.6-1.5 1.3-.4 2.6-.6 4-.6 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.7 0-10.6 3.2-12.3 7.9l-.3.8c0-.1 0 0 0 0zM1411.6 460c0-.1 0-.1 0 0l.2-.8c1.1-3 3.4-5.4 6.5-6.8h.1v.1c-3.2 1.4-5.5 3.7-6.5 6.8l-.3.7c.1-.1.1 0 0 0zM1393.9 488.5c0-.1.5-2.7 1.2-6.3h.1v.1c-.8 3.5-1.2 6-1.3 6.2.1 0 .1 0 0 0zM1396.7 474.2c-.2 0-.2 0 0 0 1.2-6.2 2.1-10.6 2.7-13.4h.1v.1c-.7 2.7-1.6 7.2-2.8 13.3zM1403.1 454.3c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 1.5-1.3 3.2-1.9 4.3-2.2 1.3-.4 2.1-.5 2.1-.5h.1v.1s-.9.1-2.1.5c-1.3.3-2.9 1-4.4 2.1z"
                        />
                        <path
                          className="st35"
                          d="M1398.2 490s-.1 0 0 0c.1-1.4 1.1-5.5 2.7-12.4h.1v.1c-1.6 6.8-2.6 11-2.8 12.3zM1402.9 469.6c-.2 0-.2 0 0 0-.2 0-.2-.1 0 0 .4-1.8.7-3.5 1.2-5.4h.1v.1c-.5 1.8-1 3.6-1.3 5.3zM1405.3 459.2c-.1 0-.1 0 0 0 .5-1.6 1.2-3 2.1-4.1.8-.9 1.6-1.6 2.7-2.2 1.8-.9 3.2-1.1 3.3-1.1h.1v.1s-1.5.1-3.2 1.1c-1.7.9-3.8 2.7-5 6.2zM1388.6 490c-.1 0-.1 0 0 0 0-.7.4-2 .6-3.7h.1v.1c-.4 1.6-.6 2.9-.7 3.6zM1390.5 480.3s-.1 0 0 0c.4-1.9.7-3.6 1.1-5.4h.1v.1c-.4 1.6-.8 3.5-1.2 5.3z"
                        />
                      </g>
                      <g>
                        <linearGradient
                          id="SVGID_00000160905971973691208900000003480951710158457735_"
                          gradientUnits="userSpaceOnUse"
                          x1={1394.75}
                          y1={491.8637}
                          x2={1394.75}
                          y2={482.6934}
                        >
                          <stop offset={0} stopColor="#b8ddf5" />
                          <stop offset={0.6005} stopColor="#d8edfa" />
                          <stop offset={1} stopColor="#e7f6fd" />
                        </linearGradient>
                        <path
                          d="M1410.5 491.5v.4h-30.6c-.6-.6-.9-1.4-.9-2.5v-.1c.1-1.6 1.2-2.9 2.6-2.9.5 0 .9.1 1.3.4.1-.1.1-.4.2-.5.6-.8 1.4-1.6 2.6-2.1 1.8-.8 3.6-.8 4.7 0 .4-.6.9-1.2 1.6-1.3 1.2-.4 2.5.2 3.3 1.3.1-.2.4-.5.6-.6.4-.2.9-.2 1.5-.2 1.2 0 2.2.8 2.6 2 .5.1.9.2 1.3.5.2-.7 1.1-1.3 1.9-1.3 1.1 0 2 .8 2 2 0 .2 0 .5-.1.7.4-.1.7-.1 1.1-.1.6 0 1.2.1 1.6.5.8.5 1.6 1.2 2.1 1.9.3.4.6 1.2.6 1.9z"
                          fill="url(#SVGID_00000160905971973691208900000003480951710158457735_)"
                        />
                        <path
                          className="st44"
                          d="M1381.9 491.8h-.6c-.1-.4-.2-.7-.2-1.1 0-.5 0-1.1.2-1.5.1-.4.4-.6.6-.8-.1.2-.2.6-.4.8-.1.4-.1.7-.1 1.1s.1.7.4 1.1c0 .2.1.3.1.4zM1399.9 485.3c-.4-.1-.6-.1-.9-.1-1.1 0-2.1.4-2.9 1.1 0-.1 0-.2-.1-.4.7-.5 1.6-.8 2.6-.8.4 0 .9.1 1.3.2zM1403.4 487.9l-.2.2c-.2-.5-.5-.9-.8-1.4-.2-.2-.6-.6-.9-.7-.1-.1-.2-.1-.4-.2.2.1.5.2.7.4.4.2.6.5.9.7.4.3.6.6.7 1zM1402.4 489.3c-.2.5-.4.9-.4 1.5 0 .2 0 .6.1.8 0 .1 0 .1.1.2h-6.5c.2-.4.4-.7.4-1.1 0-.6-.4-1.2-.8-1.5.1 0 .1.1.2.1.6.4.9.9.9 1.6 0 .4.2.6.6.6h4.9v-.4c-.1-.5.1-1.2.5-1.8 0-.1.1-.2.1-.2 0 .1-.1.2-.1.2zM1393.2 490v.2c0 .6-.2 1.2-.5 1.6h-6.3c-.2-.5-.4-1.1-.4-1.8 0-.4 0-.6.1-.8.1-.4.2-.7.4-1.1.1-.1.1-.2.2-.4.1-.1.1-.2.2-.4-.1.1-.1.2-.2.4-.2.5-.4.9-.5 1.4v.6c0 .8.7 1.5 1.6 1.5h4.6c.2-.5.4-.9.4-1.5v-.2-.5-.2c-.1-.9-.7-1.6-1.3-2.2-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.4-.1c.2 0 .4.1.6.2.1-.5 0-1.1-.1-1.4-.2-.4-.5-.7-.8-.9.5.2.9.6 1.2 1.2.2.5.2.9.1 1.5.8.5 1.4 1.3 1.6 2.2V489.3c-.1.2-.1.4-.1.7zM1383.9 487.9c-.5-.9-1.3-1.2-1.3-1.2.1-.1.1-.4.2-.5.7.4 1.2 1.1 1.1 1.7z"
                        />
                        <g>
                          <defs>
                            <path
                              id="SVGID_00000022549517106891292020000018174859364348850611_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <clipPath id="SVGID_00000102516140918848327150000007730413163149886854_">
                            <use
                              xlinkHref="#SVGID_00000022549517106891292020000018174859364348850611_"
                              overflow="visible"
                            />
                          </clipPath>
                          <defs>
                            <path
                              id="SVGID_00000176012489808355775440000012009350251958074546_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000171719860175249772500000017964921205969625505_"
                              d="M288.6 45L287.4 45 288.6 43.8z"
                            />
                          </defs>
                          <clipPath id="SVGID_00000166664799802034046770000002449117943764798902_">
                            <use
                              xlinkHref="#SVGID_00000176012489808355775440000012009350251958074546_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000101090127772929579380000018334729844493782410_"
                            clipPath="url(#SVGID_00000166664799802034046770000002449117943764798902_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000171719860175249772500000017964921205969625505_"
                              overflow="visible"
                            />
                          </clipPath>
                          <defs>
                            <filter
                              id="Adobe_OpacityMaskFilter_00000000181738835565519810000017149047382904303805_"
                              filterUnits="userSpaceOnUse"
                              x={1376}
                              y={477.4}
                              width={37.7}
                              height={14.5}
                            >
                              <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                            </filter>
                          </defs>
                          <mask
                            maskUnits="userSpaceOnUse"
                            x={1376}
                            y={477.4}
                            width={37.7}
                            height={14.5}
                            id="SVGID_00000125588774356321321250000010930513342186230415_"
                          >
                            <g filter="url(#Adobe_OpacityMaskFilter_00000000181738835565519810000017149047382904303805_)">
                              <defs>
                                <path
                                  id="SVGID_00000109016056977481114920000011971425296569758638_"
                                  d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                />
                              </defs>
                              <defs>
                                <path
                                  id="SVGID_00000145056527899060617290000014960077209264906400_"
                                  d="M288.6 45L287.4 45 288.6 43.8z"
                                />
                              </defs>
                              <clipPath
                                id="SVGID_00000007429916019558166330000009771497612356331153_"
                                clipPath="url(#SVGID_00000101090127772929579380000018334729844493782410_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000109016056977481114920000011971425296569758638_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <clipPath
                                id="SVGID_00000139982277481168747890000015350681900158816149_"
                                clipPath="url(#SVGID_00000007429916019558166330000009771497612356331153_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000145056527899060617290000014960077209264906400_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000133516182915430724780000014044020314812327314_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000066505788381656429930000000925934786399993772_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000035511438676146141950000013312708736681360276_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000036240743418250012260000011860275613220662917_"
                                  clipPath="url(#SVGID_00000101090127772929579380000018334729844493782410_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000133516182915430724780000014044020314812327314_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000147196168331296691920000012651072919792429759_"
                                  clipPath="url(#SVGID_00000036240743418250012260000011860275613220662917_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000066505788381656429930000000925934786399993772_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000076604518058945105200000012434411788339743913_"
                                  clipPath="url(#SVGID_00000147196168331296691920000012651072919792429759_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000035511438676146141950000013312708736681360276_"
                                    overflow="visible"
                                  />
                                </clipPath>
                              </g>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000020360641866397066430000015788759271337222845_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000072256246650295111800000010878653065666010773_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000081636869560015055940000016943858791930655872_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000038411978751437779160000009194438776241263024_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000029038517952349803510000016032903405672586898_"
                                  clipPath="url(#SVGID_00000101090127772929579380000018334729844493782410_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000020360641866397066430000015788759271337222845_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000043455806759906126910000014312228229351967407_"
                                  clipPath="url(#SVGID_00000029038517952349803510000016032903405672586898_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000072256246650295111800000010878653065666010773_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000028316365681055266630000004146741681502904730_"
                                  clipPath="url(#SVGID_00000043455806759906126910000014312228229351967407_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000081636869560015055940000016943858791930655872_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000143608672105414371360000017711265078558285235_"
                                  clipPath="url(#SVGID_00000028316365681055266630000004146741681502904730_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000038411978751437779160000009194438776241263024_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <linearGradient
                                  id="SVGID_00000122685131663335055310000002253152747694417594_"
                                  gradientUnits="userSpaceOnUse"
                                  x1={1394.85}
                                  y1={491.8637}
                                  x2={1394.85}
                                  y2={477.5794}
                                >
                                  <stop offset={0} stopColor="#fff" />
                                  <stop offset={1} />
                                </linearGradient>
                                <path
                                  d="M1413.7 488.5c0 .2 0 .6-.1.8-.2 1.1-.9 2-1.9 2.6H1378c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-3.2 2.6-5.7 5.7-5.7 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3.4-.1.8-.2 1.3-.2 2.2.2 3.9 1.9 3.9 4.1z"
                                  clipPath="url(#SVGID_00000143608672105414371360000017711265078558285235_)"
                                  fill="url(#SVGID_00000122685131663335055310000002253152747694417594_)"
                                />
                              </g>
                            </g>
                          </mask>
                          <linearGradient
                            id="SVGID_00000139271518682122729490000015191291038721136259_"
                            gradientUnits="userSpaceOnUse"
                            x1={1394.85}
                            y1={491.8637}
                            x2={1394.85}
                            y2={477.5794}
                          >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={1} />
                          </linearGradient>
                          <path
                            d="M1413.7 488.5c0 .2 0 .6-.1.8-.2 1.1-.9 2-1.9 2.6H1378c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-3.2 2.6-5.7 5.7-5.7 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3.4-.1.8-.2 1.3-.2 2.2.2 3.9 1.9 3.9 4.1z"
                            clipPath="url(#SVGID_00000101090127772929579380000018334729844493782410_)"
                            mask="url(#SVGID_00000125588774356321321250000010930513342186230415_)"
                            fill="url(#SVGID_00000139271518682122729490000015191291038721136259_)"
                          />
                          <linearGradient
                            id="SVGID_00000103262456816120955930000003125289145050034077_"
                            gradientUnits="userSpaceOnUse"
                            x1={1394.85}
                            y1={491.8637}
                            x2={1394.85}
                            y2={477.5794}
                          >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={1} stopColor="#9cd0f1" />
                          </linearGradient>
                          <path
                            d="M1413.7 488.5c0 .2 0 .6-.1.8-.2 1.1-.9 2-1.9 2.6H1378c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-3.2 2.6-5.7 5.7-5.7 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3.4-.1.8-.2 1.3-.2 2.2.2 3.9 1.9 3.9 4.1z"
                            opacity={0.5}
                            fill="url(#SVGID_00000103262456816120955930000003125289145050034077_)"
                            enableBackground="new"
                          />
                          <g className="st57">
                            <path
                              className="st11"
                              d="M1383 483.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.2.2 0 .2.2zM1379.4 489.5c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c0 0 .2.1.2.2zM1390.5 479.8c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1l.1-.1c.1 0 .1.1.1.1zM1386.4 480.5c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1398.1 482.4s-.2 0 0 0c-.1.1-.1 0 0 0-.3 0-.2-.1 0 0-.2-.1 0 0 0 0zM1401 483.7c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1395.4 480.5s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1388.2 482c-.1.1-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zM1377.1 487.9s-.1 0 0 0c-.1.1-.1 0 0 0-.2-.1-.1-.1 0 0-.1-.1 0-.1 0 0zM1382.5 480.9c-.1.1-.1 0 0 0-.1-.2-.1-.2 0 0 0-.2 0-.2 0 0zM1381.8 485.5c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1401.8 481.7s-.1 0 0 0c-.1.1-.1 0 0 0-.1 0-.1-.1 0 0-.1-.1 0-.1 0 0zM1405.1 483.9s-.1.1 0 0c-.1.1-.1 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0 0zM1406.2 482.4s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1404.5 481.3c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0 0-.1 0 0 0 0zM1406.6 485.4s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0z"
                            />
                            <circle
                              className="st11"
                              cx={1409.5}
                              cy={485.3}
                              r={0.1}
                            />
                            <path
                              className="st11"
                              d="M1409.9 488.2c-.1.1-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zM1411.9 490.3c0 .1 0 .1 0 0-.1.1-.1 0 0 0zM1411.2 491.3c0 .1 0 .1 0 0-.2.1-.2.1 0 0-.2 0-.2 0 0 0z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <linearGradient
                      id="SVGID_00000172432348860565352620000010854973003673771662_"
                      gradientUnits="userSpaceOnUse"
                      x1={1412.0902}
                      y1={494.053}
                      x2={1430.9098}
                      y2={442.347}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#d7e7e6" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_00000172432348860565352620000010854973003673771662_)"
                      d="M1421.1 491.8L1405.9 491.8 1421.9 444.6 1437.1 444.6z"
                    />
                    <linearGradient
                      id="SVGID_00000161629906728930560340000006230819000456017835_"
                      gradientUnits="userSpaceOnUse"
                      x1={1421.1412}
                      y1={468.2}
                      x2={1443.6029}
                      y2={468.2}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#b6c5c7" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_00000161629906728930560340000006230819000456017835_)"
                      d="M1443.7 444.6L1443.7 491.8 1421.1 491.8 1422 489.3 1437.1 444.6z"
                    />
                    <g>
                      <path
                        className="st11"
                        d="M1417.9 461.8h-1.2c-.7 2.3 0 3.7 1.8 3.9l.5-1.1c-1.2-.2-1.5-1.2-1.1-2.8zm4.6 0c-.8 1.8-1.9 2.7-3 2.8l-.5 1.1c1.8-.1 3.6-1.5 4.7-3.9h-1.2zm-5.5-.6h1.2c.8-2 2-3 3.3-3.2l.5-1.1c-2.1.1-3.9 1.7-5 4.3zm5.4-4.3l-.5 1.1c1.2.1 1.5 1.2.8 3.2h1.2c1-2.7.2-4.2-1.5-4.3zM1430.2 461.8h-1.8l-.1.2c.6.1.8.5.6 1.1-.4.9-1.3 1.5-2.6 1.5-1.1 0-1.9-.4-2.2-.9l-.9.9c.5.7 1.5 1.1 2.7 1.1 2.2 0 3.7-1.2 4.2-2.6.2-.6.3-1.1.1-1.3zm-3.8-4.4l-.5 1.1h4.1l-3.2 2.7v.1h1.3l.4-.2.2-.1 3-2.6.4-.8h-5.7v-.2z"
                      />
                    </g>
                    <linearGradient
                      id="SVGID_00000132809956900108273230000017861010126028848044_"
                      gradientUnits="userSpaceOnUse"
                      x1={1421.8754}
                      y1={439.05}
                      x2={1437.1282}
                      y2={439.05}
                    >
                      <stop offset={0} stopColor="#9bb0b5" />
                      <stop offset={1} stopColor="#d7e7e6" />
                    </linearGradient>
                    <path
                      fill="url(#SVGID_00000132809956900108273230000017861010126028848044_)"
                      d="M1421.9 433.5H1437.1000000000001V444.6H1421.9z"
                    />
                    <g>
                      <path
                        className="st64"
                        d="M1435.6 441.6h-12.3c-.4 0-.6-.2-.6-.6v-4.3c0-.4.2-.6.6-.6h12.3c.4 0 .6.2.6.6v4.3c.1.3-.3.6-.6.6z"
                      />
                      <linearGradient
                        id="SVGID_00000024704590770878400900000002574061449309378713_"
                        gradientUnits="userSpaceOnUse"
                        x1={1423}
                        y1={438.85}
                        x2={1436.0118}
                        y2={438.85}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1436.1 436.4v4.9s0 .1-.1.1h-12.9s-.1 0-.1-.1v-4.9s0-.1.1-.1l13 .1c-.2-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000024704590770878400900000002574061449309378713_)"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1427.2 436.3L1425.5 441.3 1424.1 441.3 1425.9 436.3z"
                        />
                        <path
                          className="st64"
                          d="M1435.1 436.3L1433.5 441.3 1430 441.3 1431.6 436.3z"
                        />
                      </g>
                      <path
                        className="st93"
                        d="M1436.1 438.8v2.6s0 .1-.1.1h-12.9s-.1 0-.1-.1v-1.6h7.9l5.2-1z"
                      />
                      <linearGradient
                        id="SVGID_00000004533639397396737900000012523002909015902864_"
                        gradientUnits="userSpaceOnUse"
                        x1={1423.25}
                        y1={441.3922}
                        x2={1423.25}
                        y2={436.3094}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1423.5 441.3h-.4c-.1 0-.1 0-.1-.1v-4.9c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 5c-.1 0-.1 0 0 0z"
                        fill="url(#SVGID_00000004533639397396737900000012523002909015902864_)"
                      />
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000165930091393690982910000012398267710344374457_"
                        gradientUnits="userSpaceOnUse"
                        x1={1454.25}
                        y1={444.6}
                        x2={1454.25}
                        y2={435.3371}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000165930091393690982910000012398267710344374457_)"
                        d="M1438.6 435.4H1469.8999999999999V444.59999999999997H1438.6z"
                      />
                      <path
                        className="st64"
                        d="M1469.7 442.5h-30.4c-.1 0-.4-.1-.4-.4V436c0-.1.1-.4.4-.4h30.4c.1 0 .4.1.4.4v6.1c0 .3-.3.4-.4.4z"
                      />
                      <linearGradient
                        id="SVGID_00000098905033914549657990000000315050251225197229_"
                        gradientUnits="userSpaceOnUse"
                        x1={1441.9501}
                        y1={442.3409}
                        x2={1441.9501}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1444.4 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.2-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000098905033914549657990000000315050251225197229_)"
                      />
                      <linearGradient
                        id="SVGID_00000135687043830673422330000006691210624068187793_"
                        gradientUnits="userSpaceOnUse"
                        x1={1447.05}
                        y1={442.3409}
                        x2={1447.05}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1449.5 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000135687043830673422330000006691210624068187793_)"
                      />
                      <linearGradient
                        id="SVGID_00000016768356426420544300000017942863359190989241_"
                        gradientUnits="userSpaceOnUse"
                        x1={1452.15}
                        y1={442.3409}
                        x2={1452.15}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1454.6 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000016768356426420544300000017942863359190989241_)"
                      />
                      <linearGradient
                        id="SVGID_00000183931447103354035260000009631385834902395800_"
                        gradientUnits="userSpaceOnUse"
                        x1={1457.3501}
                        y1={442.3409}
                        x2={1457.3501}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1459.8 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000183931447103354035260000009631385834902395800_)"
                      />
                      <linearGradient
                        id="SVGID_00000054979969511584491960000003590828152900495035_"
                        gradientUnits="userSpaceOnUse"
                        x1={1462.4501}
                        y1={442.3409}
                        x2={1462.4501}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1464.9 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000054979969511584491960000003590828152900495035_)"
                      />
                      <linearGradient
                        id="SVGID_00000008863134588973188070000017202086665525755018_"
                        gradientUnits="userSpaceOnUse"
                        x1={1467.6499}
                        y1={442.3409}
                        x2={1467.6499}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1470.1 436.1v6.3h-4.8c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h4.8z"
                        fill="url(#SVGID_00000008863134588973188070000017202086665525755018_)"
                      />
                      <linearGradient
                        id="SVGID_00000033345009629032578160000015231778898845821824_"
                        gradientUnits="userSpaceOnUse"
                        x1={1439.65}
                        y1={442.3409}
                        x2={1439.65}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1439.9 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000033345009629032578160000015231778898845821824_)"
                      />
                      <linearGradient
                        id="SVGID_00000146473571159943235540000004655954724873642921_"
                        gradientUnits="userSpaceOnUse"
                        x1={1449.95}
                        y1={442.3409}
                        x2={1449.95}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1450.2 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000146473571159943235540000004655954724873642921_)"
                      />
                      <linearGradient
                        id="SVGID_00000176031338540845089680000008860725955512042143_"
                        gradientUnits="userSpaceOnUse"
                        x1={1454.75}
                        y1={442.3409}
                        x2={1454.75}
                        y2={439.5656}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1439.4 439.6l4.9.7v2c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-2.7zm5.2.7v2c0 .1 0 .1.1.1h4.7c.1 0 .1 0 .1-.1v-1.8l-2.8.1-2.1-.3zm5.1 2s0 .1 0 0l4.8.1c.1 0 .1 0 .1-.1v-2l-4.9.2v1.8zm5.2 0s0 .1 0 0l4.8.1c.1 0 .1 0 .1-.1v-2.2l-4.9.2v2zm5.1-2.2v2.2c0 .1 0 .1.1.1h4.7c.1 0 .1 0 .1-.1v-2.2h-4.9zm5.2 0v2.2c0 .1 0 .1.1.1h4.8v-2.3h-4.9z"
                        opacity={0.25}
                        fill="url(#SVGID_00000176031338540845089680000008860725955512042143_)"
                        enableBackground="new"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1449.1 436.1L1446.2 442.4 1444.8 442.4 1447.7 436.1z"
                        />
                        <path
                          className="st64"
                          d="M1453.6 442.4l.9-2v1.9c0 .1 0 .1-.1.1h-.8zM1459.8 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-2.5l1.8-3.7 3.1.1c-.1-.1 0-.1 0 0zM1464.9 436.2v6.1c0 .1 0 .1-.1.1h-4.7c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1l4.8.1c-.1-.1 0-.1 0 0zM1468.3 436.1l-2.9 6.3h-.1c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h3z"
                        />
                      </g>
                      <linearGradient
                        id="SVGID_00000049205754837035961610000012799947497786910643_"
                        gradientUnits="userSpaceOnUse"
                        x1={1460.25}
                        y1={442.3409}
                        x2={1460.25}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1460.5 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000049205754837035961610000012799947497786910643_)"
                      />
                      <linearGradient
                        id="SVGID_00000132794402447968504290000001893486808572203157_"
                        gradientUnits="userSpaceOnUse"
                        x1={1465.35}
                        y1={442.3409}
                        x2={1465.35}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1465.6 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000132794402447968504290000001893486808572203157_)"
                      />
                      <linearGradient
                        id="SVGID_00000057133636394079527950000007880018478245280956_"
                        gradientUnits="userSpaceOnUse"
                        x1={1444.85}
                        y1={442.3409}
                        x2={1444.85}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1445.1 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.2-.1 0 0 0 0z"
                        fill="url(#SVGID_00000057133636394079527950000007880018478245280956_)"
                      />
                      <linearGradient
                        id="SVGID_00000054960901321854688260000013630486901333124783_"
                        gradientUnits="userSpaceOnUse"
                        x1={1455.05}
                        y1={442.3409}
                        x2={1455.05}
                        y2={436.0706}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1455.3 442.4h-.4c-.1 0-.1 0-.1-.1v-6.1c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 6.2c-.1-.1 0 0 0 0z"
                        fill="url(#SVGID_00000054960901321854688260000013630486901333124783_)"
                      />
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000090267726578414934230000001032902256713821868_"
                        gradientUnits="userSpaceOnUse"
                        x1={1456.9501}
                        y1={451.9313}
                        x2={1456.9501}
                        y2={444.6046}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={0.2179} stopColor="#9fb4b9" />
                        <stop offset={0.4949} stopColor="#adc0c3" />
                        <stop offset={0.8025} stopColor="#c4d5d6" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        d="M1470.3 444.6l-.4 1.1h-19.1c-1.6 0-3 1.4-3 3v1.5c-1.5.4-2.9.9-4.2 1.6v-7.4h26.7v.2z"
                        fill="url(#SVGID_00000090267726578414934230000001032902256713821868_)"
                      />
                      <path
                        className="st37"
                        d="M1470 445.7l-2.8 8.1h-19.3v-5c0-1.6 1.4-3 3-3h19.1v-.1z"
                      />
                      <path
                        className="st37"
                        d="M1469.6 445.7l-.1.5-2.6 7.5h-14.8v-5c0-1.6 1.4-3 3-3h14.5z"
                      />
                      <path
                        className="st38"
                        d="M1469.4 446.3l-2.7 8.1h-11.1v-5c0-1.6 1.4-3 3-3h10.8v-.1z"
                      />
                      <linearGradient
                        id="SVGID_00000160907616473835351220000010600819901002127541_"
                        gradientUnits="userSpaceOnUse"
                        x1={1448.3501}
                        y1={491.8412}
                        x2={1448.3501}
                        y2={449.8412}
                      >
                        <stop offset={0} stopColor="#79aace" />
                        <stop offset={0.5838} stopColor="#95c9ed" />
                        <stop offset={0.7626} stopColor="#c9e5f8" />
                        <stop offset={0.8631} stopColor="#aedaf5" />
                        <stop offset={1} stopColor="#9cd0f1" />
                      </linearGradient>
                      <path
                        d="M1468.4 449.9l-14.4 42h-25.7c0-9.5 5.6-22.3 8.4-31.3 1.2-3.7 3.6-6.8 6.9-8.6 1.3-.8 2.7-1.3 4.2-1.6 1.2-.2 2.3-.4 3.5-.4l17.1-.1z"
                        fill="url(#SVGID_00000160907616473835351220000010600819901002127541_)"
                      />
                      <linearGradient
                        id="SVGID_00000098207268572449013540000017020028292618996876_"
                        gradientUnits="userSpaceOnUse"
                        x1={1428.3}
                        y1={470.9}
                        x2={1468.4492}
                        y2={470.9}
                      >
                        <stop offset={0} stopColor="#fff" />
                        <stop offset={0.1981} stopColor="#fafbfd" />
                        <stop offset={0.3376} stopColor="#eff1f8" />
                        <stop offset={0.4591} stopColor="#dfe4f1" />
                        <stop offset={0.5703} stopColor="#c9d2e7" />
                        <stop offset={0.6746} stopColor="#aebedc" />
                        <stop offset={0.7737} stopColor="#8fa6d0" />
                        <stop offset={0.8686} stopColor="#6b8fc2" />
                        <stop offset={0.958} stopColor="#3d78b4" />
                        <stop offset={1} stopColor="#166eae" />
                      </linearGradient>
                      <path
                        d="M1468.4 449.9l-14.4 42h-25.7c0-9.5 5.6-22.3 8.4-31.3 1.2-3.7 3.6-6.8 6.9-8.6 1.3-.8 2.7-1.3 4.2-1.6 1.2-.2 2.3-.4 3.5-.4l17.1-.1z"
                        opacity={0.4}
                        fill="url(#SVGID_00000098207268572449013540000017020028292618996876_)"
                        enableBackground="new"
                      />
                      <g className="st41">
                        <path
                          className="st42"
                          d="M1430.6 488.5c.4-3 .9-6 1.5-8.9h.1v.1c-.6 2.8-1.2 5.7-1.6 8.8.1 0 .1 0 0 0zM1452.4 488.5c-.1 0-.1 0 0 0 .4-3 .9-6 1.5-8.9h.1v.1c-.6 2.8-1.1 5.7-1.6 8.8zM1433.6 473.7c-.1 0-.1 0 0 0 .7-3 1.6-6 2.7-9.4h.1v.1c-1 3.4-2 6.4-2.8 9.3zM1455.8 473.7c.7-3 1.6-6 2.7-9.4h.1v.1c-1 3.4-2 6.4-2.8 9.3.1 0 0 0 0 0zM1437.9 460s-.1 0 0 0c-.1-.1-.1-.1 0 0l.2-.8c.8-2.5 2.5-4.4 4.8-6 1.1-.7 2.3-1.2 3.6-1.5 1.3-.4 2.6-.6 4-.6 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.7 0-10.6 3.2-12.3 7.9l-.3.8c0-.1 0 0 0 0zM1459.4 460c0-.1 0-.1 0 0l.2-.8c1.1-3 3.4-5.4 6.5-6.8h.1v.1c-3.2 1.4-5.5 3.7-6.5 6.8l-.3.7c.1-.1 0 0 0 0zM1441.7 488.5c0-.1.5-2.7 1.2-6.3h.1v.1c-.8 3.5-1.2 6-1.3 6.2.1 0 0 0 0 0zM1444.5 474.2c-.1 0-.1 0 0 0 1.2-6.2 2.1-10.6 2.7-13.4h.1v.1c-.7 2.7-1.7 7.2-2.8 13.3zM1450.8 454.3c0-.1 0-.1 0 0 1.5-1.3 3.2-1.9 4.3-2.2 1.3-.4 2.1-.5 2.1-.5h.1v.1s-.9.1-2.1.5c-1.1.3-2.9 1-4.4 2.1.1 0 .1 0 0 0z"
                        />
                        <path
                          className="st35"
                          d="M1446 490c-.1 0-.1 0 0 0 .1-1.4 1.1-5.5 2.7-12.4h.1v.1c-1.6 6.8-2.6 11-2.8 12.3zM1450.5 469.6s0-.1 0 0c.4-1.8.7-3.5 1.2-5.4h.1v.1c-.3 1.8-.8 3.6-1.3 5.3.2 0 .2 0 0 0zM1453.1 459.2c-.1 0-.1 0 0 0 .5-1.6 1.2-3 2.1-4.1.8-.9 1.6-1.6 2.7-2.2 1.8-.9 3.2-1.1 3.3-1.1h.1v.1s-1.5.1-3.2 1.1c-1.7.9-3.8 2.7-5 6.2zM1436.3 490c0-.7.4-2 .6-3.7h.1v.1c-.2 1.6-.5 2.9-.7 3.6.1 0 .1 0 0 0zM1438.3 480.3c-.1 0-.1 0 0 0 .4-1.9.7-3.6 1.1-5.4h.1v.1c-.4 1.6-.9 3.5-1.2 5.3z"
                        />
                      </g>
                      <g>
                        <linearGradient
                          id="SVGID_00000178169823147702137260000002052774496082285452_"
                          gradientUnits="userSpaceOnUse"
                          x1={1440.85}
                          y1={491.8637}
                          x2={1440.85}
                          y2={482.6934}
                        >
                          <stop offset={0} stopColor="#b8ddf5" />
                          <stop offset={0.6005} stopColor="#d8edfa" />
                          <stop offset={1} stopColor="#e7f6fd" />
                        </linearGradient>
                        <path
                          d="M1454.9 489.3l-.8 2.6h-26.4c-.6-.6-.9-1.4-.9-2.5v-.1c.1-1.6 1.2-2.9 2.6-2.9.5 0 .9.1 1.3.4.1-.1.1-.4.2-.5.6-.8 1.4-1.6 2.6-2.1 1.8-.8 3.6-.8 4.7 0 .4-.6.9-1.2 1.6-1.3 1.2-.4 2.5.2 3.3 1.3.1-.2.4-.5.6-.6v5.7h11.2z"
                          fill="url(#SVGID_00000178169823147702137260000002052774496082285452_)"
                        />
                        <path
                          className="st44"
                          d="M1429.7 491.8h-.6c-.1-.4-.2-.7-.2-1.1 0-.5 0-1.1.2-1.5.1-.4.4-.6.6-.8-.1.2-.2.6-.4.8-.1.4-.1.7-.1 1.1s.1.7.4 1.1c0 .2 0 .3.1.4zM1447.7 485.3c-.4-.1-.6-.1-.9-.1-1.1 0-2.1.4-2.9 1.1 0-.1 0-.2-.1-.4.7-.5 1.6-.8 2.6-.8.4 0 .9.1 1.3.2zM1451.2 487.9l-.2.2c-.2-.5-.5-.9-.8-1.4-.2-.2-.6-.6-.9-.7-.1-.1-.2-.1-.4-.2.2.1.5.2.7.4.4.2.6.5.9.7.4.3.6.6.7 1zM1450.2 489.3c-.2.5-.4.9-.4 1.5 0 .2 0 .6.1.8 0 .1 0 .1.1.2h-6.7c.2-.4.4-.7.4-1.1 0-.6-.4-1.2-.8-1.5.1 0 .1.1.2.1.6.4.9.9.9 1.6 0 .4.2.6.6.6h4.9v-.4c.1-.5.2-1.2.7-1.8 0-.1.1-.2.1-.2-.1.1-.1.2-.1.2zM1441 490v.2c0 .6-.2 1.2-.5 1.6h-6.4c-.2-.5-.4-1.1-.4-1.8 0-.4 0-.6.1-.8.1-.4.2-.7.4-1.1.1-.1.1-.2.2-.4.1-.1.1-.2.2-.4-.1.1-.1.2-.2.4-.2.5-.4.9-.5 1.4v.6c0 .8.7 1.5 1.6 1.5h4.6c.2-.5.4-.9.4-1.5v-.2-.5-.2c-.1-.9-.7-1.6-1.3-2.2-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.4-.1c.2 0 .4.1.6.2.1-.5 0-1.1-.1-1.4-.2-.4-.5-.7-.8-.9.5.2.9.6 1.2 1.2.2.5.2.9.1 1.5.8.5 1.4 1.3 1.6 2.2v1zM1431.7 487.9c-.5-.9-1.3-1.2-1.3-1.2.1-.1.1-.4.2-.5.7.4 1.1 1.1 1.1 1.7z"
                        />
                        <g>
                          <defs>
                            <path
                              id="SVGID_00000008144809214065477150000008268275495971849403_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <clipPath id="SVGID_00000008847111421585263480000014650876959370591659_">
                            <use
                              xlinkHref="#SVGID_00000008144809214065477150000008268275495971849403_"
                              overflow="visible"
                            />
                          </clipPath>
                          <defs>
                            <path
                              id="SVGID_00000029022084780302098940000009316646773391904156_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000176743233421064256520000018355052759779720069_"
                              d="M288.6 45L287.4 45 288.6 43.8z"
                            />
                          </defs>
                          <clipPath id="SVGID_00000106133955166912117450000014647331425858192817_">
                            <use
                              xlinkHref="#SVGID_00000029022084780302098940000009316646773391904156_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000142878888261895613720000013346224894658554546_"
                            clipPath="url(#SVGID_00000106133955166912117450000014647331425858192817_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000176743233421064256520000018355052759779720069_"
                              overflow="visible"
                            />
                          </clipPath>
                          <defs>
                            <filter
                              id="Adobe_OpacityMaskFilter_00000116194953291714629530000007582937475883503289_"
                              filterUnits="userSpaceOnUse"
                              x={1423.7}
                              y={477}
                              width={37.8}
                              height={14.9}
                            >
                              <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                            </filter>
                          </defs>
                          <mask
                            maskUnits="userSpaceOnUse"
                            x={1423.7}
                            y={477}
                            width={37.8}
                            height={14.9}
                            id="SVGID_00000034075161444305284000000012661179462443225021_"
                          >
                            <g filter="url(#Adobe_OpacityMaskFilter_00000116194953291714629530000007582937475883503289_)">
                              <defs>
                                <path
                                  id="SVGID_00000003819153222798263040000016856940090775197616_"
                                  d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                />
                              </defs>
                              <defs>
                                <path
                                  id="SVGID_00000016785264932810121280000000613414233750101421_"
                                  d="M288.6 45L287.4 45 288.6 43.8z"
                                />
                              </defs>
                              <clipPath
                                id="SVGID_00000110449369093320633050000001658394937218834840_"
                                clipPath="url(#SVGID_00000142878888261895613720000013346224894658554546_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000003819153222798263040000016856940090775197616_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <clipPath
                                id="SVGID_00000027568173101550550070000006573296270753161114_"
                                clipPath="url(#SVGID_00000110449369093320633050000001658394937218834840_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000016785264932810121280000000613414233750101421_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000052826051321938513540000000115996879035297693_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000163074233495675800840000017213791905278728374_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000183222396020933412820000012365875369347079328_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000083046492764241538460000011269527708538970801_"
                                  clipPath="url(#SVGID_00000142878888261895613720000013346224894658554546_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000052826051321938513540000000115996879035297693_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000109740491512275627260000000201087809031412150_"
                                  clipPath="url(#SVGID_00000083046492764241538460000011269527708538970801_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000163074233495675800840000017213791905278728374_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000150061046810486110550000004119806163670276789_"
                                  clipPath="url(#SVGID_00000109740491512275627260000000201087809031412150_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000183222396020933412820000012365875369347079328_"
                                    overflow="visible"
                                  />
                                </clipPath>
                              </g>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000082328981353549705560000012759558966048294531_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000013163770970816270870000018137608000834404275_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000074437940728065292040000014736927658926401202_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000011008939972686713610000008853862708694020996_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000018916967256691343310000013785496854421088175_"
                                  clipPath="url(#SVGID_00000142878888261895613720000013346224894658554546_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000082328981353549705560000012759558966048294531_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000147204802517807104820000003136987075782138282_"
                                  clipPath="url(#SVGID_00000018916967256691343310000013785496854421088175_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000013163770970816270870000018137608000834404275_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000006692046631234054470000000057620537645454984_"
                                  clipPath="url(#SVGID_00000147204802517807104820000003136987075782138282_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000074437940728065292040000014736927658926401202_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000046304273512560574490000014630720968874368898_"
                                  clipPath="url(#SVGID_00000006692046631234054470000000057620537645454984_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000011008939972686713610000008853862708694020996_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <linearGradient
                                  id="SVGID_00000176733490420427035560000003499805113948083333_"
                                  gradientUnits="userSpaceOnUse"
                                  x1={1442.6}
                                  y1={491.8637}
                                  x2={1442.6}
                                  y2={477.5794}
                                >
                                  <stop offset={0} stopColor="#fff" />
                                  <stop offset={1} />
                                </linearGradient>
                                <path
                                  d="M1461.5 488.5c0 1.4-.8 2.7-2 3.4h-1.3v-.4c0-1.5-1.3-3.3-2.8-4.1 0 0-.1 0-.1-.1-.6-.2-1.2-.5-1.6-.5s-.7 0-1.1.1c.1-.2.1-.5.1-.7 0-1.1-.8-2-2-2-.8 0-1.5.6-1.9 1.3-.4-.2-.8-.4-1.3-.5-.4-1.1-1.4-2-2.6-2-.6 0-1.1.1-1.5.2v5.7h11.3l-.8 2.6h-28.2c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-3.2 2.6-5.7 5.7-5.7 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3h.1c.4-.1.8-.2 1.2-.2 2.3.6 4 2.3 4 4.5z"
                                  clipPath="url(#SVGID_00000046304273512560574490000014630720968874368898_)"
                                  fill="url(#SVGID_00000176733490420427035560000003499805113948083333_)"
                                />
                              </g>
                            </g>
                          </mask>
                          <linearGradient
                            id="SVGID_00000165927540630329425640000009350369869107993766_"
                            gradientUnits="userSpaceOnUse"
                            x1={1442.6}
                            y1={491.8637}
                            x2={1442.6}
                            y2={477.5794}
                          >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={1} />
                          </linearGradient>
                          <path
                            d="M1461.5 488.5c0 1.4-.8 2.7-2 3.4h-1.3v-.4c0-1.5-1.3-3.3-2.8-4.1 0 0-.1 0-.1-.1-.6-.2-1.2-.5-1.6-.5s-.7 0-1.1.1c.1-.2.1-.5.1-.7 0-1.1-.8-2-2-2-.8 0-1.5.6-1.9 1.3-.4-.2-.8-.4-1.3-.5-.4-1.1-1.4-2-2.6-2-.6 0-1.1.1-1.5.2v5.7h11.3l-.8 2.6h-28.2c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-3.2 2.6-5.7 5.7-5.7 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3h.1c.4-.1.8-.2 1.2-.2 2.3.6 4 2.3 4 4.5z"
                            clipPath="url(#SVGID_00000142878888261895613720000013346224894658554546_)"
                            mask="url(#SVGID_00000034075161444305284000000012661179462443225021_)"
                            fill="url(#SVGID_00000165927540630329425640000009350369869107993766_)"
                          />
                          <linearGradient
                            id="SVGID_00000133508095281831658850000015515062915985319831_"
                            gradientUnits="userSpaceOnUse"
                            x1={1442.6}
                            y1={491.8637}
                            x2={1442.6}
                            y2={477.5794}
                          >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={1} stopColor="#9cd0f1" />
                          </linearGradient>
                          <path
                            d="M1461.5 488.5c0 1.4-.8 2.7-2 3.4h-1.3v-.4c0-1.5-1.3-3.3-2.8-4.1 0 0-.1 0-.1-.1-.6-.2-1.2-.5-1.6-.5s-.7 0-1.1.1c.1-.2.1-.5.1-.7 0-1.1-.8-2-2-2-.8 0-1.5.6-1.9 1.3-.4-.2-.8-.4-1.3-.5-.4-1.1-1.4-2-2.6-2-.6 0-1.1.1-1.5.2v5.7h11.3l-.8 2.6h-28.2c-.9-.6-1.6-1.4-1.9-2.6 0-.2-.1-.6-.1-.8 0-1.8 1.2-3.2 2.7-3.7v-.7c0-3.2 2.6-5.7 5.7-5.7 1.1 0 2.1.4 3 .8.8-1.1 2.1-1.8 3.6-1.8 1.8 0 3.2.9 4 2.3.2-.1.5-.1.8-.2h.7c1.6 0 3 .7 4 1.9.8-.7 1.9-1.1 3-1.1 2.6 0 4.7 1.9 5 4.3h.1c.4-.1.8-.2 1.2-.2 2.3.6 4 2.3 4 4.5z"
                            opacity={0.5}
                            fill="url(#SVGID_00000133508095281831658850000015515062915985319831_)"
                            enableBackground="new"
                          />
                          <g className="st57">
                            <path
                              className="st11"
                              d="M1430.8 483.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c0-.2.2 0 .2.2z"
                            />
                            <circle
                              className="st11"
                              cx={1426.8}
                              cy={489.5}
                              r={0.2}
                            />
                            <path
                              className="st11"
                              d="M1438.3 479.8c0 .1-.1.1-.1.1l-.1-.1.1-.1.1.1zM1434.2 480.5c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1445.8 482.4c-.1.1-.1 0 0 0-.1 0-.2-.1 0 0 0-.1 0 0 0 0zM1448.8 483.7c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1443.2 480.5s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1436.1 482c-.1.1-.1 0 0 0-.2-.1-.2-.1 0 0 0-.1 0-.1 0 0zM1424.8 487.9c-.1.1-.1 0 0 0-.1-.1 0-.1 0 0 0-.1 0-.1 0 0zM1430.3 480.9c-.1.1-.1 0 0 0-.1-.2-.1-.2 0 0 0-.2 0-.2 0 0zM1429.6 485.5c0 .1-.1.1 0 0-.1.1-.1 0 0 0-.2 0-.1 0 0 0-.1 0 0 0 0 0z"
                            />
                            <circle
                              className="st11"
                              cx={1449.5}
                              cy={481.7}
                              r={0.1}
                            />
                            <circle
                              className="st11"
                              cx={1453.9}
                              cy={482.4}
                              r={0.1}
                            />
                            <path
                              className="st11"
                              d="M1452.3 481.3s-.1 0 0 0c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0-.1-.1 0 0 0 0zM1454.4 485.4s0 .1 0 0c-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1457.4 485.3c-.1.1-.1 0 0 0-.1 0-.1-.1 0 0 0-.1 0-.1 0 0zM1457.7 488.2c-.1.1-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zM1459.7 490.3c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.2 0-.2 0 0 0zM1459 491.3c0 .1 0 .1 0 0-.2.1-.2.1 0 0-.2 0-.2 0 0 0z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000165932712206054328880000009696037748411454849_"
                        gradientUnits="userSpaceOnUse"
                        x1={1470.0154}
                        y1={439.05}
                        x2={1485.2683}
                        y2={439.05}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000165932712206054328880000009696037748411454849_)"
                        d="M1470.1 433.5H1485.3V444.6H1470.1z"
                      />
                      <linearGradient
                        id="SVGID_00000088091894244613611240000006754274965659074231_"
                        gradientUnits="userSpaceOnUse"
                        x1={1469.7}
                        y1={491.8}
                        x2={1469.7}
                        y2={444.6}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000088091894244613611240000006754274965659074231_)"
                        d="M1485.3 444.6L1485.3 491.8 1454.1 491.8 1454.9 489.3 1455.5 487.5 1456.4 484.8 1470.1 444.6z"
                      />
                      <linearGradient
                        id="SVGID_00000102540620673809981480000015827153152702779039_"
                        gradientUnits="userSpaceOnUse"
                        x1={1485.2628}
                        y1={468.2}
                        x2={1499.5629}
                        y2={468.2}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#b6c5c7" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000102540620673809981480000015827153152702779039_)"
                        d="M1485.3 444.6H1499.6V491.8H1485.3z"
                      />
                      <linearGradient
                        id="SVGID_00000167370209794192954280000014785670307430161550_"
                        gradientUnits="userSpaceOnUse"
                        x1={1485.2628}
                        y1={439.05}
                        x2={1499.5629}
                        y2={439.05}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#b6c5c7" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000167370209794192954280000014785670307430161550_)"
                        d="M1485.3 433.5H1499.6V444.6H1485.3z"
                      />
                    </g>
                    <g>
                      <path
                        className="st64"
                        d="M1483.7 441.6h-12.3c-.4 0-.6-.2-.6-.6v-4.3c0-.4.2-.6.6-.6h12.3c.4 0 .6.2.6.6v4.3c.1.3-.2.6-.6.6z"
                      />
                      <linearGradient
                        id="SVGID_00000101089450653842206820000014789886753286044351_"
                        gradientUnits="userSpaceOnUse"
                        x1={1471.1361}
                        y1={438.85}
                        x2={1484.1479}
                        y2={438.85}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1484.1 436.4v4.9s0 .1-.1.1h-12.9s-.1 0-.1-.1v-4.9s0-.1.1-.1l13 .1c0-.1 0-.1 0 0z"
                        fill="url(#SVGID_00000101089450653842206820000014789886753286044351_)"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1475.3 436.3L1473.7 441.3 1472.3 441.3 1473.9 436.3z"
                        />
                        <path
                          className="st64"
                          d="M1483.3 436.3L1481.6 441.3 1478.1 441.3 1479.8 436.3z"
                        />
                      </g>
                      <path
                        className="st93"
                        d="M1484.1 438.8v2.6s0 .1-.1.1h-12.9s-.1 0-.1-.1v-1.6h7.9l5.2-1z"
                      />
                      <linearGradient
                        id="SVGID_00000106135185092148344040000006238599519994648754_"
                        gradientUnits="userSpaceOnUse"
                        x1={1471.35}
                        y1={441.3922}
                        x2={1471.35}
                        y2={436.3094}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1471.6 441.3h-.4c-.1 0-.1 0-.1-.1v-4.9c0-.1 0-.1.1-.1h.4c-.1 0-.1 0-.1.1l.1 5z"
                        fill="url(#SVGID_00000106135185092148344040000006238599519994648754_)"
                      />
                    </g>
                    <g>
                      <linearGradient
                        id="SVGID_00000161592730499809272080000002047333093671364505_"
                        gradientUnits="userSpaceOnUse"
                        x1={1488.5}
                        y1={491.8412}
                        x2={1488.5}
                        y2={455.5486}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.04567565} stopColor="#708eb0" />
                        <stop offset={0.1285} stopColor="#819ebc" />
                        <stop offset={0.2263} stopColor="#8eacc6" />
                        <stop offset={0.3474} stopColor="#98b6ce" />
                        <stop offset={0.5173} stopColor="#9ebcd2" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000161592730499809272080000002047333093671364505_)"
                        d="M1482 455.6H1495V491.8H1482z"
                      />
                      <linearGradient
                        id="SVGID_00000173153429977673619490000002390134259354399397_"
                        gradientUnits="userSpaceOnUse"
                        x1={1499.6}
                        y1={491.8412}
                        x2={1499.6}
                        y2={456.4412}
                      >
                        <stop offset={0} stopColor="#4c7099" />
                        <stop offset={0.03787671} stopColor="#57789f" />
                        <stop offset={0.1214} stopColor="#6987a8" />
                        <stop offset={0.2201} stopColor="#7694b1" />
                        <stop offset={0.3421} stopColor="#809eb8" />
                        <stop offset={0.5134} stopColor="#86a4bb" />
                        <stop offset={0.9888} stopColor="#88a6bd" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000173153429977673619490000002390134259354399397_)"
                        d="M1495 456.4H1504.2V491.79999999999995H1495z"
                      />
                      <path
                        className="st64"
                        d="M1493.2 488.3h-9.6c-.6 0-.9-.5-.9-.9v-26.9c0-.6.5-.9.9-.9h9.6c.6 0 .9.5.9.9v26.9c.2.5-.3.9-.9.9z"
                      />
                      <path
                        d="M1483.6 488.1h-.5c-.1 0-.2-.1-.2-.2v-27.7c0-.1.1-.2.2-.2h.5c-.1 0-.2.1-.2.2v27.7c-.1 0 .1.2.2.2z"
                        fill="#708eb1"
                      />
                      <linearGradient
                        id="SVGID_00000057829622797907560020000012145890502549088912_"
                        gradientUnits="userSpaceOnUse"
                        x1={1479.0216}
                        y1={483.5786}
                        x2={1498.3441}
                        y2={464.2559}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.1335} stopColor="#7593b4" />
                        <stop offset={0.3093} stopColor="#87a5c1" />
                        <stop offset={0.499} stopColor="#95b2cb" />
                        <stop offset={0.7106} stopColor="#9dbbd1" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        d="M1494 460v27.7c0 .1-.1.2-.2.2h-10.1c-.1 0-.2-.1-.2-.2V460c0-.1.1-.2.2-.2h10.1c0-.1.2 0 .2.2z"
                        fill="url(#SVGID_00000057829622797907560020000012145890502549088912_)"
                      />
                      <path
                        className="st64"
                        d="M1482.9 461.6H1494V462H1482.9z"
                      />
                      <path
                        className="st64"
                        d="M1482.9 466.5H1494V466.9H1482.9z"
                      />
                      <path
                        className="st64"
                        d="M1482.9 471.3H1494V471.7H1482.9z"
                      />
                      <path
                        className="st64"
                        d="M1482.9 476.2H1494V476.59999999999997H1482.9z"
                      />
                      <path
                        className="st64"
                        d="M1482.9 481H1494V481.4H1482.9z"
                      />
                      <path
                        className="st64"
                        d="M1482.9 485.9H1494V486.29999999999995H1482.9z"
                      />
                      <linearGradient
                        id="SVGID_00000007393914837124904250000007344161829264305335_"
                        gradientUnits="userSpaceOnUse"
                        x1={1497.8}
                        y1={456.4234}
                        x2={1497.8}
                        y2={455.571}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        d="M1504.4 456.4h-13.2c-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5h13.2c.2 0 .5.2.5.5s-.2.5-.5.5z"
                        fill="url(#SVGID_00000007393914837124904250000007344161829264305335_)"
                      />
                      <linearGradient
                        id="SVGID_00000109715522642190123080000011361174645277631662_"
                        gradientUnits="userSpaceOnUse"
                        x1={1488.4}
                        y1={456.4234}
                        x2={1488.4}
                        y2={455.571}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        d="M1495 456.4h-13.2c-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5h13.2c.2 0 .5.2.5.5-.1.3-.3.5-.5.5z"
                        fill="url(#SVGID_00000109715522642190123080000011361174645277631662_)"
                      />
                      <g className="st57">
                        <path
                          className="st64"
                          d="M1487.2 459.7L1483.3 472.1 1483.3 468.5 1486.1 459.7z"
                        />
                        <path
                          className="st64"
                          d="M1494 460v12.6l-4.8 15.4h-4.9l8.9-28.3h.5c.1 0 .3.1.3.3z"
                        />
                      </g>
                      <g>
                        <defs>
                          <path
                            id="SVGID_00000181807851081624818350000013622434714228540327_"
                            d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                          />
                        </defs>
                        <clipPath id="SVGID_00000026856650044116289550000016363011094922092470_">
                          <use
                            xlinkHref="#SVGID_00000181807851081624818350000013622434714228540327_"
                            overflow="visible"
                          />
                        </clipPath>
                        <g>
                          <defs>
                            <path
                              id="SVGID_00000052824016662757695330000007167467430367618712_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000164513946736174892910000007051353050206255261_"
                              d="M288.6 45L287.4 45 288.6 43.8z"
                            />
                          </defs>
                          <clipPath id="SVGID_00000160889010807845559280000009714761594267371414_">
                            <use
                              xlinkHref="#SVGID_00000052824016662757695330000007167467430367618712_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000063595008923196231040000005568427670538130818_"
                            clipPath="url(#SVGID_00000160889010807845559280000009714761594267371414_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000164513946736174892910000007051353050206255261_"
                              overflow="visible"
                            />
                          </clipPath>
                          <defs>
                            <filter
                              id="Adobe_OpacityMaskFilter_00000106128675900641558340000005547930321767942840_"
                              filterUnits="userSpaceOnUse"
                              x={1482}
                              y={456.4}
                              width={13}
                              height={0.8}
                            >
                              <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                            </filter>
                          </defs>
                          <mask
                            maskUnits="userSpaceOnUse"
                            x={1482}
                            y={456.4}
                            width={13}
                            height={0.8}
                            id="SVGID_00000034057098909902340800000013250690343892848007_"
                          >
                            <g filter="url(#Adobe_OpacityMaskFilter_00000106128675900641558340000005547930321767942840_)">
                              <defs>
                                <path
                                  id="SVGID_00000151517478617020001080000013937766562206115493_"
                                  d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                />
                              </defs>
                              <defs>
                                <path
                                  id="SVGID_00000004535221158288397950000002503777390870832550_"
                                  d="M288.6 45L287.4 45 288.6 43.8z"
                                />
                              </defs>
                              <clipPath
                                id="SVGID_00000182485957641674220550000008827371865451525763_"
                                clipPath="url(#SVGID_00000063595008923196231040000005568427670538130818_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000151517478617020001080000013937766562206115493_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <clipPath
                                id="SVGID_00000004539300938575548210000016666869549738985623_"
                                clipPath="url(#SVGID_00000182485957641674220550000008827371865451525763_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000004535221158288397950000002503777390870832550_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000131337977209355400620000009419822059113652887_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000149351924913866069400000010849475220232057764_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000120560101400678378990000012768842172192376469_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000165232550000083025440000013111499141687607940_"
                                  clipPath="url(#SVGID_00000063595008923196231040000005568427670538130818_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000131337977209355400620000009419822059113652887_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000157306712980537235560000007642305973912711603_"
                                  clipPath="url(#SVGID_00000165232550000083025440000013111499141687607940_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000149351924913866069400000010849475220232057764_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000106845191144422781510000015197443284898146435_"
                                  clipPath="url(#SVGID_00000157306712980537235560000007642305973912711603_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000120560101400678378990000012768842172192376469_"
                                    overflow="visible"
                                  />
                                </clipPath>
                              </g>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000116952058355103403890000004999916806787174544_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000063597079615710138820000002611935653531398820_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000101809821004207091290000015256169964801806507_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000127010949909813830000000015671924503871782032_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000001640257942161580600000014494317282549161614_"
                                  clipPath="url(#SVGID_00000063595008923196231040000005568427670538130818_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000116952058355103403890000004999916806787174544_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000061470023752812272990000001350325363174733501_"
                                  clipPath="url(#SVGID_00000001640257942161580600000014494317282549161614_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000063597079615710138820000002611935653531398820_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000126304060203104962970000011778533010443854737_"
                                  clipPath="url(#SVGID_00000061470023752812272990000001350325363174733501_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000101809821004207091290000015256169964801806507_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000082348320174909043990000009119267421577473711_"
                                  clipPath="url(#SVGID_00000126304060203104962970000011778533010443854737_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000127010949909813830000000015671924503871782032_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <linearGradient
                                  id="SVGID_00000110435140426215796690000005497963603841420467_"
                                  gradientUnits="userSpaceOnUse"
                                  x1={1488.5}
                                  y1={456.4234}
                                  x2={1488.5}
                                  y2={457.2013}
                                >
                                  <stop offset={0} stopColor="#fff" />
                                  <stop offset={0.1185} stopColor="#c6c6c6" />
                                  <stop offset={0.2417} stopColor="#929292" />
                                  <stop offset={0.3671} stopColor="#656565" />
                                  <stop offset={0.4923} stopColor="#414141" />
                                  <stop offset={0.6171} stopColor="#242424" />
                                  <stop offset={0.7416} stopColor="#101010" />
                                  <stop offset={0.8656} stopColor="#040404" />
                                  <stop offset={0.9888} />
                                </linearGradient>
                                <path
                                  clipPath="url(#SVGID_00000082348320174909043990000009119267421577473711_)"
                                  fill="url(#SVGID_00000110435140426215796690000005497963603841420467_)"
                                  d="M1482 456.4H1495V457.2H1482z"
                                />
                              </g>
                            </g>
                          </mask>
                          <linearGradient
                            id="SVGID_00000036218814384405039960000008953675361080034455_"
                            gradientUnits="userSpaceOnUse"
                            x1={1488.5}
                            y1={456.4234}
                            x2={1488.5}
                            y2={457.2013}
                          >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={0.1185} stopColor="#c6c6c6" />
                            <stop offset={0.2417} stopColor="#929292" />
                            <stop offset={0.3671} stopColor="#656565" />
                            <stop offset={0.4923} stopColor="#414141" />
                            <stop offset={0.6171} stopColor="#242424" />
                            <stop offset={0.7416} stopColor="#101010" />
                            <stop offset={0.8656} stopColor="#040404" />
                            <stop offset={0.9888} />
                          </linearGradient>
                          <path
                            clipPath="url(#SVGID_00000063595008923196231040000005568427670538130818_)"
                            mask="url(#SVGID_00000034057098909902340800000013250690343892848007_)"
                            fill="url(#SVGID_00000036218814384405039960000008953675361080034455_)"
                            d="M1482 456.4H1495V457.2H1482z"
                          />
                        </g>
                      </g>
                      <linearGradient
                        id="SVGID_00000015334351983673782340000015458049609950189478_"
                        gradientUnits="userSpaceOnUse"
                        x1={1488.5}
                        y1={456.4234}
                        x2={1488.5}
                        y2={457.2013}
                      >
                        <stop offset={0} stopColor="#4c7099" />
                        <stop offset={0.05276774} stopColor="#53749c" />
                        <stop offset={0.2868} stopColor="#6a88a9" />
                        <stop offset={0.5217} stopColor="#7a98b3" />
                        <stop offset={0.7559} stopColor="#84a2ba" />
                        <stop offset={0.9888} stopColor="#88a6bd" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000015334351983673782340000015458049609950189478_)"
                        d="M1482 456.4H1495V457.2H1482z"
                      />
                      <g>
                        <defs>
                          <path
                            id="SVGID_00000075130810421648200620000013125013136202832059_"
                            d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                          />
                        </defs>
                        <clipPath id="SVGID_00000025427274620717137730000001917171764791594888_">
                          <use
                            xlinkHref="#SVGID_00000075130810421648200620000013125013136202832059_"
                            overflow="visible"
                          />
                        </clipPath>
                        <g>
                          <defs>
                            <path
                              id="SVGID_00000137816292078491582060000009406818165924406190_"
                              d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                            />
                          </defs>
                          <defs>
                            <path
                              id="SVGID_00000147213176273047665150000017235119670197220276_"
                              d="M288.6 45L287.4 45 288.6 43.8z"
                            />
                          </defs>
                          <clipPath id="SVGID_00000165198229090019909560000004227356697884090008_">
                            <use
                              xlinkHref="#SVGID_00000137816292078491582060000009406818165924406190_"
                              overflow="visible"
                            />
                          </clipPath>
                          <clipPath
                            id="SVGID_00000086664829254374875880000000303755786687317689_"
                            clipPath="url(#SVGID_00000165198229090019909560000004227356697884090008_)"
                          >
                            <use
                              xlinkHref="#SVGID_00000147213176273047665150000017235119670197220276_"
                              overflow="visible"
                            />
                          </clipPath>
                          <defs>
                            <filter
                              id="Adobe_OpacityMaskFilter_00000142859271310509350750000004911970582740537748_"
                              filterUnits="userSpaceOnUse"
                              x={1495}
                              y={456.4}
                              width={9.2}
                              height={0.8}
                            >
                              <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                            </filter>
                          </defs>
                          <mask
                            maskUnits="userSpaceOnUse"
                            x={1495}
                            y={456.4}
                            width={9.2}
                            height={0.8}
                            id="SVGID_00000156579233409204639560000014861384269060722327_"
                          >
                            <g filter="url(#Adobe_OpacityMaskFilter_00000142859271310509350750000004911970582740537748_)">
                              <defs>
                                <path
                                  id="SVGID_00000132777075198718426120000010011188251656934822_"
                                  d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                />
                              </defs>
                              <defs>
                                <path
                                  id="SVGID_00000072985878098052004250000002918049550889025947_"
                                  d="M288.6 45L287.4 45 288.6 43.8z"
                                />
                              </defs>
                              <clipPath
                                id="SVGID_00000044170097894292218230000009294910402729583503_"
                                clipPath="url(#SVGID_00000086664829254374875880000000303755786687317689_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000132777075198718426120000010011188251656934822_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <clipPath
                                id="SVGID_00000074420901553130297840000014703099649616237958_"
                                clipPath="url(#SVGID_00000044170097894292218230000009294910402729583503_)"
                              >
                                <use
                                  xlinkHref="#SVGID_00000072985878098052004250000002918049550889025947_"
                                  overflow="visible"
                                />
                              </clipPath>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000182508220911541975190000014773120517446268289_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000006688611255523125120000013400043497940427421_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000098917838096563367010000014972471357478896268_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000173879111040479978720000001564218178638847678_"
                                  clipPath="url(#SVGID_00000086664829254374875880000000303755786687317689_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000182508220911541975190000014773120517446268289_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000029762959631675564470000009586324059126975917_"
                                  clipPath="url(#SVGID_00000173879111040479978720000001564218178638847678_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000006688611255523125120000013400043497940427421_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000039837768021719888770000011378555153694995590_"
                                  clipPath="url(#SVGID_00000029762959631675564470000009586324059126975917_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000098917838096563367010000014972471357478896268_"
                                    overflow="visible"
                                  />
                                </clipPath>
                              </g>
                              <g>
                                <defs>
                                  <path
                                    id="SVGID_00000039814829907939414170000015824835742769966730_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000127037587644813448710000005659271310588333995_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000152985718046206899130000000998750912643997317_"
                                    d="M290.9 47.3L292.1 47.3 290.9 48.5z"
                                  />
                                </defs>
                                <defs>
                                  <path
                                    id="SVGID_00000067934657504833267260000003421602413288044190_"
                                    d="M288.6 45L287.4 45 288.6 43.8z"
                                  />
                                </defs>
                                <clipPath
                                  id="SVGID_00000118373802976433980490000001105389129797260471_"
                                  clipPath="url(#SVGID_00000086664829254374875880000000303755786687317689_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000039814829907939414170000015824835742769966730_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000103970137068475172820000013734148221953433523_"
                                  clipPath="url(#SVGID_00000118373802976433980490000001105389129797260471_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000127037587644813448710000005659271310588333995_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000141424152503319106540000009900525247782657965_"
                                  clipPath="url(#SVGID_00000103970137068475172820000013734148221953433523_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000152985718046206899130000000998750912643997317_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <clipPath
                                  id="SVGID_00000044171575697609239990000011964237578084181689_"
                                  clipPath="url(#SVGID_00000141424152503319106540000009900525247782657965_)"
                                >
                                  <use
                                    xlinkHref="#SVGID_00000067934657504833267260000003421602413288044190_"
                                    overflow="visible"
                                  />
                                </clipPath>
                                <linearGradient
                                  id="SVGID_00000173874578306085754330000009141674210041139134_"
                                  gradientUnits="userSpaceOnUse"
                                  x1={1499.6}
                                  y1={456.4234}
                                  x2={1499.6}
                                  y2={457.2013}
                                >
                                  <stop offset={0} stopColor="#fff" />
                                  <stop offset={0.1185} stopColor="#c6c6c6" />
                                  <stop offset={0.2417} stopColor="#929292" />
                                  <stop offset={0.3671} stopColor="#656565" />
                                  <stop offset={0.4923} stopColor="#414141" />
                                  <stop offset={0.6171} stopColor="#242424" />
                                  <stop offset={0.7416} stopColor="#101010" />
                                  <stop offset={0.8656} stopColor="#040404" />
                                  <stop offset={0.9888} />
                                </linearGradient>
                                <path
                                  clipPath="url(#SVGID_00000044171575697609239990000011964237578084181689_)"
                                  fill="url(#SVGID_00000173874578306085754330000009141674210041139134_)"
                                  d="M1495 456.4H1504.2V457.2H1495z"
                                />
                              </g>
                            </g>
                          </mask>
                          <linearGradient
                            id="SVGID_00000101089586708707172880000007785026142208393897_"
                            gradientUnits="userSpaceOnUse"
                            x1={1499.6}
                            y1={456.4234}
                            x2={1499.6}
                            y2={457.2013}
                          >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={0.1185} stopColor="#c6c6c6" />
                            <stop offset={0.2417} stopColor="#929292" />
                            <stop offset={0.3671} stopColor="#656565" />
                            <stop offset={0.4923} stopColor="#414141" />
                            <stop offset={0.6171} stopColor="#242424" />
                            <stop offset={0.7416} stopColor="#101010" />
                            <stop offset={0.8656} stopColor="#040404" />
                            <stop offset={0.9888} />
                          </linearGradient>
                          <path
                            clipPath="url(#SVGID_00000086664829254374875880000000303755786687317689_)"
                            mask="url(#SVGID_00000156579233409204639560000014861384269060722327_)"
                            fill="url(#SVGID_00000101089586708707172880000007785026142208393897_)"
                            d="M1495 456.4H1504.2V457.2H1495z"
                          />
                        </g>
                      </g>
                      <linearGradient
                        id="SVGID_00000160160946001160891470000002531314534358264481_"
                        gradientUnits="userSpaceOnUse"
                        x1={1499.6}
                        y1={456.4234}
                        x2={1499.6}
                        y2={457.2013}
                      >
                        <stop offset={0} stopColor="#4c7099" />
                        <stop offset={0.05276774} stopColor="#53749c" />
                        <stop offset={0.2868} stopColor="#6a88a9" />
                        <stop offset={0.5217} stopColor="#7a98b3" />
                        <stop offset={0.7559} stopColor="#84a2ba" />
                        <stop offset={0.9888} stopColor="#88a6bd" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000160160946001160891470000002531314534358264481_)"
                        d="M1495 456.4H1504.2V457.2H1495z"
                      />
                    </g>
                    <path
                      className="st184"
                      d="M1483.7 452.8v.4c0 .5-.4.8-.8.8h-2.1c-1.3 0-2.2 1.1-2.2 2.2V492h-1.6v-36c0-1.6 1.3-2.9 2.9-2.9h3.5c.1-.2.2-.2.3-.3z"
                    />
                    <g>
                      <path
                        className="st184"
                        d="M1476 452.9c0 .1-.1.1-.1.1-.6.8-.9 1.8-.9 2.8V492h-1.6v-36c.1-1.7 1.1-2.8 2.6-3.1zM1472.5 452.9c0 .1-.1.1-.1.1-.6.8-.9 1.8-.9 2.8V492h-1.6v-36c.1-1.7 1.1-2.8 2.6-3.1z"
                      />
                      <path
                        className="st185"
                        d="M1476.8 452c0 .6-.4.9-.7.9h-3.2c-1.6 0-2.9 1.3-2.9 2.9v36h-2v-36c0-2.7 2.2-4.9 4.9-4.9h3.2c.4 0 .7.5.7 1.1z"
                      />
                      <path
                        className="st185"
                        d="M1480.4 452c0 .6-.4.9-.7.9h-3.2c-1.6 0-2.9 1.3-2.9 2.9v36h-2v-36c0-2.7 2.2-4.9 4.9-4.9h3.2c.3 0 .7.5.7 1.1z"
                      />
                      <path
                        className="st186"
                        d="M1476.4 452.5c-.1.1-.2.4-.4.5-1.4.2-2.6 1.4-2.6 2.9v36h-.6v-36.1c0-1.9 1.5-3.3 3.3-3.3h.3zM1472.9 452.5c-.1.1-.2.4-.4.5-1.4.2-2.6 1.4-2.6 2.9v36h-.6v-36.1c0-1.9 1.5-3.3 3.3-3.3h.3z"
                      />
                      <path
                        className="st185"
                        d="M1476.6 452c0 .2 0 .4-.1.6s-.4.5-.6.5h-3.2c-.2 0-.5 0-.7.1-.1 0-.1 0-.2.1-.5.1-.9.5-1.3.8-.4.4-.6.9-.7 1.4v36.6h-2v-36-.7-.2c.1-.7.5-1.3.8-1.9 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.5-.5 1.1-.9 1.8-1.2.1 0 .1-.1.2-.1H1471.3c.4-.1.7-.1 1.2-.1h3.2c.2 0 .4.1.6.4v.1c.3-.4.3-.3.3.1 0-.1 0-.1 0 0z"
                      />
                      <linearGradient
                        id="SVGID_00000001639118682362776210000013706123452716197302_"
                        gradientUnits="userSpaceOnUse"
                        x1={1475.9216}
                        y1={452.0977}
                        x2={1476.9718}
                        y2={452.0977}
                      >
                        <stop offset={0} stopColor="#f57e20" />
                        <stop offset={0.287} stopColor="#f8993c" />
                        <stop offset={0.5834} stopColor="#fbb259" />
                        <stop offset={0.8317} stopColor="#fdc16b" />
                        <stop offset={1} stopColor="#fec771" />
                      </linearGradient>
                      <path
                        d="M1477 452c0 .4-.2.7-.5.9-.1 0-.2.1-.2.1h-.4.1l.1-.1c.1-.1.1-.4.1-.6 0-.6-.4-.9-.7-.9h.4c.7-.5 1.1 0 1.1.6z"
                        fill="url(#SVGID_00000001639118682362776210000013706123452716197302_)"
                      />
                      <path
                        className="st186"
                        d="M1476.5 452.5c-.1.2-.4.5-.6.5h-3.2c-1.5 0-2.7 1.1-2.9 2.5v36.4h-.6v-36.1-.4-.2c.2-1.5 1.6-2.8 3.3-2.8l4 .1z"
                      />
                      <linearGradient
                        id="SVGID_00000011722993681022346240000003345811777415444915_"
                        gradientUnits="userSpaceOnUse"
                        x1={1468.8141}
                        y1={459.722}
                        x2={1468.8141}
                        y2={459.4001}
                      >
                        <stop offset={0} stopColor="#f57e20" />
                        <stop offset={0.287} stopColor="#f8993c" />
                        <stop offset={0.5834} stopColor="#fbb259" />
                        <stop offset={0.8317} stopColor="#fdc16b" />
                        <stop offset={1} stopColor="#fec771" />
                      </linearGradient>
                      <path
                        d="M1469.8 459.7h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.1.1-.1.1-.1.1z"
                        fill="url(#SVGID_00000011722993681022346240000003345811777415444915_)"
                      />
                      <path
                        className="st186"
                        d="M1467.8 459.7H1469.8V459.9H1467.8z"
                      />
                      <linearGradient
                        id="SVGID_00000051343705415036197040000011398760739668249759_"
                        gradientUnits="userSpaceOnUse"
                        x1={1468.8141}
                        y1={465.6732}
                        x2={1468.8141}
                        y2={465.3512}
                      >
                        <stop offset={0} stopColor="#f57e20" />
                        <stop offset={0.287} stopColor="#f8993c" />
                        <stop offset={0.5834} stopColor="#fbb259" />
                        <stop offset={0.8317} stopColor="#fdc16b" />
                        <stop offset={1} stopColor="#fec771" />
                      </linearGradient>
                      <path
                        d="M1469.8 465.7h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.1.1-.1.1-.1.1z"
                        fill="url(#SVGID_00000051343705415036197040000011398760739668249759_)"
                      />
                      <path
                        className="st186"
                        d="M1467.8 465.7H1469.8V465.9H1467.8z"
                      />
                      <g>
                        <linearGradient
                          id="SVGID_00000016053728482154255460000000052080542367885201_"
                          gradientUnits="userSpaceOnUse"
                          x1={1468.8141}
                          y1={471.6243}
                          x2={1468.8141}
                          y2={471.3024}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1469.8 471.6h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.1 0-.1.1-.1.1z"
                          fill="url(#SVGID_00000016053728482154255460000000052080542367885201_)"
                        />
                        <path
                          className="st186"
                          d="M1467.8 471.6H1469.8V471.8H1467.8z"
                        />
                      </g>
                      <g>
                        <linearGradient
                          id="SVGID_00000015335909538417157420000004943523655071391652_"
                          gradientUnits="userSpaceOnUse"
                          x1={1468.8141}
                          y1={477.5755}
                          x2={1468.8141}
                          y2={477.2535}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1469.8 477.6h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.1 0-.1.1-.1.1z"
                          fill="url(#SVGID_00000015335909538417157420000004943523655071391652_)"
                        />
                        <path
                          className="st186"
                          d="M1467.8 477.6H1469.8V477.8H1467.8z"
                        />
                      </g>
                      <g>
                        <linearGradient
                          id="SVGID_00000067196895371815675710000012227439315853974165_"
                          gradientUnits="userSpaceOnUse"
                          x1={1468.8141}
                          y1={483.5267}
                          x2={1468.8141}
                          y2={483.2047}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1469.8 483.5h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.1 0-.1.1-.1.1z"
                          fill="url(#SVGID_00000067196895371815675710000012227439315853974165_)"
                        />
                        <path
                          className="st186"
                          d="M1467.8 483.5H1469.8V483.7H1467.8z"
                        />
                      </g>
                      <g>
                        <linearGradient
                          id="SVGID_00000144317146049133013380000015356345738954136736_"
                          gradientUnits="userSpaceOnUse"
                          x1={1468.8141}
                          y1={489.4777}
                          x2={1468.8141}
                          y2={489.1558}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1469.8 489.5h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.1 0-.1.1-.1.1z"
                          fill="url(#SVGID_00000144317146049133013380000015356345738954136736_)"
                        />
                        <path
                          className="st186"
                          d="M1467.8 489.5H1469.8V489.7H1467.8z"
                        />
                      </g>
                      <g>
                        <linearGradient
                          id="SVGID_00000125590088789046303500000016026930547137802881_"
                          gradientUnits="userSpaceOnUse"
                          x1={2940.7891}
                          y1={960.4713}
                          x2={2940.7891}
                          y2={960.1493}
                          gradientTransform="rotate(13.639 4317.377 -5443.587)"
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1469.8 455.4l-1.9-.5c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.9.5c.1 0 .1.1.1.2.1.1 0 .1-.2.1z"
                          fill="url(#SVGID_00000125590088789046303500000016026930547137802881_)"
                        />
                        <path
                          className="st186"
                          d="M1469.8 455.4v.2l-.6-.1-1.4-.4v-.2l1.4.4.6.1z"
                        />
                      </g>
                      <g>
                        <path
                          className="st186"
                          d="M1471.9 453c-.1 0-.1 0-.2.1v-.1c.4-1.2-.5-1.8-.5-1.8h.2l.4.4c.3.1.4.7.1 1.4z"
                        />
                        <linearGradient
                          id="SVGID_00000181081409850048873980000014234047654349937301_"
                          gradientUnits="userSpaceOnUse"
                          x1={1471.3699}
                          y1={452.1125}
                          x2={1472.2687}
                          y2={452.1125}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1472.1 453.2c-.1 0-.1-.1-.1-.1.4-1.2-.5-1.8-.5-1.8-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.5.5s.4.8.1 1.5c-.1-.1-.2.1-.2.1z"
                          fill="url(#SVGID_00000181081409850048873980000014234047654349937301_)"
                        />
                      </g>
                      <g>
                        <path
                          className="st185"
                          d="M1480.2 452c0 .2 0 .4-.1.6s-.4.5-.6.5h-3.2c-.2 0-.5 0-.7.1-.1 0-.1 0-.2.1-.5.1-.9.5-1.3.8-.4.4-.6.9-.7 1.4v36.6h-2v-36-.7-.2c.1-.7.5-1.3.8-1.9 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.5-.5 1.1-.9 1.8-1.2.1 0 .1-.1.2-.1H1474.9c.4-.1.7-.1 1.2-.1h3.2c.2 0 .4.1.6.4v.1c.2-.4.3-.3.3.1 0-.1 0-.1 0 0z"
                        />
                        <linearGradient
                          id="SVGID_00000116234524719369633270000008075616661239577010_"
                          gradientUnits="userSpaceOnUse"
                          x1={1479.5044}
                          y1={452.0977}
                          x2={1480.5546}
                          y2={452.0977}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1480.6 452c0 .4-.2.7-.5.9-.1 0-.2.1-.2.1h-.4.1l.1-.1c.1-.1.1-.4.1-.6 0-.6-.4-.9-.7-.9h.4c.7-.5 1.1 0 1.1.6z"
                          fill="url(#SVGID_00000116234524719369633270000008075616661239577010_)"
                        />
                        <path
                          className="st186"
                          d="M1480.1 452.5c-.1.2-.4.5-.6.5h-3.2c-1.5 0-2.7 1.1-2.9 2.5v36.4h-.6v-36.1-.4-.2c.2-1.5 1.6-2.8 3.3-2.8l4 .1z"
                        />
                        <linearGradient
                          id="SVGID_00000156550374966400906490000015725757591032114871_"
                          gradientUnits="userSpaceOnUse"
                          x1={1472.3545}
                          y1={459.722}
                          x2={1472.3545}
                          y2={459.4001}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1473.3 459.7h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.2.1.1.1-.1.1z"
                          fill="url(#SVGID_00000156550374966400906490000015725757591032114871_)"
                        />
                        <path
                          className="st186"
                          d="M1471.5 459.7H1473.5V459.9H1471.5z"
                        />
                        <linearGradient
                          id="SVGID_00000075159902680975309220000016172784670551251374_"
                          gradientUnits="userSpaceOnUse"
                          x1={1472.3545}
                          y1={465.6732}
                          x2={1472.3545}
                          y2={465.3512}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1473.3 465.7h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.2.1.1.1-.1.1z"
                          fill="url(#SVGID_00000075159902680975309220000016172784670551251374_)"
                        />
                        <path
                          className="st186"
                          d="M1471.5 465.7H1473.5V465.9H1471.5z"
                        />
                        <g>
                          <linearGradient
                            id="SVGID_00000146479225864015418700000007101968058036817342_"
                            gradientUnits="userSpaceOnUse"
                            x1={1472.3545}
                            y1={471.6243}
                            x2={1472.3545}
                            y2={471.3024}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1473.3 471.6h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.2 0 .1.1-.1.1z"
                            fill="url(#SVGID_00000146479225864015418700000007101968058036817342_)"
                          />
                          <path
                            className="st186"
                            d="M1471.5 471.6H1473.5V471.8H1471.5z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000037655128058754057230000004748474914047573169_"
                            gradientUnits="userSpaceOnUse"
                            x1={1472.3545}
                            y1={477.5755}
                            x2={1472.3545}
                            y2={477.2535}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1473.3 477.6h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.2 0 .1.1-.1.1z"
                            fill="url(#SVGID_00000037655128058754057230000004748474914047573169_)"
                          />
                          <path
                            className="st186"
                            d="M1471.5 477.6H1473.5V477.8H1471.5z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000087390039817330630460000015830942815978719371_"
                            gradientUnits="userSpaceOnUse"
                            x1={1472.3545}
                            y1={483.5267}
                            x2={1472.3545}
                            y2={483.2047}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1473.3 483.5h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.2 0 .1.1-.1.1z"
                            fill="url(#SVGID_00000087390039817330630460000015830942815978719371_)"
                          />
                          <path
                            className="st186"
                            d="M1471.5 483.5H1473.5V483.7H1471.5z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000016772972831921879760000015972219829892099468_"
                            gradientUnits="userSpaceOnUse"
                            x1={1472.3545}
                            y1={489.4777}
                            x2={1472.3545}
                            y2={489.1558}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1473.3 489.5h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1.2 0 .1.1-.1.1z"
                            fill="url(#SVGID_00000016772972831921879760000015972219829892099468_)"
                          />
                          <path
                            className="st186"
                            d="M1471.5 489.5H1473.5V489.7H1471.5z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000057107941885971496490000012328880224866973572_"
                            gradientUnits="userSpaceOnUse"
                            x1={2944.3579}
                            y1={959.6262}
                            x2={2944.3579}
                            y2={959.3042}
                            gradientTransform="rotate(13.639 4317.377 -5443.587)"
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1473.5 455.4l-1.9-.5c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.9.5c.1 0 .1.1.1.2-.1.1-.1.1-.2.1z"
                            fill="url(#SVGID_00000057107941885971496490000012328880224866973572_)"
                          />
                          <path
                            className="st186"
                            d="M1473.5 455.4v.2l-.6-.1-1.4-.4v-.2l1.4.4.6.1z"
                          />
                        </g>
                        <g>
                          <path
                            className="st186"
                            d="M1475.6 453c-.1 0-.1 0-.2.1v-.1c.4-1.2-.5-1.8-.5-1.8h.2l.4.4c.2.1.3.7.1 1.4z"
                          />
                          <linearGradient
                            id="SVGID_00000089547436756772534030000005825647999375815569_"
                            gradientUnits="userSpaceOnUse"
                            x1={1474.9525}
                            y1={452.1125}
                            x2={1475.8514}
                            y2={452.1125}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1475.6 453.2c-.1 0-.1-.1-.1-.1.4-1.2-.5-1.8-.5-1.8-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.5.5s.4.8.1 1.5c-.1-.1-.1.1-.2.1z"
                            fill="url(#SVGID_00000089547436756772534030000005825647999375815569_)"
                          />
                        </g>
                      </g>
                      <g>
                        <path
                          className="st185"
                          d="M1483.9 452c0 .2 0 .4-.1.6s-.4.5-.6.5h-3.2c-.2 0-.5 0-.7.1-.1 0-.1 0-.2.1-.5.1-.9.5-1.3.8-.4.4-.6.9-.7 1.4v36.6h-2v-36-.7-.2c.1-.7.5-1.3.8-1.9 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.5-.5 1.1-.9 1.8-1.2.1 0 .1-.1.2-.1H1478.6c.4-.1.7-.1 1.2-.1h3.2c.2 0 .4.1.6.4v.1c.1-.4.1-.3.3.1 0-.1 0-.1 0 0z"
                        />
                        <linearGradient
                          id="SVGID_00000047780109367252521970000009378646016884715411_"
                          gradientUnits="userSpaceOnUse"
                          x1={1483.0869}
                          y1={452.0977}
                          x2={1484.1372}
                          y2={452.0977}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1484.1 452c0 .4-.2.7-.5.9-.1 0-.2.1-.2.1h-.4.1l.1-.1c.1-.1.1-.4.1-.6 0-.6-.4-.9-.7-.9h.4c.9-.5 1.1 0 1.1.6z"
                          fill="url(#SVGID_00000047780109367252521970000009378646016884715411_)"
                        />
                        <path
                          className="st186"
                          d="M1483.7 452.5c-.1.2-.4.5-.6.5h-3.2c-1.5 0-2.7 1.1-2.9 2.5v36.4h-.6v-36.1-.4-.2c.2-1.5 1.6-2.8 3.3-2.8l4 .1z"
                        />
                        <linearGradient
                          id="SVGID_00000129894017901026877380000017297347990608070569_"
                          gradientUnits="userSpaceOnUse"
                          x1={1476}
                          y1={459.722}
                          x2={1476}
                          y2={459.4001}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1477 459.7h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1 0 .1 0 .1-.1.1z"
                          fill="url(#SVGID_00000129894017901026877380000017297347990608070569_)"
                        />
                        <path
                          className="st186"
                          d="M1475 459.7H1477V459.9H1475z"
                        />
                        <linearGradient
                          id="SVGID_00000101062211947637337300000018216825226984392860_"
                          gradientUnits="userSpaceOnUse"
                          x1={1476}
                          y1={465.6732}
                          x2={1476}
                          y2={465.3512}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M1477 465.7h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1 0 .1 0 .1-.1.1z"
                          fill="url(#SVGID_00000101062211947637337300000018216825226984392860_)"
                        />
                        <path
                          className="st186"
                          d="M1475 465.7H1477V465.9H1475z"
                        />
                        <g>
                          <linearGradient
                            id="SVGID_00000042698803530734202840000012380066501562761651_"
                            gradientUnits="userSpaceOnUse"
                            x1={1476}
                            y1={471.6243}
                            x2={1476}
                            y2={471.3024}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1477 471.6h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1s0 .1-.1.1z"
                            fill="url(#SVGID_00000042698803530734202840000012380066501562761651_)"
                          />
                          <path
                            className="st186"
                            d="M1475 471.6H1477V471.8H1475z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000173861898767109241260000000266729572206989464_"
                            gradientUnits="userSpaceOnUse"
                            x1={1476}
                            y1={477.5755}
                            x2={1476}
                            y2={477.2535}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1477 477.6h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1s0 .1-.1.1z"
                            fill="url(#SVGID_00000173861898767109241260000000266729572206989464_)"
                          />
                          <path
                            className="st186"
                            d="M1475 477.6H1477V477.8H1475z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000066482683478220715690000012434508173607982235_"
                            gradientUnits="userSpaceOnUse"
                            x1={1476}
                            y1={483.5267}
                            x2={1476}
                            y2={483.2047}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1477 483.5h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1s0 .1-.1.1z"
                            fill="url(#SVGID_00000066482683478220715690000012434508173607982235_)"
                          />
                          <path
                            className="st186"
                            d="M1475 483.5H1477V483.7H1475z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000101063195535442841430000000875623745828887227_"
                            gradientUnits="userSpaceOnUse"
                            x1={1476}
                            y1={489.4777}
                            x2={1476}
                            y2={489.1558}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1477 489.5h-2c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1s0 .1-.1.1z"
                            fill="url(#SVGID_00000101063195535442841430000000875623745828887227_)"
                          />
                          <path
                            className="st186"
                            d="M1475 489.5H1477V489.7H1475z"
                          />
                        </g>
                        <g>
                          <linearGradient
                            id="SVGID_00000071550430950296597920000004381308472556123028_"
                            gradientUnits="userSpaceOnUse"
                            x1={2947.8562}
                            y1={958.7811}
                            x2={2947.8562}
                            y2={958.4591}
                            gradientTransform="rotate(13.639 4317.377 -5443.587)"
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1477.1 455.4l-1.9-.5c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.9.5c.1 0 .1.1.1.2-.1.1-.2.1-.2.1z"
                            fill="url(#SVGID_00000071550430950296597920000004381308472556123028_)"
                          />
                          <path
                            className="st186"
                            d="M1477 455.4v.2l-.6-.1-1.4-.4v-.2l1.4.4.6.1z"
                          />
                        </g>
                        <g>
                          <path
                            className="st186"
                            d="M1479.2 453c-.1 0-.1 0-.2.1v-.1c.4-1.2-.5-1.8-.5-1.8h.2l.4.4c.1.1.3.7.1 1.4z"
                          />
                          <linearGradient
                            id="SVGID_00000096775071036465710620000000213080521582406802_"
                            gradientUnits="userSpaceOnUse"
                            x1={1478.5353}
                            y1={452.1125}
                            x2={1479.434}
                            y2={452.1125}
                          >
                            <stop offset={0} stopColor="#f57e20" />
                            <stop offset={0.287} stopColor="#f8993c" />
                            <stop offset={0.5834} stopColor="#fbb259" />
                            <stop offset={0.8317} stopColor="#fdc16b" />
                            <stop offset={1} stopColor="#fec771" />
                          </linearGradient>
                          <path
                            d="M1479.2 453.2c-.1 0-.1-.1-.1-.1.4-1.2-.5-1.8-.5-1.8-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.5.5s.4.8.1 1.5c-.1-.1-.1.1-.2.1z"
                            fill="url(#SVGID_00000096775071036465710620000000213080521582406802_)"
                          />
                        </g>
                      </g>
                    </g>
                    <linearGradient
                      id="SVGID_00000061452062040753610010000001595934549871750284_"
                      gradientUnits="userSpaceOnUse"
                      x1={1377.6001}
                      y1={491.8637}
                      x2={1377.6001}
                      y2={489.3167}
                    >
                      <stop offset={0} stopColor="#79aace" />
                      <stop offset={0.6117} stopColor="#6ba4ce" />
                      <stop offset={1} stopColor="#dceffb" />
                    </linearGradient>
                    <path
                      d="M1454.9 489.3l-.8 2.6h-152.7c-.6 0-1.1-.5-1.1-1.1 0-.8.7-1.4 1.4-1.4h153.1l.1-.1z"
                      fill="url(#SVGID_00000061452062040753610010000001595934549871750284_)"
                    />
                    <g>
                      <linearGradient
                        id="SVGID_00000063603412821191860760000008998559419348567974_"
                        gradientUnits="userSpaceOnUse"
                        x1={848.1606}
                        y1={494.3}
                        x2={866.8606}
                        y2={494.3}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#b6c5c7" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000063603412821191860760000008998559419348567974_)"
                        d="M866.8 480L859.5 508.6 859.4 508.6 848.1 508.6 848.1 498.8 855.4 496.7 859.7 480z"
                      />
                      <linearGradient
                        id="SVGID_00000033371619930894373330000003251525438828689810_"
                        gradientUnits="userSpaceOnUse"
                        x1={852.5482}
                        y1={495.6916}
                        x2={856.2304}
                        y2={480.7951}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000033371619930894373330000003251525438828689810_)"
                        d="M859.7 480L859.6 480.7 859.6 480.8 858.8 483.6 858.8 483.7 858.1 486.6 858 486.7 857.3 489.5 857.3 489.7 856.4 492.6 856.4 492.7 855.7 495.5 855.7 495.6 855.4 496.7 849 496.7 849.2 495.6 849.3 495.5 850 492.7 850 492.6 850.7 489.7 850.8 489.5 851.5 486.7 851.5 486.6 852.3 483.7 852.3 483.6 853 480.8 853.2 480.7 853.3 480z"
                      />
                      <path
                        className="st217"
                        d="M848.1 498.8L855.4 496.7 849 496.7 841.7 498.8z"
                      />
                      <linearGradient
                        id="SVGID_00000180344504645545094370000011045182004911320233_"
                        gradientUnits="userSpaceOnUse"
                        x1={844.9}
                        y1={508.5585}
                        x2={844.9}
                        y2={498.7585}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000180344504645545094370000011045182004911320233_)"
                        d="M841.7 498.8H848.1V508.6H841.7z"
                      />
                      <linearGradient
                        id="SVGID_00000143608326172237331250000002847354850700387997_"
                        gradientUnits="userSpaceOnUse"
                        x1={880.285}
                        y1={486.4298}
                        x2={880.3445}
                        y2={480.3363}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.05275641} stopColor="#6b8aad" />
                        <stop offset={0.2402} stopColor="#809ebc" />
                        <stop offset={0.429} stopColor="#90afc8" />
                        <stop offset={0.6184} stopColor="#9bb9d0" />
                        <stop offset={0.8094} stopColor="#9ebdd3" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000143608326172237331250000002847354850700387997_)"
                        d="M863.7 480L863.9 486.5 863.1 489.8 894.9 489.8 897.5 480z"
                      />
                      <linearGradient
                        id="SVGID_00000088105934831229205180000007113527212458780596_"
                        gradientUnits="userSpaceOnUse"
                        x1={879.4}
                        y1={489.4971}
                        x2={879.4}
                        y2={486.8089}
                      >
                        <stop offset={0} stopColor="#6383a8" />
                        <stop offset={0.05275641} stopColor="#6b8aad" />
                        <stop offset={0.2402} stopColor="#809ebc" />
                        <stop offset={0.429} stopColor="#90afc8" />
                        <stop offset={0.6184} stopColor="#9bb9d0" />
                        <stop offset={0.8094} stopColor="#9ebdd3" />
                        <stop offset={0.9888} stopColor="#a0bed4" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000088105934831229205180000007113527212458780596_)"
                        d="M895.7 486.5L894.9 489.8 863.1 489.8 863.1 489.7 863.1 489.5 863.9 486.5z"
                      />
                      <path
                        d="M894.9 489.8l-.2.7-.2.8h-26.3c-.8 0-3.4-.1-4.8.7-.1.1-.2.1-.4.2v-2.6h31.9v.2z"
                        fill="#9fb7ce"
                      />
                      <path
                        className="st222"
                        d="M894.7 490.5l-.2.8h-26.3c-.8 0-3.4-.1-4.8.7v-.1c0-.8.7-1.4 1.4-1.4h29.9z"
                      />
                      <linearGradient
                        id="SVGID_00000178178463683768167690000007673640647886563762_"
                        gradientUnits="userSpaceOnUse"
                        x1={876.2}
                        y1={508.5585}
                        x2={876.2}
                        y2={491.3585}
                      >
                        <stop offset={0} stopColor="#79aace" />
                        <stop offset={0.5838} stopColor="#95c9ed" />
                        <stop offset={0.7626} stopColor="#b8ddf5" />
                        <stop offset={0.8966} stopColor="#6ba4ce" />
                        <stop offset={1} stopColor="#9cd0f1" />
                      </linearGradient>
                      <path
                        d="M894.4 491.3l-.9 17.2H858c0-2 .1-3.9.5-5.6v-.1c.2-1.2.5-2.2.7-3.2v-.1c.5-1.5.9-2.8 1.5-3.9 0 0 0-.1.1-.1.6-1.3 1.3-2.2 1.9-2.8l.1-.1.2-.2c1.2-1.1 4.2-.9 5-.9h26.4v-.2z"
                        fill="url(#SVGID_00000178178463683768167690000007673640647886563762_)"
                      />
                      <path
                        className="st222"
                        d="M853.3 478.9H903.9V480H853.3z"
                      />
                      <path
                        className="st224"
                        d="M865.7 486.2c-.1 0-.4-.1-.4-.4l-.1-2.6c0-.1 0-.1.1-.2s.1-.1.2-.1h1.5c.1 0 .4.1.4.4l.1 2.6c0 .1 0 .1-.1.2s-.1.1-.2.1h-1.5z"
                      />
                      <path
                        className="st225"
                        d="M867.3 485.8c0 .1-.1.2-.2.2h-1.4c-.1 0-.2-.1-.2-.2l-.1-2.6c0-.1.1-.2.2-.2h1.5c.1 0 .2.1.2.2v2.6z"
                      />
                      <path
                        className="st222"
                        d="M867.3 485.8c0 .1-.1.2-.2.2h-.9c-.1 0-.2-.1-.2-.2l-.1-2.6c0-.1.1-.2.2-.2h.9c.1 0 .2.1.2.2v.1l.1 2.5z"
                      />
                      <path
                        className="st224"
                        d="M880.4 486.2c-.1 0-.4-.1-.4-.4l-.1-2.6c0-.1 0-.1.1-.2s.1-.1.2-.1h1.5c.1 0 .4.1.4.4l.1 2.6c0 .1 0 .1-.1.2s-.1.1-.2.1h-1.5z"
                      />
                      <path
                        className="st225"
                        d="M882 485.8c0 .1-.1.2-.2.2h-1.5c-.1 0-.2-.1-.2-.2l-.1-2.6c0-.1.1-.2.2-.2h1.5c.1 0 .2.1.2.2v.1l.1 2.5z"
                      />
                      <path
                        className="st222"
                        d="M882 485.8c0 .1-.1.2-.2.2h-.9c-.1 0-.2-.1-.2-.2l-.1-2.6c0-.1.1-.2.2-.2h.9c.1 0 .2.1.2.2v.1l.1 2.5z"
                      />
                      <path
                        className="st224"
                        d="M895.1 486.2c-.1 0-.4-.1-.4-.4l-.1-2.6c0-.1 0-.1.1-.2s.1-.1.2-.1h1.5c.1 0 .4.1.4.4l.1 2.6c0 .1 0 .1-.1.2s-.1.1-.2.1h-1.5z"
                      />
                      <path
                        className="st225"
                        d="M896.8 485.8c0 .1-.1.2-.2.2H895c-.1 0-.2-.1-.2-.2l-.1-2.6c0-.1.1-.2.2-.2h1.5c.1 0 .2.1.2.2v.1l.2 2.5z"
                      />
                      <path
                        className="st222"
                        d="M896.8 485.8c0 .1-.1.2-.2.2h-.9c-.1 0-.2-.1-.2-.2l-.1-2.6c0-.1.1-.2.2-.2h.9c.1 0 .2.1.2.2v.1l.1 2.5z"
                      />
                      <linearGradient
                        id="SVGID_00000140010068493941474470000006022972019299933577_"
                        gradientUnits="userSpaceOnUse"
                        x1={901.65}
                        y1={508.5587}
                        x2={901.65}
                        y2={479.9587}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#b6c5c7" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000140010068493941474470000006022972019299933577_)"
                        d="M911 480L911 508.6 892.3 508.6 892.3 498.8 899.6 496.7 899.8 495.6 899.9 495.5 900.6 492.7 900.6 492.7 900.6 492.6 901.4 489.7 901.4 489.7 901.4 489.5 901.4 489.5 902.1 486.7 902.3 486.6 903 483.7 903.7 480.8 903.8 480.7 903.9 480z"
                      />
                      <linearGradient
                        id="SVGID_00000023259283263753180900000008110561692424233615_"
                        gradientUnits="userSpaceOnUse"
                        x1={896.7006}
                        y1={496.5227}
                        x2={900.1486}
                        y2={481.1044}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000023259283263753180900000008110561692424233615_)"
                        d="M903.9 480L903.8 480.7 903.7 480.8 903 483.6 903 483.6 903 483.7 902.3 486.6 902.1 486.7 901.4 489.5 901.4 489.7 900.6 492.6 900.6 492.7 899.9 495.5 899.8 495.6 899.6 496.7 893.1 496.7 893.4 495.6 893.4 495.5 894.2 492.7 894.2 492.6 894.9 489.7 895 489.5 895.7 486.7 895.7 486.6 896.5 483.7 896.5 483.6 897.2 480.8 897.2 480.7 897.5 480z"
                      />
                      <path
                        className="st217"
                        d="M892.3 498.8L899.6 496.7 893.1 496.7 885.9 498.8z"
                      />
                      <linearGradient
                        id="SVGID_00000015329397499200398050000013629608437454952108_"
                        gradientUnits="userSpaceOnUse"
                        x1={889.1}
                        y1={508.5585}
                        x2={889.1}
                        y2={498.7585}
                      >
                        <stop offset={0} stopColor="#9bb0b5" />
                        <stop offset={1} stopColor="#d7e7e6" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000015329397499200398050000013629608437454952108_)"
                        d="M885.9 498.8H892.3V508.6H885.9z"
                      />
                      <path fill="#425362" d="M903.9 478.9H911V480H903.9z" />
                      <g className="st57">
                        <path
                          className="st230"
                          d="M853.2 480.7L859.6 480.7 859.6 480.8 853 480.8z"
                        />
                        <path
                          className="st231"
                          d="M903.8 480.7L903.7 480.8 897.2 480.8 897.2 480.7z"
                        />
                        <path
                          className="st230"
                          d="M852.3 483.6L858.8 483.6 858.8 483.7 852.3 483.7z"
                        />
                        <path
                          className="st231"
                          d="M903 483.6L903 483.7 896.5 483.7 896.5 483.6z"
                        />
                        <path
                          className="st230"
                          d="M851.5 486.6L858.1 486.6 858 486.7 851.5 486.7z"
                        />
                        <path
                          className="st231"
                          d="M902.3 486.6L902.1 486.7 895.7 486.7 895.7 486.6z"
                        />
                        <path
                          className="st230"
                          d="M850.8 489.5L857.3 489.5 857.3 489.7 850.7 489.7z"
                        />
                        <path
                          className="st231"
                          d="M901.4 489.5L901.4 489.7 894.9 489.7 895 489.5z"
                        />
                        <path
                          className="st230"
                          d="M850 492.6L856.4 492.6 856.4 492.7 850 492.7z"
                        />
                        <path
                          className="st231"
                          d="M900.6 492.6L900.6 492.7 894.2 492.7 894.2 492.6z"
                        />
                        <path
                          className="st230"
                          d="M855.7 495.5L855.7 495.6 849.2 495.6 849.2 495.5z"
                        />
                        <path
                          className="st231"
                          d="M899.9 495.5L899.8 495.6 893.4 495.6 893.4 495.5z"
                        />
                      </g>
                      <path
                        className="st231"
                        d="M885.9 499.5H892.3V499.6H885.9z"
                      />
                      <g className="st57">
                        <path
                          className="st231"
                          d="M911 480.7L911 480.8 903.7 480.8 903.8 480.7z"
                        />
                        <path
                          className="st231"
                          d="M911 483.6L911 483.7 903 483.7 903 483.6z"
                        />
                        <path
                          className="st231"
                          d="M911 486.6L911 486.7 902.1 486.7 902.3 486.6z"
                        />
                        <path
                          className="st231"
                          d="M911 489.5L911 489.7 901.4 489.7 901.4 489.5 901.4 489.5z"
                        />
                        <path
                          className="st231"
                          d="M911 492.6L911 492.7 900.6 492.7 900.6 492.6z"
                        />
                        <path
                          className="st231"
                          d="M911 495.5L911 495.6 899.8 495.6 899.9 495.5z"
                        />
                        <path
                          className="st231"
                          d="M892.3 499.5H911V499.6H892.3z"
                        />
                        <path
                          className="st231"
                          d="M892.3 502.9H911V503H892.3z"
                        />
                      </g>
                      <path
                        className="st231"
                        d="M885.9 502.9H892.3V503H885.9z"
                      />
                      <path
                        className="st230"
                        d="M841.7 499.5H848.1V499.6H841.7z"
                      />
                      <path
                        className="st230"
                        d="M841.7 502.9H848.1V503H841.7z"
                      />
                      <g>
                        <path
                          className="st232"
                          d="M859.2 499.5v.1h-11.1v-.1h11.1zM858.4 502.9v.1h-10.3v-.1h10.3zM860.8 495.5s0 .1-.1.1h-5v-.1h5.1zM862.9 492.6l-.1.1h-6.2v-.1h6.3z"
                        />
                        <path
                          className="st232"
                          d="M863.1 489.5L863.1 489.7 857.3 489.7 857.3 489.5z"
                        />
                        <path
                          className="st232"
                          d="M863.9 486.6L863.9 486.7 858 486.7 858.1 486.6z"
                        />
                        <path
                          className="st232"
                          d="M858.8 483.7L863.8 483.7 863.8 483.6 858.8 483.6z"
                        />
                        <path
                          className="st232"
                          d="M859.6 480.8L863.7 480.8 863.7 480.7 859.6 480.7z"
                        />
                      </g>
                      <g>
                        <path
                          d="M903.9 477.7h-.2v-1.9h.2c.1 0 .4.1.4.4v1.2c-.2.2-.3.3-.4.3z"
                          fill="#f47a26"
                        />
                        <linearGradient
                          id="SVGID_00000173861468667582188860000016322530293601360028_"
                          gradientUnits="userSpaceOnUse"
                          x1={878.6}
                          y1={477.7231}
                          x2={878.6}
                          y2={475.931}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M903.9 476.1v1.5c0 .1-.1.1-.1.1h-50.4c-.1 0-.1-.1-.1-.1v-1.5c0-.1.1-.1.1-.1h50.4c.1-.1.1 0 .1.1z"
                          fill="url(#SVGID_00000173861468667582188860000016322530293601360028_)"
                        />
                        <path
                          className="st235"
                          d="M855 477.7L853.5 477.7 854.4 475.9 856 475.9z"
                        />
                        <path
                          className="st235"
                          d="M859.6 477.7L858.1 477.7 859 475.9 860.5 475.9z"
                        />
                        <path
                          className="st235"
                          d="M864.1 477.7L862.6 477.7 863.6 475.9 865.1 475.9z"
                        />
                        <path
                          className="st235"
                          d="M868.7 477.7L867.2 477.7 868.1 475.9 869.6 475.9z"
                        />
                        <path
                          className="st235"
                          d="M873.4 477.7L871.7 477.7 872.7 475.9 874.3 475.9z"
                        />
                        <path
                          className="st235"
                          d="M877.9 477.7L876.4 477.7 877.2 475.9 878.9 475.9z"
                        />
                        <path
                          className="st235"
                          d="M882.5 477.7L881 477.7 881.9 475.9 883.4 475.9z"
                        />
                        <path
                          className="st235"
                          d="M887.1 477.7L885.5 477.7 886.5 475.9 888 475.9z"
                        />
                        <path
                          className="st235"
                          d="M891.6 477.7L890.1 477.7 891 475.9 892.6 475.9z"
                        />
                        <path
                          className="st235"
                          d="M896.2 477.7L894.7 477.7 895.6 475.9 897.1 475.9z"
                        />
                        <path
                          className="st235"
                          d="M900.7 477.7L899.2 477.7 900.1 475.9 901.7 475.9z"
                        />
                        <linearGradient
                          id="SVGID_00000066508777628387724990000015668318816026748826_"
                          gradientUnits="userSpaceOnUse"
                          x1={857.9313}
                          y1={478.3}
                          x2={858.5303}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          fill="url(#SVGID_00000066508777628387724990000015668318816026748826_)"
                          d="M858 477.7H858.6V478.9H858z"
                        />
                        <linearGradient
                          id="SVGID_00000041291768303330586160000012625775435129523590_"
                          gradientUnits="userSpaceOnUse"
                          x1={867.5091}
                          y1={478.3}
                          x2={868.1081}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          fill="url(#SVGID_00000041291768303330586160000012625775435129523590_)"
                          d="M867.5 477.7H868.1V478.9H867.5z"
                        />
                        <linearGradient
                          id="SVGID_00000088129376281212794250000011434110207982480271_"
                          gradientUnits="userSpaceOnUse"
                          x1={877.0868}
                          y1={478.3}
                          x2={877.6858}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          fill="url(#SVGID_00000088129376281212794250000011434110207982480271_)"
                          d="M877.1 477.7H877.7V478.9H877.1z"
                        />
                        <linearGradient
                          id="SVGID_00000069364621453683596350000001553603412706361529_"
                          gradientUnits="userSpaceOnUse"
                          x1={886.6646}
                          y1={478.3}
                          x2={887.2636}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          fill="url(#SVGID_00000069364621453683596350000001553603412706361529_)"
                          d="M886.7 477.7H887.3000000000001V478.9H886.7z"
                        />
                        <linearGradient
                          id="SVGID_00000026877464694816945660000008657164254086390432_"
                          gradientUnits="userSpaceOnUse"
                          x1={896.2424}
                          y1={478.3}
                          x2={896.8414}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          fill="url(#SVGID_00000026877464694816945660000008657164254086390432_)"
                          d="M896.3 477.7H896.9V478.9H896.3z"
                        />
                        <linearGradient
                          id="SVGID_00000109708267421625197070000005620301972259232955_"
                          gradientUnits="userSpaceOnUse"
                          x1={857.9313}
                          y1={478.3}
                          x2={858.5303}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          opacity={0.5}
                          fill="url(#SVGID_00000109708267421625197070000005620301972259232955_)"
                          enableBackground="new"
                          d="M858 478L858.3 478 858.3 478.9 858.5 478.9 858.5 477.7 858 477.7z"
                        />
                        <linearGradient
                          id="SVGID_00000134968477777397035930000016824283461747243695_"
                          gradientUnits="userSpaceOnUse"
                          x1={867.5091}
                          y1={478.3}
                          x2={868.1081}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          opacity={0.5}
                          fill="url(#SVGID_00000134968477777397035930000016824283461747243695_)"
                          enableBackground="new"
                          d="M867.5 478L867.9 478 867.9 478.9 868.1 478.9 868.1 477.7 867.5 477.7z"
                        />
                        <linearGradient
                          id="SVGID_00000078042801099047740020000014558302674211593106_"
                          gradientUnits="userSpaceOnUse"
                          x1={877.0868}
                          y1={478.3}
                          x2={877.6858}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          opacity={0.5}
                          fill="url(#SVGID_00000078042801099047740020000014558302674211593106_)"
                          enableBackground="new"
                          d="M877.1 478L877.5 478 877.5 478.9 877.7 478.9 877.7 477.7 877.1 477.7z"
                        />
                        <linearGradient
                          id="SVGID_00000003815275922323838120000002998456830182811800_"
                          gradientUnits="userSpaceOnUse"
                          x1={886.6646}
                          y1={478.3}
                          x2={887.2636}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          opacity={0.5}
                          fill="url(#SVGID_00000003815275922323838120000002998456830182811800_)"
                          enableBackground="new"
                          d="M886.7 478L887.1 478 887.1 478.9 887.3 478.9 887.3 477.7 886.7 477.7z"
                        />
                        <linearGradient
                          id="SVGID_00000044865391749750035540000010624236142839382166_"
                          gradientUnits="userSpaceOnUse"
                          x1={896.2424}
                          y1={478.3}
                          x2={896.8414}
                          y2={478.3}
                        >
                          <stop offset={0} stopColor="#9bb0b5" />
                          <stop offset={1} stopColor="#b6c5c7" />
                        </linearGradient>
                        <path
                          opacity={0.5}
                          fill="url(#SVGID_00000044865391749750035540000010624236142839382166_)"
                          enableBackground="new"
                          d="M896.3 478L896.6 478 896.6 478.9 896.9 478.9 896.9 477.7 896.3 477.7z"
                        />
                      </g>
                      <linearGradient
                        id="SVGID_00000000205082325653800190000009505756321942321083_"
                        gradientUnits="userSpaceOnUse"
                        x1={880.6}
                        y1={480.7667}
                        x2={880.6}
                        y2={480.0421}
                      >
                        <stop offset={0.0111732} stopColor="#fff" />
                        <stop offset={0.2662} stopColor="#fafbfc" />
                        <stop offset={0.4201} stopColor="#f0f1f5" />
                        <stop offset={0.5472} stopColor="#e1e4ec" />
                        <stop offset={0.6597} stopColor="#cdd3e0" />
                        <stop offset={0.7626} stopColor="#b5bfd3" />
                        <stop offset={0.8584} stopColor="#98a9c3" />
                        <stop offset={0.9471} stopColor="#7991b2" />
                        <stop offset={1} stopColor="#6383a8" />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_00000000205082325653800190000009505756321942321083_)"
                        d="M897.1 481.1L863.8 481.1 863.7 480 897.5 480z"
                      />
                      <g className="st57">
                        <linearGradient
                          id="SVGID_00000159459326818126043940000000385973680509147299_"
                          gradientUnits="userSpaceOnUse"
                          x1={878.6}
                          y1={476.8271}
                          x2={878.6}
                          y2={475.931}
                        >
                          <stop offset={0} stopColor="#f57e20" />
                          <stop offset={0.287} stopColor="#f8993c" />
                          <stop offset={0.5834} stopColor="#fbb259" />
                          <stop offset={0.8317} stopColor="#fdc16b" />
                          <stop offset={1} stopColor="#fec771" />
                        </linearGradient>
                        <path
                          d="M903.9 476.1v.8h-50.6v-.8c0-.1.1-.1.1-.1h50.4c.1-.1.1 0 .1.1z"
                          fill="url(#SVGID_00000159459326818126043940000000385973680509147299_)"
                        />
                        <path
                          d="M903.9 476.8h-50.6v-.8c0-.1.1-.1.1-.1h50.4c.1 0 .1.1.1.1v.8zm-50.6 0h50.6v-.7c0-.1 0-.1-.1-.1h-50.4c-.1 0-.1 0-.1.1v.7z"
                          fill="#faa63a"
                        />
                      </g>
                      <path
                        fill="#788a9a"
                        d="M853.3 478.9H903.9V479.29999999999995H853.3z"
                      />
                      <path
                        className="st222"
                        d="M903.9 478.9H911V479.29999999999995H903.9z"
                      />
                      <g>
                        <path
                          className="st250"
                          d="M905.2 491.7c-.1.8-.8 1.3-1.5 1.4H902.9c-.2-.1-.4-.2-.6-.4-.2-.1-.4-.4-.5-.6-.1-.4-.2-.7-.1-1.1.1-.9 1.1-1.5 1.9-1.4h.1c1 .2 1.7 1.1 1.5 2.1z"
                        />
                        <path
                          className="st250"
                          d="M908.9 491.1v.2c0 .1-.1.2-.1.5 0 .1-.1.2-.1.4-.4.5-.8.8-1.3 1.1-.4.1-.7.1-1.1.1h-.2c-.8-.2-1.4-.9-1.6-1.8-.1-.4-.1-.6 0-.9 0-.1.1-.4.1-.5.1-.2.1-.4.2-.5.1-.2.4-.4.6-.6.5-.4 1.1-.5 1.8-.4.5.1.9.4 1.3.7.3.4.5 1 .4 1.7z"
                        />
                        <path
                          className="st251"
                          d="M908.9 491.1v.2c0 .1-.1.2-.1.5 0 .1-.1.2-.1.4-.4.5-.8.8-1.3 1.1-.4.1-.7.1-1.1.1h-.2c-.8-.2-1.4-.9-1.6-1.8-.1-.4-.1-.6 0-.9 0-.1.1-.4.1-.5.1-.2.1-.4.2-.5 0 0-.2 1.3.9.8 1.2-.4 1.8 0 2.1.5.2.2.8.4 1.1.1z"
                        />
                        <path
                          className="st250"
                          d="M903.8 493.6c-.1.4-.2.6-.6.7-.1 0-.2.1-.4.1h-.4c-.6-.1-.9-.6-.8-1.2 0-.2.2-.5.5-.6s.5-.2.7-.1h.2c.4.1.5.4.6.7.2.2.2.3.2.4z"
                        />
                        <path
                          className="st252"
                          d="M903.8 493.3h-.7c-.2-.1-.6-.2-.7-.5.1.1.4.2.6.4h.8c-.1 0 0 0 0 .1zM904.4 491.2v.2h-.2v-.2-.5c0-.2.1-.6.4-.8 0 .1-.1.2-.1.5-.1.3-.1.6-.1.8z"
                        />
                        <path
                          className="st250"
                          d="M907.3 493.4v.5c-.1.4-.2.7-.5 1.1l-.5.5s-.1 0-.1.1c-.2.1-.4.1-.6.2-.2 0-.6.1-.8 0-.6-.1-1.1-.5-1.4-.9s-.5-1.1-.4-1.6v-.1c0-.2.1-.5.2-.6.2-.4.5-.6.8-.8h.2c.4-.1.7-.1 1.2-.1.5.1.8.4 1.2.6l.1.1.1.1c.2.4.4.7.5 1.1v-.2z"
                        />
                        <path
                          className="st252"
                          d="M904.1 491.5c-.6.4-1.1.8-1.2 1.5h-.1v-.1c.1-.7.6-1.2 1.2-1.5h.1v.1zM907 492c-.1 0-.1.1-.2.1-.4-.4-.8-.7-1.3-.8-.5-.1-.8 0-1.2.1h-.1c.1-.1.2-.1.4-.1.4-.1.8-.2 1.2-.1.5.1 1 .3 1.2.8z"
                        />
                        <path
                          className="st250"
                          d="M910.9 494.5c0 .1 0 .1 0 0-.4 1.3-1.5 2.1-2.8 1.9-.7-.1-1.3-.6-1.6-1.2-.2-.5-.4-1.1-.2-1.5.1-.5.2-.8.6-1.2.4-.5.9-.7 1.5-.8h.7c.6.1 1.1.4 1.4.8.3.6.5 1.3.4 2z"
                        />
                        <path
                          className="st252"
                          d="M907.2 494.5c0 .1 0 .2-.1.2s-.1-.1-.1-.2 0-.2.1-.2c-.1-.1.1 0 .1.2zM905.4 494.1c-.1.1-.1.1-.2.1s0-.1 0-.2c.1-.1.1-.1.2-.1v.2zM908.3 491.7c-.5 0-.8.2-1.2.5-.1 0-.1.1-.2.1-.4.4-.7.8-.8 1.4v.2c0 .5 0 .9.2 1.3l-.1.1s-.1 0-.1.1c-.4-.5-.5-1.1-.4-1.8v-.1c0-.1.1-.2.1-.4.2-.5.5-.8.9-1.1.1 0 .1-.1.2-.1.6-.1 1-.2 1.4-.2z"
                        />
                        <path
                          className="st253"
                          d="M910.2 493.3c-.2.4-.8-.2-.9-.6 0-.4-.2-.5-.5-.4-.2.1-.6.2-.7 0-.1-.1 0-.2.1-.4.1-.1.4-.2.6-.2h.2c.4.1.6.2.8.4.4.3.5.7.4 1.2zM906.7 491.9c-.1.1-.2.2-.4.1s-.4-.1-.4.2c0 .4-.7.4-1.1-.4-.4-.6-.9.6-1.4.6-.2 0-.2-.1-.2-.4.2-.4.5-.6.8-.8h.2c.4-.1.7-.1 1.2-.1.6.3 1.1.6 1.3.8z"
                        />
                        <path
                          className="st251"
                          d="M906.2 495.4c-.2.1-.4.1-.6.2-.2 0-.6.1-.8 0-.6-.1-1.1-.5-1.4-.9s-.5-1.1-.4-1.6v-.1c.1 0 .4 0 .5.4.2.6.8 1.1 1.2.6s.7-.6 1.2-.4v.1c-.1.5 0 1.1.3 1.7zM910.9 494.6c-.2 1.3-1.5 2.1-2.8 1.9-.7-.1-1.3-.6-1.6-1.2-.2-.5-.4-1.1-.2-1.5s.2-.8.6-1.2c0 0-.5 1.1.2 1.1s2-.5 1.8.6.5 1.6.8 1.2c.2-.8.7-1.5 1.2-.9z"
                        />
                        <path
                          className="st253"
                          d="M903.7 489.5c0 .2-.2.5-.4.4-.2 0-.1 0-.5.2-.2.2.4.4.2.7 0 .5-.4.2-.6.1s-.1.7-.4 1.1c-.1.1-.1.1-.2 0-.1-.4-.2-.7-.1-1.1.2-.8 1-1.5 2-1.4zM908 489.1c.2.1 0 .5-.2.4-.1-.1-.2-.1-.2-.2-.2-.4-.2 0-.5.5-.2.5-.5-.2-.7-.5-.1-.2-.6.4-.8.2 0 0-.1 0-.1-.1-.1-.1 0-.4.1-.4.5-.2.9-.4 1.5-.2.3-.1.6 0 .9.3z"
                        />
                        <path
                          d="M908.1 497.7l-1.6 1.5.1 3.7v.8l-1.2-.5.4-8.2-.6-1.1h.1l.8 1.1.8-.6-.7.7.1 3.4 1.5-1.1h.1c.3.3.3.3.2.3z"
                          fill="#ad5c74"
                        />
                        <path
                          className="st250"
                          d="M908.8 497.4c0 .2-.1.5-.2.7-.2.4-.6.5-.9.5-.7 0-1.2-.5-1.2-1.2 0-.1 0-.4.1-.5.2-.5.6-.7 1.1-.7.6 0 1.1.5 1.1 1.2z"
                        />
                        <path
                          className="st250"
                          d="M909.4 498.7c0 .1 0 .2-.1.4-.1.4-.5.7-.9.7-.6 0-1.1-.5-1.1-1.1v-.1c0-.1 0-.1.1-.2.1-.2.2-.5.5-.5.1 0 .1 0 .2-.1H908.4c.5 0 .8.4.9.8.1-.1.1-.1.1.1z"
                        />
                        <path
                          className="st250"
                          d="M909.7 497.7c0 .1 0 .2-.1.4l-.4.4c-.1 0-.1.1-.2.1h-.1c-.2 0-.5-.1-.6-.2s-.2-.4-.2-.6v-.1c0-.1 0-.2.1-.4l.4-.4c.1 0 .2-.1.4-.1.4.1.7.5.7.9z"
                        />
                        <path
                          className="st252"
                          d="M908.6 496.9c-.2.1-.5.4-.5.7-.1 0-.1 0-.2.1.1-.3.3-.7.7-.8z"
                        />
                        <path
                          className="st251"
                          d="M909.7 498.1c-.1.2-.4.5-.6.5h-.1c-.5 0-.8-.4-.8-.8 0-.1 0-.2.1-.4-.1.2-.1.5.2.5.5 0 .7-.1.7.1.1.1.3.3.5.1zM908.2 497.3c-.1.1-.1.2-.1.4-.1 0-.1 0-.2.1-.2.1-.5.5-.6.8-.5-.1-.9-.6-.9-1.2 0-.1 0-.4.1-.5.1 0 .2-.1.4.2.1.5.2.7.5.5.1-.1.6-.3.8-.3z"
                        />
                        <path
                          className="st251"
                          d="M909.3 499c-.1.4-.5.7-.9.7-.6 0-1.1-.5-1.1-1.1v-.1c0-.1 0-.1.1-.2.1 0 .4 0 .4.2.1.5.2.9.5.6.2-.2.5-.5.5-.2s0 .5.1.2c.1-.2.1-.4.4-.1 0-.1 0-.1 0 0z"
                        />
                        <path
                          className="st255"
                          d="M905.5 503.3l.4-8.2-.6-1.1.7 1.2v7.2c0 .4.2.6.5.7h.1v.8l-1.1-.6z"
                        />
                        <path
                          className="st255"
                          d="M906.5 499.3L906.3 499.5 906.6 501.7z"
                        />
                        <path
                          className="st255"
                          d="M907 494.6l-.7.7v-.1l.7-.6c0-.1 0 0 0 0z"
                        />
                      </g>
                      <g>
                        <path
                          className="st250"
                          d="M896.5 502.2v.5c-.2.8-.9 1.4-1.8 1.4s-1.8-.7-1.9-1.5v-.4c0-.7.5-1.4 1.1-1.6.1 0 .1-.1.2-.1.2-.1.4-.1.6-.1.6 0 1.2.4 1.5.8l.1.1s0 .1.1.1c.1.2.1.4.1.8z"
                        />
                        <path
                          className="st250"
                          d="M899.9 500.8c0 .6-.2 1.1-.5 1.4l-.2.2s-.1.1-.2.1c-.4.2-.8.4-1.2.4-.9 0-1.6-.5-2-1.3-.1-.2-.2-.6-.2-.9 0-.9.5-1.6 1.3-2 .2-.1.6-.2.9-.2.7 0 1.3.4 1.8.8.1.4.3 1 .3 1.5z"
                        />
                        <path
                          className="st250"
                          d="M902.5 501.7c0 .7-.4 1.2-.8 1.5-.2.2-.6.4-.9.4-.9 0-1.8-.8-1.8-1.8 0-.2 0-.5.1-.6.1-.2.2-.6.5-.7.1-.1.2-.1.4-.2s.6-.2.8-.2c.6 0 1.2.4 1.5.8.1.1.2.5.2.8z"
                        />
                        <path
                          className="st252"
                          d="M898.9 501.7c0 .2.1.6.2.8 0 0-.1.1-.2.1-.1-.2-.2-.5-.2-.8 0-.6.4-1.2.8-1.5-.4.4-.6.8-.6 1.4z"
                        />
                        <path
                          className="st250"
                          d="M896.9 500.1c0 .4-.1.7-.4.9 0 .1-.1.1-.2.1-.1.1-.4.2-.5.2h-.5c-.2 0-.5-.1-.6-.2-.4-.2-.6-.6-.7-.9v-.2-.2c.1-.7.7-1.2 1.4-1.2.4 0 .6.1.8.2.4.2.5.6.6.9.1.3.1.4.1.4z"
                        />
                        <path
                          className="st252"
                          d="M895.4 501.5c-.3 0-.6-.1-.8-.2-.4-.2-.6-.5-.7-.8.1 0 .1-.1.2-.1.1.4.4.7.7.9.1.2.3.2.6.2zM897 500.2c0 .5-.2.9-.6 1.2 0 0 0-.1-.1-.1.4-.2.6-.7.6-1.2s-.2-.8-.6-1.1c.5.3.7.7.7 1.2z"
                        />
                        <path
                          className="st251"
                          d="M902.5 501.8c0 .6-.4 1.1-.8 1.4-.2.2-.6.4-.9.4-.7 0-1.3-.4-1.6-.9-.1-.2-.2-.5-.2-.8 0-.2 0-.4.1-.6.2-.1.6-.2.8.1.2.5.1 1.1.6.8.6-.2.9-.7 1.2-.4.1.3.3.4.8 0-.1 0-.1 0 0 0z"
                        />
                        <path
                          className="st251"
                          d="M899.1 502.5s-.1.1-.2.1c-.4.2-.8.4-1.2.4-.5 0-.8-.1-1.2-.4 0-.1.1-.4.1-.5 0-.4-.1-.6-.2-.9.1 0 .1-.1.2-.1s.4.1.4.5c.2.6.5.8.8.5.2-.2.8-.6 1.2-.4-.1.2 0 .6.1.8z"
                        />
                        <path
                          className="st253"
                          d="M902.1 500.8c-.2.1-.9 0-1.2-.5-.4-.5-.6.1-1.1.2-.2 0-.2-.1-.2-.2s.1-.2.2-.2c.2-.1.5-.1.7-.1.8 0 1.4.3 1.6.8zM899.4 499.4c0 .1 0 .1 0 0-.2.6-.9.1-1.2-.2-.2-.4-.6-.2-1.1 0-.2.1-.4-.1-.4-.4.2-.1.6-.2.9-.2.8-.1 1.4.3 1.8.8z"
                        />
                        <path
                          className="st251"
                          d="M896.9 500.1c0 .4-.1.7-.4.9 0 .1-.1.1-.2.1-.1.1-.4.2-.5.2h-.5c-.2 0-.5-.1-.6-.2-.4-.2-.6-.6-.7-.9v-.2-.2c.1-.1.2-.2.5 0 .2.4.7.7.8.5.2-.4.4-.7.7-.4.2.4.6.4.8 0 .1.1.1.2.1.2z"
                        />
                        <path
                          className="st252"
                          d="M896.5 502.4v.1c-.2.8-.9 1.4-1.8 1.4s-1.8-.7-1.9-1.5c.2 0 .6-.1.8.2.2.5 1.1.8 1.4.5.4-.4.5-1.1.8-.6.1.3.5 0 .7-.1z"
                        />
                      </g>
                      <path
                        className="st250"
                        d="M915.1 508.5l-26.5.1s-.2-.7.2-1.8c.5-.9 1.4-2.1 3.5-3.2 0 0 6.4-3.6 11.8-.9 2.5 1.3 4.4 2.1 6.1 2.6 1.2.4 2.1.6 2.8.8 1.2.2 2.1 1.2 2.1 2.4z"
                      />
                      <path
                        className="st251"
                        d="M915.1 508.5l-26.5.1c.2-1.2.8-2.2 1.9-2.8 1.5-1.1 3.7-2.2 4.3-1.3.8 1.5 2.2 2.2 4.2.9 2.1-1.2 5.5-2 6.1-.7.6 1.2-.1 2.8 2.7 1.4h.1c1.2-.6 2.7-.7 4-.4.6.1.9.2 1.4.4.9.2 1.8 1.2 1.8 2.4z"
                      />
                      <g>
                        <linearGradient
                          id="SVGID_00000067205702726529217500000010047313351019884965_"
                          gradientUnits="userSpaceOnUse"
                          x1={869.9501}
                          y1={508.5292}
                          x2={869.9501}
                          y2={500.596}
                        >
                          <stop offset={0} stopColor="#9cd0f1" />
                          <stop offset={0.536} stopColor="#b1d9f4" />
                          <stop offset={1} stopColor="#c7e4f7" />
                        </linearGradient>
                        <path
                          d="M885.3 504.2v-.1-.4c0-.6-.4-1.1-.8-1.3v-.4c0-.8-.7-1.4-1.4-1.4-.8 0-1.5.7-1.5 1.4v.1h-.6c-.2 0-.5 0-.6.1-.2-.4-.7-.7-1.2-.7-.7 0-1.2.5-1.3 1.1v.2c-.1 0-.2-.1-.4-.1h-.2c-.1 0-.2.1-.4.2-.1-.8-.8-1.5-1.6-1.5-.7 0-1.4.5-1.5 1.2h-.4c-.1-.6-.7-1.1-1.3-1.1-.7 0-1.3.6-1.3 1.3v.2c-.2 0-.4 0-.6.1-.2.1-.4.2-.5.4-.1-.7-.7-1.2-1.5-1.2-.7 0-1.4.6-1.5 1.2-.2-.1-.5-.1-.6-.1 0-1.3-1.1-2.3-2.3-2.3-.8 0-1.4.4-1.9.9-.1.1-.1.2-.2.4-.5-.4-1.2-.6-1.9-.6-1.1 0-2 .5-2.6 1.3-.2.4-.5.8-.6 1.3 0 0-.1 0-.1-.1-.2-.1-.6-.1-.8-.1-1.2 0-2 .9-2 2.1s.9 2.1 2.1 2.1c.6 0 1.2-.2 1.5-.7.1-.1.1-.2.2-.4.6.6 1.4.9 2.2.9.9 0 1.6-.4 2.2-.9l.2-.2c.1.9.8 1.6 1.8 1.6.8 0 1.5-.6 1.8-1.3h1c.1 0 .4-.1.5-.2.4.5.9.7 1.5.7.7 0 1.4-.5 1.6-1.1.2.6.8 1.1 1.4 1.1.7 0 1.3-.5 1.5-1.2.1 0 .2 0 .4.1h.1c.7 0 1.4-.4 1.8-.9.2.4.7.7 1.2.7s.9-.2 1.2-.7l.1.1c.2.2.6.4.8.4.4 0 .6-.1.8-.2.4.4.9.7 1.5.7.5 0 .9-.1 1.3-.4l.2-.2c.1.8.8 1.4 1.8 1.4.2 0 .5 0 .7-.1.6-.2 1.1-.8 1.1-1.5-.1-1.1-.4-1.7-.9-1.9z"
                          fill="url(#SVGID_00000067205702726529217500000010047313351019884965_)"
                        />
                        <path
                          className="st257"
                          d="M857.6 507.1c-.1.1-.1.2-.2.4-.6-.6-.9-1.4-.9-2.2 0-.4 0-.7.1-1.1 0 0 .1 0 .1.1 0 .2-.1.5-.1.6.1.9.4 1.6 1 2.2zM865.4 505.2c-.5.7-1.4 1.1-2.3.9-.9-.2-1.6-.9-1.9-1.9-.1-.8.1-1.6.7-2.2-.4.5-.6 1.2-.5 1.9.1 1.1.9 1.8 2 2 .7 0 1.6-.2 2-.7z"
                        />
                        <path
                          className="st257"
                          d="M864.3 505.3v.4h-.2v-.4c0-.8.5-1.4 1.2-1.8 0 0 .1 0 .1-.1-.7.6-1.1 1.2-1.1 1.9zM866.6 507.2c-.2.1-.5.1-.7.1-.9 0-1.6-.7-1.9-1.5h.2c.2.8.9 1.5 1.9 1.5.3-.1.4-.1.5-.1zM869.8 504.2c0 .4-.1.8-.4 1.1 0 .1-.1.1-.2.1-.2.2-.6.4-.9.4-.8 0-1.5-.7-1.5-1.5v-.3c.1.8.7 1.4 1.5 1.4.4 0 .6-.1.8-.2.1 0 .1-.1.2-.1.2-.2.5-.6.5-.9 0-.2 0 0 0 0z"
                        />
                        <path
                          className="st257"
                          d="M871.2 506.1c-.2.1-.4.1-.6.1-.6 0-1.2-.4-1.4-.8.1 0 .1-.1.2-.1.2.6.8.9 1.4.9.1-.1.2-.1.4-.1zM880.5 502.2c-.8.2-1.5 1.1-1.5 2h-.1c.1-1 .7-1.8 1.6-2zM882.8 504.9c-.1.2-.1.5-.1.7v.2l-.2.2v-.4c0-.2 0-.5.1-.7 0-.1.1-.1.1-.2s.1-.1.2-.2c0 0 0 .1.1.1-.2.1-.2.3-.2.3zM882.5 503.7c-.5-.2-.9-.7-.9-1.3v-.2h.1c0 .6.4.9.8 1.2.1.1 0 .2 0 .3zM873.6 506.6c-1.2 0-2.1-.9-2.1-2s.9-2 2-2h.1c-1.1.1-1.9.9-1.9 2s.9 2 1.9 2zM875.3 504.9c0 .1 0 .1 0 0-.8 0-1.4-.7-1.4-1.5v-.4.1c0 .8.6 1.4 1.3 1.6.1 0 .1.2.1.2z"
                        />
                        <path
                          className="st257"
                          d="M876.9 503.5s0 .1 0 0h-.4c-.7 0-1.3.5-1.4 1.2v-.1-.2c.1-.7.7-1.2 1.4-1.2h.4v.3z"
                        />
                        <path
                          className="st257"
                          d="M876.9 503.5s0 .1 0 0h-.2c0-.4.4-.7.7-.7-.3.1-.5.4-.5.7zM879.1 504.5c-.6-.1-1.1-.7-1.1-1.4 0-.2 0-.4.1-.6v.4c0 .6.5 1.2 1.1 1.3-.1.2-.1.2-.1.3zM878.1 505.1c0 .2 0 .5-.1.6l-.1-.1c.1-.2.2-.5.2-.7v-.4c0 .1.1.1.1.2-.1.2-.1.3-.1.4zM885.3 504v.1c-.1.7-.7 1.3-1.4 1.3-.5 0-.8-.2-1.1-.5 0-.1.1-.1.1-.2.2.2.6.5 1.1.5.6-.1 1.1-.6 1.3-1.2 0-.1 0 0 0 0z"
                        />
                      </g>
                      <linearGradient
                        id="SVGID_00000034048173009173660120000015976290743518448516_"
                        gradientUnits="userSpaceOnUse"
                        x1={862.05}
                        y1={508.5585}
                        x2={862.05}
                        y2={504.3351}
                      >
                        <stop offset={0} stopColor="#9cd0f1" />
                        <stop offset={0.536} stopColor="#b1d9f4" />
                        <stop offset={1} stopColor="#c7e4f7" />
                      </linearGradient>
                      <path
                        d="M885.9 504.6v3.9h-47.7v-.1c0-2.1 1.6-3.9 3.7-4 2.7-.1 6.1-.1 7.9.7.6.2 1.4.4 2.5.5 5.6.4 17.5-1.3 25.5-1.3 2.1 0 4.9.2 8.1.3z"
                        fill="url(#SVGID_00000034048173009173660120000015976290743518448516_)"
                      />
                      <linearGradient
                        id="SVGID_00000104677464254756982020000015250286972840415386_"
                        gradientUnits="userSpaceOnUse"
                        x1={869.1685}
                        y1={505.6375}
                        x2={869.1685}
                        y2={498.3019}
                      >
                        <stop offset={0} stopColor="#fff" />
                        <stop offset={0.4442} stopColor="#e7f3fb" />
                        <stop offset={1} stopColor="#c7e4f7" />
                      </linearGradient>
                      <path
                        d="M885.9 500.1v4.6c-3.2-.2-6-.4-7.9-.4-7.9 0-19.8 1.6-25.5 1.3-.1-.8-.5-4.3 3.2-4.4 4.1-.1 6.7-3.4 9.7-1.6 2.9 1.8 7.1 1.3 9.9-.1 2.8-1.4 5.4-1.4 6.7-.2 1.2 1 3.9.8 3.9.8z"
                        opacity={0.5}
                        fill="url(#SVGID_00000104677464254756982020000015250286972840415386_)"
                        enableBackground="new"
                      />
                    </g>
                    <g>
                      <path d="M1392.4 963.3c-1.6-4-4.6-7.3-8.4-9.2-2.3-1.2-5-1.9-7.8-1.9-5.4 0-10.1 2.4-13.4 6.2-2.6 3-4.1 7-4.1 11.3 0 9.6 7.8 17.5 17.5 17.5 3.4 0 6.7-1 9.4-2.7 4.9-3.1 8.1-8.6 8.1-14.8-.1-2.3-.5-4.4-1.3-6.4zm-8.5 19.4c-1.1.7-2.1 1.1-3.3 1.5-1.4.5-3 .7-4.5.7-8.4 0-15.1-6.8-15.1-15.2 0-2.6.7-5 1.8-7.1 2.5-4.8 7.6-8 13.4-8 2.8 0 5.5.8 7.8 2.2 2.6 1.5 4.6 3.8 5.9 6.6.9 2 1.4 4.1 1.4 6.4 0 5.4-3 10.2-7.4 12.9z" />
                    </g>
                    <path
                      className="st20"
                      d="M1373 971.1h-3.1c-.4 0-.7 0-.9-.4-.2-.4 0-.6.2-.9 3.2-3.9 6.5-7.9 9.7-11.8.3-.4.7-.5 1-.3s.4.5.3 1c-.8 3-1.6 6.1-2.4 9.1 0 .1-.1.3-.1.5h3.2c.3 0 .6.1.8.4.2.3 0 .6-.2.9-3.3 3.9-6.5 7.9-9.7 11.8-.3.4-.7.5-1 .3s-.4-.5-.3-1c0-.1 0-.1.1-.2l2.4-9v-.4z"
                    />
                    <g>
                      <text
                        transform="translate(313.436 456.871)"
                        className="st260"
                        fontSize="34px"
                      >
                        {"Sirdaryo"}
                      </text>
                    </g>
                    <path
                      opacity={0.3}
                      fill="#4457a6"
                      enableBackground="new"
                      d="M95.7 255.4H395.8V386.8H95.7z"
                    />
                    <text
                      transform="translate(162.944 286.323)"
                      className="st3 st263"
                    >
                      {"Do\u2019stlik kanali:"}
                    </text>
                    <text
                      transform="translate(121.499 330.328)"
                      className="st15 st263"
                    >
                      {"O\u2019zbekiston"}
                    </text>
                    <text
                      transform="translate(251.599 330.328)"
                      className="st3 st263"
                    >
                      {"-"}
                    </text>
                    <text
                      transform="translate(264.699 330.328)"
                      className="st264 st263"
                    >
                      {`${schema?.uzb1 ? schema?.uzb1 : 0} m\u00B3/s`}
                    </text>
                    <text
                      transform="translate(121.499 357.228)"
                      className="st15 st263"
                    >
                      {"Qozog\u2019iston"}
                    </text>
                    <text
                      transform="translate(253.999 357.228)"
                      className="st3 st263"
                    >
                      {"-"}
                    </text>
                    <text
                      transform="translate(267.099 357.228)"
                      className="st264 st263"
                    >
                      {`${schema?.kaz1 ? schema?.kaz1 : 0} m\u00B3/s`}
                    </text>

                    <path
                      d="M844.8 521.7S535.4 828.4 464.6 648L443 480"
                      fill="none"
                      stroke="#4457a6"
                      strokeWidth={15}
                      strokeMiterlimit={10}
                    />
                    <circle
                      cx={467.5}
                      cy={655.1}
                      r={21.7}
                      fill="#fff"
                      stroke="#000"
                      strokeWidth={4}
                      strokeMiterlimit={10}
                    />
                    <path
                      className="st20"
                      d="M464.5 656.9h-3.9c-.5 0-.9-.1-1.1-.5-.2-.5 0-.8.3-1.1 4.1-5 8.2-9.9 12.3-14.9.4-.5.8-.6 1.3-.4.4.2.6.6.4 1.3-1 3.8-2 7.7-3.1 11.5 0 .2-.1.4-.1.6h4c.4 0 .8.1 1 .5s0 .8-.2 1.2l-12.3 15c-.4.5-.8.6-1.3.4-.4-.2-.5-.6-.4-1.2 0-.1 0-.2.1-.3l3-11.4v-.7z"
                    />
                    <path
                      className="st269"
                      d="M779.4 321.2h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1v70.5c0 3.9-3.1 7.1-7.1 7.1zM340.1 733.1h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1V726c0 3.9-3.2 7.1-7.1 7.1zM382.7 891.4h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1v70.5c.1 4-3.1 7.1-7.1 7.1zM708.6 609.3H577.4c-3.9 0-7.1-3.2-7.1-7.1v-59.5c0-3.9 3.2-7.1 7.1-7.1h131.2c3.9 0 7.1 3.2 7.1 7.1v59.5c0 4-3.2 7.1-7.1 7.1zM995.7 321.2h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1v70.5c0 3.9-3.2 7.1-7.1 7.1zM1216.1 384.3h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1v70.5c0 3.9-3.2 7.1-7.1 7.1zM1853 384h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1v70.5c0 3.9-3.1 7.1-7.1 7.1zM1104.1 666.1h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1V659c0 3.9-3.2 7.1-7.1 7.1z"
                    />
                    <g>
                      <text
                        transform="translate(629.229 264.882)"
                        className="st3"
                        fontSize="20.9991px"
                      >
                        {"Quyidalvarzin"}
                      </text>
                    </g>
                    <g>
                      <text
                        transform="translate(668.728 298.61)"
                        className="st5 st6"
                        fontSize="18.6658px"
                      >
                        {`${schema?.kdk1 ? schema?.kdk1 : "0"} m\u00B3/s`}
                      </text>
                    </g>
                    <g>
                      <text
                        transform="translate(843.683 266.367)"
                        className="st3"
                        fontSize="18.7003px"
                      >
                        {"Yuqoridalvarzin"}
                      </text>
                    </g>
                    <g>
                      <text
                        transform="translate(888.292 300.038)"
                        className="st5 st6"
                        fontSize="18.6338px"
                      >
                        {`${schema?.yudk1 ? schema?.yudk1 : "0"} m\u00B3/s`}
                      </text>
                    </g>
                    <text
                      transform="translate(1068.448 327.599)"
                      className="st3 st276"
                    >
                      {"Qizilqishloq"}
                    </text>
                    <text
                      transform="translate(1068.448 359.775)"
                      className="st15 st276"
                    >
                      {"G/u"}
                    </text>
                    <g>
                      <text
                        transform="translate(1142.754 372.55)"
                        className="st5 st6"
                        fontSize="17.5837px"
                      >
                        {`${schema?.qizil1 ? schema?.qizil1 : "0"} m\u00B3/s`}
                      </text>
                    </g>
                    <text
                      transform="translate(952.047 612.722)"
                      className="st3"
                      fontSize="20.8758px"
                    >
                      {"1-reyka"}
                    </text>
                    <g>
                      <text
                        transform="translate(1000.115 649.792)"
                        className="st5 st6"
                        fontSize="18.5562px"
                      >
                        {`${schema?.reka1 ? schema.reka1 : "0"} m\u00B3/s`}
                      </text>
                    </g>
                    <text
                      transform="translate(1701.7 328.843)"
                      className="st3 st281"
                    >
                      {"Oqjar"}
                    </text>
                    <text
                      transform="translate(1701.7 360.547)"
                      className="st15 st281"
                    >
                      {"G/p"}
                    </text>
                    <g>
                      <text
                        transform="translate(1770.819 365.353)"
                        className="st5 st6"
                        fontSize="18.1502px"
                      >
                        {`${schema?.oqjar1 ? schema?.oqjar1 : "0"} m\u00B3/s`}
                      </text>
                    </g>
                    <text
                      transform="translate(189.307 698.712)"
                      className="st3"
                      fontSize="25.496px"
                    >
                      {"Farxod GES"}
                    </text>
                    <path
                      className="st285"
                      d="M531 701.9L420.3 806.1 497.3 688.5"
                    />
                    <text
                      transform="translate(236.35 837.135)"
                      className="st3"
                      fontSize="24.5859px"
                    >
                      {"J.M.M."}
                    </text>
                    <text
                      transform="translate(236.35 860.722)"
                      className="st6 st287"
                    >
                      {"kanali"}
                    </text>
                    <g>
                      <text
                        transform="translate(300.428 874.187)"
                        className="st5 st6 st287"
                      >
                        {`${schema?.jmmk1 ? schema?.jmmk1 : "0"} m\u00B3/s`}
                      </text>
                    </g>
                    <text
                      transform="translate(578.118 561.27)"
                      className="st3"
                      fontSize="17.7694px"
                    >
                      {"5-reyka"}
                    </text>
                    <g>
                      <text
                        transform="translate(600.991 590.352)"
                        className="st5 st6"
                        fontSize="18.1578px"
                      >
                        {`${schema?.reka5 ? schema?.reka5 : "0"} sm`}
                      </text>
                    </g>
                    <path className="st285" d="M628.7 681.6L629.2 800.4" />
                    <path
                      className="st285"
                      d="M650 480.8L457.6 592.9 306.3 596.9"
                    />
                    <path
                      className="st269"
                      d="M302.1 616.2h-153c-3.9 0-7.1-3.2-7.1-7.1v-70.5c0-3.9 3.2-7.1 7.1-7.1h153c3.9 0 7.1 3.2 7.1 7.1v70.5c0 3.9-3.2 7.1-7.1 7.1z"
                    />
                    <text
                      transform="translate(149.796 560.14)"
                      className="st3"
                      fontSize="25.5926px"
                    >
                      {"Do\u2019stlik"}
                    </text>
                    <text
                      transform="translate(149.796 584.692)"
                      className="st6 st292"
                    >
                      {"kanali"}
                    </text>
                    <g>
                      <text
                        transform="translate(200.4 608.709)"
                        className="st5 st6 st292"
                      >
                        {`${
                          schema?.dostlik1 ? schema?.dostlik1 : "0"
                        } m\u00B3/s`}
                      </text>
                    </g>
                    <g>
                      <text
                        transform="rotate(-39.977 1185.13 -714.19)"
                        className="st260"
                        fontSize="21px"
                      >
                        {"Derivatsiya"}
                      </text>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Oqjar;
